const saerchOptions = {
    "Haussperling": {
        "latinName": "Passer domesticus",
        "germanName": "Haussperling"
    },
    "Kohlmeise": {
        "latinName": "Parus major",
        "germanName": "Kohlmeise"
    },
    "Blaumeise": {
        "latinName": "Cyanistes caeruleus",
        "germanName": "Blaumeise"
    },
    "Rotkehlchen": {
        "latinName": "Erithacus rubecula",
        "germanName": "Rotkehlchen"
    },
    "Amsel": {
        "latinName": "Turdus merula",
        "germanName": "Amsel"
    },
    "Eurasisches Eichhörnchen":{
        "latinName": "Sciurus vulgaris",
        "germanName": "Eurasisches Eichhoernchen"
    },
    "Alpenstrandlaeufer": {
        "latinName": "Calidris alpina",
        "germanName": "Alpenstrandlaeufer"
    },
    "Austernfischer": {
        "latinName": "Haematopus ostralegus",
        "germanName": "Austernfischer"
    },
    "Aztekenmoewe": {
        "latinName": "Leucophaeus atricilla",
        "germanName": "Aztekenmoewe"
    },
    "Bachstelze": {
        "latinName": "Motacilla alba",
        "germanName": "Bachstelze"
    },
    "Bahamaente": {
        "latinName": "Anas bahamensis",
        "germanName": "Bahamaente"
    },
    "Bairdstrandlaeufer": {
        "latinName": "Calidris bairdii",
        "germanName": "Bairdstrandlaeufer"
    },
    "Basstoelpel": {
        "latinName": "Morus bassanus",
        "germanName": "Basstoelpel"
    },
    "Baumfalke": {
        "latinName": "Falco subbuteo",
        "germanName": "Baumfalke"
    },
    "Bekassine": {
        "latinName": "Gallinago gallinago",
        "germanName": "Bekassine"
    },
    "Bergente": {
        "latinName": "Aythya marila",
        "germanName": "Bergente"
    },
    "Bergfink": {
        "latinName": "Fringilla montifringilla",
        "germanName": "Bergfink"
    },
    "Bienenfresser": {
        "latinName": "Merops apiaster",
        "germanName": "Bienenfresser"
    },
    "Bindenkreuzschnabel": {
        "latinName": "Loxia leucoptera",
        "germanName": "Bindenkreuzschnabel"
    },
    "Bindenstrandlaeufer": {
        "latinName": "Calidris himantopus",
        "germanName": "Bindenstrandlaeufer"
    },
    "Bindentaucher": {
        "latinName": "Podilymbus podiceps",
        "germanName": "Bindentaucher"
    },
    "Blaessgans": {
        "latinName": "Anser albifrons",
        "germanName": "Blaessgans"
    },
    "Blaesshuhn": {
        "latinName": "Fulica atra",
        "germanName": "Blaesshuhn"
    },
    "Blaukehlchen": {
        "latinName": "Luscinia svecica",
        "germanName": "Blaukehlchen"
    },
    "Blaumerle": {
        "latinName": "Monticola solitarius",
        "germanName": "Blaumerle"
    },
    "Blauracke": {
        "latinName": "Coracias garrulus",
        "germanName": "Blauracke"
    },
    "Bonapartemoewe": {
        "latinName": "Chroicocephalus philadelphia",
        "germanName": "Bonapartemoewe"
    },
    "Brachvogel": {
        "latinName": "Numenius arquata",
        "germanName": "Brachvogel"
    },
    "Brandgans": {
        "latinName": "Tadorna tadorna",
        "germanName": "Brandgans"
    },
    "Brandseeschwalbe": {
        "latinName": "Thalasseus sandvicensis",
        "germanName": "Brandseeschwalbe"
    },
    "Braunkehlchen": {
        "latinName": "Saxicola rubetra",
        "germanName": "Braunkehlchen"
    },
    "Braunkopf-Kuhstaerling": {
        "latinName": "Molothrus ater",
        "germanName": "Braunkopf-Kuhstaerling"
    },
    "Brautente": {
        "latinName": "Aix sponsa",
        "germanName": "Brautente"
    },
    "Brillenente": {
        "latinName": "Melanitta perspicillata",
        "germanName": "Brillenente"
    },
    "Bruchwasserlaeufer": {
        "latinName": "Tringa glareola",
        "germanName": "Bruchwasserlaeufer"
    },
    "Buchfink": {
        "latinName": "Fringilla coelebs",
        "germanName": "Buchfink"
    },
    "Bueffelkopfente": {
        "latinName": "Bucephala albeola",
        "germanName": "Bueffelkopfente"
    },
    "Buntfalke": {
        "latinName": "Falco sparverius",
        "germanName": "Buntfalke"
    },
    "Buntfuss-Sturmschwalbe": {
        "latinName": "Oceanites oceanicus",
        "germanName": "Buntfuss-Sturmschwalbe"
    },
    "Buntspecht": {
        "latinName": "Dendrocopos major",
        "germanName": "Buntspecht"
    },
    "Carolinataube": {
        "latinName": "Zenaida macroura",
        "germanName": "Carolinataube"
    },
    "Dachsammer": {
        "latinName": "Zonotrichia leucophrys",
        "germanName": "Dachsammer"
    },
    "Dorngrasmuecke": {
        "latinName": "Sylvia communis",
        "germanName": "Dorngrasmuecke"
    },
    "Dreifarbenreiher": {
        "latinName": "Egretta tricolor",
        "germanName": "Dreifarbenreiher"
    },
    "Dreizehenmoewe": {
        "latinName": "Rissa tridactyla",
        "germanName": "Dreizehenmoewe"
    },
    "Drosseluferlaeufer": {
        "latinName": "Actitis macularius",
        "germanName": "Drosseluferlaeufer"
    },
    "Dunkelente": {
        "latinName": "Anas rubripes",
        "germanName": "Dunkelente"
    },
    "Eichelhaeher": {
        "latinName": "Garrulus glandarius",
        "germanName": "Eichelhaeher"
    },
    "Eiderente": {
        "latinName": "Somateria mollissima",
        "germanName": "Eiderente"
    },
    "Einsiedler-Musendrossel": {
        "latinName": "Catharus guttatus",
        "germanName": "Einsiedler-Musendrossel"
    },
    "Eisente": {
        "latinName": "Clangula hyemalis",
        "germanName": "Eisente"
    },
    "Eismoewe": {
        "latinName": "Larus hyperboreus",
        "germanName": "Eismoewe"
    },
    "Eissturmvogel": {
        "latinName": "Fulmarus glacialis",
        "germanName": "Eissturmvogel"
    },
    "Eistaucher": {
        "latinName": "Gavia immer",
        "germanName": "Eistaucher"
    },
    "Eisvogel": {
        "latinName": "Alcedo atthis",
        "germanName": "Eisvogel"
    },
    "Elster": {
        "latinName": "Pica pica",
        "germanName": "Elster"
    },
    "Erlenzeisig": {
        "latinName": "Spinus spinus",
        "germanName": "Erlenzeisig"
    },
    "Feldlerche": {
        "latinName": "Alauda arvensis",
        "germanName": "Feldlerche"
    },
    "Feldsperling": {
        "latinName": "Passer montanus",
        "germanName": "Feldsperling"
    },
    "Fichtenkreuzschnabel": {
        "latinName": "Loxia curvirostra",
        "germanName": "Fichtenkreuzschnabel"
    },
    "Fischadler": {
        "latinName": "Pandion haliaetus",
        "germanName": "Fischadler"
    },
    "Flussregenpfeifer": {
        "latinName": "Charadrius dubius",
        "germanName": "Flussregenpfeifer"
    },
    "Flussseeschwalbe": {
        "latinName": "Sterna hirundo",
        "germanName": "Flussseeschwalbe"
    },
    "Flussuferlaeufer": {
        "latinName": "Actitis hypoleucos",
        "germanName": "Flussuferlaeufer"
    },
    "Fuchsammer": {
        "latinName": "Passerella iliaca",
        "germanName": "Fuchsammer"
    },
    "Gaensegeier": {
        "latinName": "Gyps fulvus",
        "germanName": "Gaensegeier"
    },
    "Gaensesaeger": {
        "latinName": "Mergus merganser",
        "germanName": "Gaensesaeger"
    },
    "Gartenrotschwanz": {
        "latinName": "Phoenicurus phoenicurus",
        "germanName": "Gartenrotschwanz"
    },
    "Gebirgsstelze": {
        "latinName": "Motacilla cinerea",
        "germanName": "Gebirgsstelze"
    },
    "Gelbkehlvireo": {
        "latinName": "Vireo flavifrons",
        "germanName": "Gelbkehlvireo"
    },
    "Gelbkopfamazone": {
        "latinName": "Amazona oratrix",
        "germanName": "Gelbkopfamazone"
    },
    "Gelbschenkel": {
        "latinName": "Tringa flavipes",
        "germanName": "Gelbschenkel"
    },
    "Gimpel": {
        "latinName": "Pyrrhula pyrrhula",
        "germanName": "Gimpel"
    },
    "Girlitz": {
        "latinName": "Serinus serinus",
        "germanName": "Girlitz"
    },
    "Goldammer": {
        "latinName": "Emberiza citrinella",
        "germanName": "Goldammer"
    },
    "Graslaeufer": {
        "latinName": "Calidris subruficollis",
        "germanName": "Graslaeufer"
    },
    "Grauammer": {
        "latinName": "Emberiza calandra",
        "germanName": "Grauammer"
    },
    "Graubrust-Strandlaeufer": {
        "latinName": "Calidris melanotos",
        "germanName": "Graubrust-Strandlaeufer"
    },
    "Graugans": {
        "latinName": "Anser anser",
        "germanName": "Graugans"
    },
    "Graukopf-Purpurhuhn": {
        "latinName": "Porphyrio poliocephalus",
        "germanName": "Graukopf-Purpurhuhn"
    },
    "Graureiher": {
        "latinName": "Ardea cinerea",
        "germanName": "Graureiher"
    },
    "Grauschnaepper": {
        "latinName": "Muscicapa striata",
        "germanName": "Grauschnaepper"
    },
    "Grauwangen-Musendrossel": {
        "latinName": "Catharus minimus",
        "germanName": "Grauwangen-Musendrossel"
    },
    "Gruenfink": {
        "latinName": "Chloris chloris",
        "germanName": "Gruenfink"
    },
    "Gruenmantel-Waldsaenger": {
        "latinName": "Setophaga virens",
        "germanName": "Gruenmantel-Waldsaenger"
    },
    "Gruenschenkel": {
        "latinName": "Tringa nebularia",
        "germanName": "Gruenschenkel"
    },
    "Gruenspecht": {
        "latinName": "Picus viridis",
        "germanName": "Gruenspecht"
    },
    "Gryllteiste": {
        "latinName": "Cepphus grylle",
        "germanName": "Gryllteiste"
    },
    "Habicht": {
        "latinName": "Accipiter gentilis",
        "germanName": "Habicht"
    },
    "Hakengimpel": {
        "latinName": "Pinicola enucleator",
        "germanName": "Hakengimpel"
    },
    "Halsbandsittich": {
        "latinName": "Psittacula krameri",
        "germanName": "Halsbandsittich"
    },
    "Haubenlerche": {
        "latinName": "Galerida cristata",
        "germanName": "Haubenlerche"
    },
    "Haubentaucher": {
        "latinName": "Podiceps cristatus",
        "germanName": "Haubentaucher"
    },
    "Hausrotschwanz": {
        "latinName": "Phoenicurus ochruros",
        "germanName": "Hausrotschwanz"
    },
    "Heckenbraunelle": {
        "latinName": "Prunella modularis",
        "germanName": "Heckenbraunelle"
    },
    "Heringsmoewe": {
        "latinName": "Larus fuscus",
        "germanName": "Heringsmoewe"
    },
    "Hirtenmaina": {
        "latinName": "Acridotheres tristis",
        "germanName": "Hirtenmaina"
    },
    "Hoeckerschwan": {
        "latinName": "Cygnus olor",
        "germanName": "Hoeckerschwan"
    },
    "Indigofink": {
        "latinName": "Passerina cyanea",
        "germanName": "Indigofink"
    },
    "Jagdfasan": {
        "latinName": "Phasianus colchicus",
        "germanName": "Jagdfasan"
    },
    "Kampflaeufer": {
        "latinName": "Calidris pugnax",
        "germanName": "Kampflaeufer"
    },
    "Kanadabergente": {
        "latinName": "Aythya affinis",
        "germanName": "Kanadabergente"
    },
    "Kanadagans": {
        "latinName": "Branta canadensis",
        "germanName": "Kanadagans"
    },
    "Kanadakranich": {
        "latinName": "Antigone canadensis",
        "germanName": "Kanadakranich"
    },
    "Kappensaeger": {
        "latinName": "Lophodytes cucullatus",
        "germanName": "Kappensaeger"
    },
    "Kappensturmtaucher": {
        "latinName": "Ardenna gravis",
        "germanName": "Kappensturmtaucher"
    },
    "Katzenspottdrossel": {
        "latinName": "Dumetella carolinensis",
        "germanName": "Katzenspottdrossel"
    },
    "Kernbeisser": {
        "latinName": "Coccothraustes coccothraustes",
        "germanName": "Kernbeisser"
    },
    "Kiebitz": {
        "latinName": "Vanellus vanellus",
        "germanName": "Kiebitz"
    },
    "Kiebitzregenpfeifer": {
        "latinName": "Pluvialis squatarola",
        "germanName": "Kiebitzregenpfeifer"
    },
    "Kleiber": {
        "latinName": "Sitta europaea",
        "germanName": "Kleiber"
    },
    "Knutt": {
        "latinName": "Calidris canutus",
        "germanName": "Knutt"
    },
    "Kolbenente": {
        "latinName": "Netta rufina",
        "germanName": "Kolbenente"
    },
    "Kolkrabe": {
        "latinName": "Corvus corax",
        "germanName": "Kolkrabe"
    },
    "Kormoran": {
        "latinName": "Phalacrocorax carbo",
        "germanName": "Kormoran"
    },
    "Kornweihe": {
        "latinName": "Circus cyaneus",
        "germanName": "Kornweihe"
    },
    "Kragenente": {
        "latinName": "Histrionicus histrionicus",
        "germanName": "Kragenente"
    },
    "Kranich": {
        "latinName": "Grus grus",
        "germanName": "Kranich"
    },
    "Krickente": {
        "latinName": "Anas crecca",
        "germanName": "Krickente"
    },
    "Kubaflamingo": {
        "latinName": "Phoenicopterus ruber",
        "germanName": "Kubaflamingo"
    },
    "Kuckuck": {
        "latinName": "Cuculus canorus",
        "germanName": "Kuckuck"
    },
    "Kuestenreiher": {
        "latinName": "Egretta gularis",
        "germanName": "Kuestenreiher"
    },
    "Kuestenseeschwalbe": {
        "latinName": "Sterna paradisaea",
        "germanName": "Kuestenseeschwalbe"
    },
    "Kuhreiher": {
        "latinName": "Bubulcus ibis",
        "germanName": "Kuhreiher"
    },
    "Lachmoewe": {
        "latinName": "Chroicocephalus ridibundus",
        "germanName": "Lachmoewe"
    },
    "Lachseeschwalbe": {
        "latinName": "Gelochelidon nilotica",
        "germanName": "Lachseeschwalbe"
    },
    "Lazulifink": {
        "latinName": "Passerina amoena",
        "germanName": "Lazulifink"
    },
    "Loeffler": {
        "latinName": "Platalea leucorodia",
        "germanName": "Loeffler"
    },
    "Maeusebussard": {
        "latinName": "Buteo buteo",
        "germanName": "Maeusebussard"
    },
    "Mandarinente": {
        "latinName": "Aix galericulata",
        "germanName": "Mandarinente"
    },
    "Mantelmoewe": {
        "latinName": "Larus marinus",
        "germanName": "Mantelmoewe"
    },
    "Mauersegler": {
        "latinName": "Apus apus",
        "germanName": "Mauersegler"
    },
    "Meerstrandlaeufer": {
        "latinName": "Calidris maritima",
        "germanName": "Meerstrandlaeufer"
    },
    "Mehlschwalbe": {
        "latinName": "Delichon urbicum",
        "germanName": "Mehlschwalbe"
    },
    "Meisenwaldsaenger": {
        "latinName": "Setophaga americana",
        "germanName": "Meisenwaldsaenger"
    },
    "Merlin": {
        "latinName": "Falco columbarius",
        "germanName": "Merlin"
    },
    "Misteldrossel": {
        "latinName": "Turdus viscivorus",
        "germanName": "Misteldrossel"
    },
    "Mittelmeermoewe": {
        "latinName": "Larus michahellis",
        "germanName": "Mittelmeermoewe"
    },
    "Mittelsaeger": {
        "latinName": "Mergus serrator",
        "germanName": "Mittelsaeger"
    },
    "Moenchsgrasmuecke": {
        "latinName": "Sylvia atricapilla",
        "germanName": "Moenchsgrasmuecke"
    },
    "Moorschlammlaeufer": {
        "latinName": "Limnodromus griseus",
        "germanName": "Moorschlammlaeufer"
    },
    "Moschusente": {
        "latinName": "Cairina moschata",
        "germanName": "Moschusente"
    },
    "Nachtreiher": {
        "latinName": "Nycticorax nycticorax",
        "germanName": "Nachtreiher"
    },
    "Nebelkraehe": {
        "latinName": "Corvus cornix",
        "germanName": "Nebelkraehe"
    },
    "Neuntoeter": {
        "latinName": "Lanius collurio",
        "germanName": "Neuntoeter"
    },
    "Nilgans": {
        "latinName": "Alopochen aegyptiaca",
        "germanName": "Nilgans"
    },
    "Noddi": {
        "latinName": "Anous stolidus",
        "germanName": "Noddi"
    },
    "Odinshuehnchen": {
        "latinName": "Phalaropus lobatus",
        "germanName": "Odinshuehnchen"
    },
    "Ohrenlerche": {
        "latinName": "Eremophila alpestris",
        "germanName": "Ohrenlerche"
    },
    "Ohrenscharbe": {
        "latinName": "Phalacrocorax auritus",
        "germanName": "Ohrenscharbe"
    },
    "Ohrentaucher": {
        "latinName": "Podiceps auritus",
        "germanName": "Ohrentaucher"
    },
    "Papageitaucher": {
        "latinName": "Fratercula arctica",
        "germanName": "Papageitaucher"
    },
    "Pazifikpieper": {
        "latinName": "Anthus rubescens",
        "germanName": "Pazifikpieper"
    },
    "Pazifiktrauerente": {
        "latinName": "Melanitta americana",
        "germanName": "Pazifiktrauerente"
    },
    "Pfuhlschnepfe": {
        "latinName": "Limosa lapponica",
        "germanName": "Pfuhlschnepfe"
    },
    "Pharaonenibis": {
        "latinName": "Threskiornis aethiopicus",
        "germanName": "Pharaonenibis"
    },
    "Polarmoewe": {
        "latinName": "Larus glaucoides",
        "germanName": "Polarmoewe"
    },
    "Praerie-Goldregenpfeifer": {
        "latinName": "Pluvialis dominica",
        "germanName": "Praerie-Goldregenpfeifer"
    },
    "Praerielaeufer": {
        "latinName": "Bartramia longicauda",
        "germanName": "Praerielaeufer"
    },
    "Praeriemoewe": {
        "latinName": "Leucophaeus pipixcan",
        "germanName": "Praeriemoewe"
    },
    "Purpurreiher": {
        "latinName": "Ardea purpurea",
        "germanName": "Purpurreiher"
    },
    "Rabenkraehe": {
        "latinName": "Corvus corone",
        "germanName": "Rabenkraehe"
    },
    "Rallenreiher": {
        "latinName": "Ardeola ralloides",
        "germanName": "Rallenreiher"
    },
    "Raubseeschwalbe": {
        "latinName": "Hydroprogne caspia",
        "germanName": "Raubseeschwalbe"
    },
    "Raubwuerger": {
        "latinName": "Lanius excubitor",
        "germanName": "Raubwuerger"
    },
    "Rauchschwalbe": {
        "latinName": "Hirundo rustica",
        "germanName": "Rauchschwalbe"
    },
    "Raufussbussard": {
        "latinName": "Buteo lagopus",
        "germanName": "Raufussbussard"
    },
    "Regenbrachvogel": {
        "latinName": "Numenius phaeopus",
        "germanName": "Regenbrachvogel"
    },
    "Reiherente": {
        "latinName": "Aythya fuligula",
        "germanName": "Reiherente"
    },
    "Riesentafelente": {
        "latinName": "Aythya valisineria",
        "germanName": "Riesentafelente"
    },
    "Ringelgans": {
        "latinName": "Branta bernicla",
        "germanName": "Ringelgans"
    },
    "Ringeltaube": {
        "latinName": "Columba palumbus",
        "germanName": "Ringeltaube"
    },
    "Ringschnabelente": {
        "latinName": "Aythya collaris",
        "germanName": "Ringschnabelente"
    },
    "Ringschnabelmoewe": {
        "latinName": "Larus delawarensis",
        "germanName": "Ringschnabelmoewe"
    },
    "Rohrammer": {
        "latinName": "Emberiza schoeniclus",
        "germanName": "Rohrammer"
    },
    "Rohrweihe": {
        "latinName": "Circus aeruginosus",
        "germanName": "Rohrweihe"
    },
    "Rosaflamingo": {
        "latinName": "Phoenicopterus roseus",
        "germanName": "Rosaflamingo"
    },
    "Rosapelikan": {
        "latinName": "Pelecanus onocrotalus",
        "germanName": "Rosapelikan"
    },
    "Rosenbrust-Kernknacker": {
        "latinName": "Pheucticus ludovicianus",
        "germanName": "Rosenbrust-Kernknacker"
    },
    "Rostgans": {
        "latinName": "Tadorna ferruginea",
        "germanName": "Rostgans"
    },
    "Rotaugenvireo": {
        "latinName": "Vireo olivaceus",
        "germanName": "Rotaugenvireo"
    },
    "Rotgesichtloeffler": {
        "latinName": "Platalea alba",
        "germanName": "Rotgesichtloeffler"
    },
    "Rothalstaucher": {
        "latinName": "Podiceps grisegena",
        "germanName": "Rothalstaucher"
    },
    "Rothuhn": {
        "latinName": "Alectoris rufa",
        "germanName": "Rothuhn"
    },
    "Rotkopfente": {
        "latinName": "Aythya americana",
        "germanName": "Rotkopfente"
    },
    "Rotmilan": {
        "latinName": "Milvus milvus",
        "germanName": "Rotmilan"
    },
    "Rotschenkel": {
        "latinName": "Tringa totanus",
        "germanName": "Rotschenkel"
    },
    "Russseeschwalbe": {
        "latinName": "Onychoprion fuscatus",
        "germanName": "Russseeschwalbe"
    },
    "Saatkraehe": {
        "latinName": "Corvus frugilegus",
        "germanName": "Saatkraehe"
    },
    "Saebelschnaebler": {
        "latinName": "Recurvirostra avosetta",
        "germanName": "Saebelschnaebler"
    },
    "Samtente": {
        "latinName": "Melanitta fusca",
        "germanName": "Samtente"
    },
    "Sanderling": {
        "latinName": "Calidris alba",
        "germanName": "Sanderling"
    },
    "Sandregenpfeifer": {
        "latinName": "Charadrius hiaticula",
        "germanName": "Sandregenpfeifer"
    },
    "Sandstrandlaeufer": {
        "latinName": "Calidris pusilla",
        "germanName": "Sandstrandlaeufer"
    },
    "Schafstelze": {
        "latinName": "Motacilla flava",
        "germanName": "Schafstelze"
    },
    "Schellente": {
        "latinName": "Bucephala clangula",
        "germanName": "Schellente"
    },
    "Schlangenadler": {
        "latinName": "Circaetus gallicus",
        "germanName": "Schlangenadler"
    },
    "Schleiereule": {
        "latinName": "Tyto alba",
        "germanName": "Schleiereule"
    },
    "Schmarotzerraubmoewe": {
        "latinName": "Stercorarius parasiticus",
        "germanName": "Schmarotzerraubmoewe"
    },
    "Schmuckreiher": {
        "latinName": "Egretta thula",
        "germanName": "Schmuckreiher"
    },
    "Schmuckseeschwalbe": {
        "latinName": "Thalasseus elegans",
        "germanName": "Schmuckseeschwalbe"
    },
    "Schneeammer": {
        "latinName": "Plectrophenax nivalis",
        "germanName": "Schneeammer"
    },
    "Schneeeule": {
        "latinName": "Bubo scandiacus",
        "germanName": "Schneeeule"
    },
    "Schwalbenmoewe": {
        "latinName": "Xema sabini",
        "germanName": "Schwalbenmoewe"
    },
    "Schwanzmeise": {
        "latinName": "Aegithalos caudatus",
        "germanName": "Schwanzmeise"
    },
    "Schwarzhalstaucher": {
        "latinName": "Podiceps nigricollis",
        "germanName": "Schwarzhalstaucher"
    },
    "Schwarzkehlchen": {
        "latinName": "Saxicola rubicola",
        "germanName": "Schwarzkehlchen"
    },
    "Schwarzkopf-Ruderente": {
        "latinName": "Oxyura jamaicensis",
        "germanName": "Schwarzkopf-Ruderente"
    },
    "Schwarzmilan": {
        "latinName": "Milvus migrans",
        "germanName": "Schwarzmilan"
    },
    "Schwarzschnabelkuckuck": {
        "latinName": "Coccyzus erythropthalmus",
        "germanName": "Schwarzschnabelkuckuck"
    },
    "Schwarzschwan": {
        "latinName": "Cygnus atratus",
        "germanName": "Schwarzschwan"
    },
    "Seidenreiher": {
        "latinName": "Egretta garzetta",
        "germanName": "Seidenreiher"
    },
    "Seidenschwanz": {
        "latinName": "Bombycilla garrulus",
        "germanName": "Seidenschwanz"
    },
    "Sichelstrandlaeufer": {
        "latinName": "Calidris ferruginea",
        "germanName": "Sichelstrandlaeufer"
    },
    "Sichler": {
        "latinName": "Plegadis falcinellus",
        "germanName": "Sichler"
    },
    "Silbermoewe": {
        "latinName": "Larus argentatus",
        "germanName": "Silbermoewe"
    },
    "Silberreiher": {
        "latinName": "Ardea alba",
        "germanName": "Silberreiher"
    },
    "Singammer": {
        "latinName": "Melospiza melodia",
        "germanName": "Singammer"
    },
    "Singdrossel": {
        "latinName": "Turdus philomelos",
        "germanName": "Singdrossel"
    },
    "Singschwan": {
        "latinName": "Cygnus cygnus",
        "germanName": "Singschwan"
    },
    "Sommergoldhaehnchen": {
        "latinName": "Regulus ignicapilla",
        "germanName": "Sommergoldhaehnchen"
    },
    "Spatelente": {
        "latinName": "Bucephala islandica",
        "germanName": "Spatelente"
    },
    "Spatelraubmoewe": {
        "latinName": "Stercorarius pomarinus",
        "germanName": "Spatelraubmoewe"
    },
    "Sperber": {
        "latinName": "Accipiter nisus",
        "germanName": "Sperber"
    },
    "Sperbereule": {
        "latinName": "Surnia ulula",
        "germanName": "Sperbereule"
    },
    "Spiessente": {
        "latinName": "Anas acuta",
        "germanName": "Spiessente"
    },
    "Spornammer": {
        "latinName": "Calcarius lapponicus",
        "germanName": "Spornammer"
    },
    "Spornkiebitz": {
        "latinName": "Vanellus spinosus",
        "germanName": "Spornkiebitz"
    },
    "Star": {
        "latinName": "Sturnus vulgaris",
        "germanName": "Star"
    },
    "Steinadler": {
        "latinName": "Aquila chrysaetos",
        "germanName": "Steinadler"
    },
    "Steinkauz": {
        "latinName": "Athene noctua",
        "germanName": "Steinkauz"
    },
    "Steinschmaetzer": {
        "latinName": "Oenanthe oenanthe",
        "germanName": "Steinschmaetzer"
    },
    "Steinwaelzer": {
        "latinName": "Arenaria interpres",
        "germanName": "Steinwaelzer"
    },
    "Stelzenlaeufer": {
        "latinName": "Himantopus himantopus",
        "germanName": "Stelzenlaeufer"
    },
    "Sterntaucher": {
        "latinName": "Gavia stellata",
        "germanName": "Sterntaucher"
    },
    "Stieglitz": {
        "latinName": "Carduelis carduelis",
        "germanName": "Stieglitz"
    },
    "Stockente": {
        "latinName": "Anas platyrhynchos",
        "germanName": "Stockente"
    },
    "Sturmmoewe": {
        "latinName": "Larus canus",
        "germanName": "Sturmmoewe"
    },
    "Sumpfohreule": {
        "latinName": "Asio flammeus",
        "germanName": "Sumpfohreule"
    },
    "Tafelente": {
        "latinName": "Aythya ferina",
        "germanName": "Tafelente"
    },
    "Taigabirkenzeisig": {
        "latinName": "Acanthis flammea",
        "germanName": "Taigabirkenzeisig"
    },
    "Tannenmeise": {
        "latinName": "Periparus ater",
        "germanName": "Tannenmeise"
    },
    "Teichhuhn": {
        "latinName": "Gallinula chloropus",
        "germanName": "Teichhuhn"
    },
    "Thorshuehnchen": {
        "latinName": "Phalaropus fulicarius",
        "germanName": "Thorshuehnchen"
    },
    "Tordalk": {
        "latinName": "Alca torda",
        "germanName": "Tordalk"
    },
    "Trauerschnaepper": {
        "latinName": "Ficedula hypoleuca",
        "germanName": "Trauerschnaepper"
    },
    "Trauerseeschwalbe": {
        "latinName": "Chlidonias niger",
        "germanName": "Trauerseeschwalbe"
    },
    "Trottellumme": {
        "latinName": "Uria aalge",
        "germanName": "Trottellumme"
    },
    "Truthuhn": {
        "latinName": "Meleagris gallopavo",
        "germanName": "Truthuhn"
    },
    "Tuerkentaube": {
        "latinName": "Streptopelia decaocto",
        "germanName": "Tuerkentaube"
    },
    "Tundra-Goldregenpfeifer": {
        "latinName": "Pluvialis fulva",
        "germanName": "Tundra-Goldregenpfeifer"
    },
    "Tundraschlammlaeufer": {
        "latinName": "Limnodromus scolopaceus",
        "germanName": "Tundraschlammlaeufer"
    },
    "Turmfalke": {
        "latinName": "Falco tinnunculus",
        "germanName": "Turmfalke"
    },
    "Turteltaube": {
        "latinName": "Streptopelia turtur",
        "germanName": "Turteltaube"
    },
    "Uferschnepfe": {
        "latinName": "Limosa limosa",
        "germanName": "Uferschnepfe"
    },
    "Uferschwalbe": {
        "latinName": "Riparia riparia",
        "germanName": "Uferschwalbe"
    },
    "Virginiauhu": {
        "latinName": "Bubo virginianus",
        "germanName": "Virginiauhu"
    },
    "Wacholderdrossel": {
        "latinName": "Turdus pilaris",
        "germanName": "Wacholderdrossel"
    },
    "Waldohreule": {
        "latinName": "Asio otus",
        "germanName": "Waldohreule"
    },
    "Waldwasserlaeufer": {
        "latinName": "Tringa ochropus",
        "germanName": "Waldwasserlaeufer"
    },
    "Wanderdrossel": {
        "latinName": "Turdus migratorius",
        "germanName": "Wanderdrossel"
    },
    "Wanderfalke": {
        "latinName": "Falco peregrinus",
        "germanName": "Wanderfalke"
    },
    "Wasseramsel": {
        "latinName": "Cinclus cinclus",
        "germanName": "Wasseramsel"
    },
    "Weissbauchtoelpel": {
        "latinName": "Sula leucogaster",
        "germanName": "Weissbauchtoelpel"
    },
    "Weissbuerzel-Strandlaeufer": {
        "latinName": "Calidris fuscicollis",
        "germanName": "Weissbuerzel-Strandlaeufer"
    },
    "Weisskehlammer": {
        "latinName": "Zonotrichia albicollis",
        "germanName": "Weisskehlammer"
    },
    "Weisskopf-Seeadler": {
        "latinName": "Haliaeetus leucocephalus",
        "germanName": "Weisskopf-Seeadler"
    },
    "Weissstorch": {
        "latinName": "Ciconia ciconia",
        "germanName": "Weissstorch"
    },
    "Weisswangengans": {
        "latinName": "Branta leucopsis",
        "germanName": "Weisswangengans"
    },
    "Wiedehopf": {
        "latinName": "Upupa epops",
        "germanName": "Wiedehopf"
    },
    "Wiesenpieper": {
        "latinName": "Anthus pratensis",
        "germanName": "Wiesenpieper"
    },
    "Wiesenstrandlaeufer": {
        "latinName": "Calidris minutilla",
        "germanName": "Wiesenstrandlaeufer"
    },
    "Wilsonwassertreter": {
        "latinName": "Phalaropus tricolor",
        "germanName": "Wilsonwassertreter"
    },
    "Wintergoldhaehnchen": {
        "latinName": "Regulus regulus",
        "germanName": "Wintergoldhaehnchen"
    },
    "Zaunkoenig": {
        "latinName": "Troglodytes troglodytes",
        "germanName": "Zaunkoenig"
    },
    "Zilpzalp": {
        "latinName": "Phylloscopus collybita",
        "germanName": "Zilpzalp"
    },
    "Zwergkanadagans": {
        "latinName": "Branta hutchinsii",
        "germanName": "Zwergkanadagans"
    },
    "Zwergmusendrossel": {
        "latinName": "Catharus ustulatus",
        "germanName": "Zwergmusendrossel"
    },
    "Zwergschwan": {
        "latinName": "Cygnus columbianus",
        "germanName": "Zwergschwan"
    },
    "Zwergtaucher": {
        "latinName": "Tachybaptus ruficollis",
        "germanName": "Zwergtaucher"
    },
    "Acanthis flammea": {
        "latinName": "Acanthis flammea",
        "germanName": "Taigabirkenzeisig"
    },
    "Accipiter cooperii": {
        "latinName": "Accipiter cooperii",
        "germanName": ""
    },
    "Accipiter gentilis": {
        "latinName": "Accipiter gentilis",
        "germanName": "Habicht"
    },
    "Accipiter nisus": {
        "latinName": "Accipiter nisus",
        "germanName": "Sperber"
    },
    "Accipiter striatus": {
        "latinName": "Accipiter striatus",
        "germanName": ""
    },
    "Acridotheres tristis": {
        "latinName": "Acridotheres tristis",
        "germanName": "Hirtenmaina"
    },
    "Actitis hypoleucos": {
        "latinName": "Actitis hypoleucos",
        "germanName": "Flussuferlaeufer"
    },
    "Actitis macularius": {
        "latinName": "Actitis macularius",
        "germanName": "Drosseluferlaeufer"
    },
    "Actophilornis africanus": {
        "latinName": "Actophilornis africanus",
        "germanName": ""
    },
    "Aechmophorus clarkii": {
        "latinName": "Aechmophorus clarkii",
        "germanName": ""
    },
    "Aechmophorus occidentalis": {
        "latinName": "Aechmophorus occidentalis",
        "germanName": ""
    },
    "Aegithalos caudatus": {
        "latinName": "Aegithalos caudatus",
        "germanName": "Schwanzmeise"
    },
    "Aegolius acadicus": {
        "latinName": "Aegolius acadicus",
        "germanName": ""
    },
    "Aeronautes saxatalis": {
        "latinName": "Aeronautes saxatalis",
        "germanName": ""
    },
    "Agelaius phoeniceus": {
        "latinName": "Agelaius phoeniceus",
        "germanName": ""
    },
    "Agelaius tricolor": {
        "latinName": "Agelaius tricolor",
        "germanName": ""
    },
    "Aimophila ruficeps": {
        "latinName": "Aimophila ruficeps",
        "germanName": ""
    },
    "Aix galericulata": {
        "latinName": "Aix galericulata",
        "germanName": "Mandarinente"
    },
    "Aix sponsa": {
        "latinName": "Aix sponsa",
        "germanName": "Brautente"
    },
    "Alauda arvensis": {
        "latinName": "Alauda arvensis",
        "germanName": "Feldlerche"
    },
    "Alca torda": {
        "latinName": "Alca torda",
        "germanName": "Tordalk"
    },
    "Alcedo atthis": {
        "latinName": "Alcedo atthis",
        "germanName": "Eisvogel"
    },
    "Alectoris chukar": {
        "latinName": "Alectoris chukar",
        "germanName": ""
    },
    "Alectoris rufa": {
        "latinName": "Alectoris rufa",
        "germanName": "Rothuhn"
    },
    "Alectura lathami": {
        "latinName": "Alectura lathami",
        "germanName": ""
    },
    "Alisterus scapularis": {
        "latinName": "Alisterus scapularis",
        "germanName": ""
    },
    "Alopochen aegyptiaca": {
        "latinName": "Alopochen aegyptiaca",
        "germanName": "Nilgans"
    },
    "Amaurornis phoenicurus": {
        "latinName": "Amaurornis phoenicurus",
        "germanName": ""
    },
    "Amazilia beryllina": {
        "latinName": "Amazilia beryllina",
        "germanName": ""
    },
    "Amazilia rutila": {
        "latinName": "Amazilia rutila",
        "germanName": ""
    },
    "Amazilia tzacatl": {
        "latinName": "Amazilia tzacatl",
        "germanName": ""
    },
    "Amazilia violiceps": {
        "latinName": "Amazilia violiceps",
        "germanName": ""
    },
    "Amazilia yucatanensis": {
        "latinName": "Amazilia yucatanensis",
        "germanName": ""
    },
    "Amazona albifrons": {
        "latinName": "Amazona albifrons",
        "germanName": ""
    },
    "Amazona autumnalis": {
        "latinName": "Amazona autumnalis",
        "germanName": ""
    },
    "Amazona oratrix": {
        "latinName": "Amazona oratrix",
        "germanName": "Gelbkopfamazone"
    },
    "Amazona viridigenalis": {
        "latinName": "Amazona viridigenalis",
        "germanName": ""
    },
    "Ammodramus maritimus": {
        "latinName": "Ammodramus maritimus",
        "germanName": ""
    },
    "Ammodramus nelsoni": {
        "latinName": "Ammodramus nelsoni",
        "germanName": ""
    },
    "Ammodramus savannarum": {
        "latinName": "Ammodramus savannarum",
        "germanName": ""
    },
    "Amphispiza bilineata": {
        "latinName": "Amphispiza bilineata",
        "germanName": ""
    },
    "Anas acuta": {
        "latinName": "Anas acuta",
        "germanName": "Spiessente"
    },
    "Anas americana": {
        "latinName": "Anas americana",
        "germanName": ""
    },
    "Anas bahamensis": {
        "latinName": "Anas bahamensis",
        "germanName": "Bahamaente"
    },
    "Anas chlorotis": {
        "latinName": "Anas chlorotis",
        "germanName": ""
    },
    "Anas clypeata": {
        "latinName": "Anas clypeata",
        "germanName": ""
    },
    "Anas crecca": {
        "latinName": "Anas crecca",
        "germanName": "Krickente"
    },
    "Anas crecca carolinensis": {
        "latinName": "Anas crecca carolinensis",
        "germanName": ""
    },
    "Anas cyanoptera": {
        "latinName": "Anas cyanoptera",
        "germanName": ""
    },
    "Anas discors": {
        "latinName": "Anas discors",
        "germanName": ""
    },
    "Anas fulvigula": {
        "latinName": "Anas fulvigula",
        "germanName": ""
    },
    "Anas gracilis": {
        "latinName": "Anas gracilis",
        "germanName": ""
    },
    "Anas penelope": {
        "latinName": "Anas penelope",
        "germanName": ""
    },
    "Anas platyrhynchos": {
        "latinName": "Anas platyrhynchos",
        "germanName": "Stockente"
    },
    "Anas platyrhynchos diazi": {
        "latinName": "Anas platyrhynchos diazi",
        "germanName": ""
    },
    "Anas platyrhynchos domesticus": {
        "latinName": "Anas platyrhynchos domesticus",
        "germanName": ""
    },
    "Anas querquedula": {
        "latinName": "Anas querquedula",
        "germanName": ""
    },
    "Anas rubripes": {
        "latinName": "Anas rubripes",
        "germanName": "Dunkelente"
    },
    "Anas strepera": {
        "latinName": "Anas strepera",
        "germanName": ""
    },
    "Anas superciliosa": {
        "latinName": "Anas superciliosa",
        "germanName": ""
    },
    "Anas superciliosa \u00c3\u2014 platyrhynchos": {
        "latinName": "Anas superciliosa \u00c3\u2014 platyrhynchos",
        "germanName": ""
    },
    "Anastomus lamelligerus": {
        "latinName": "Anastomus lamelligerus",
        "germanName": ""
    },
    "Anhinga anhinga": {
        "latinName": "Anhinga anhinga",
        "germanName": ""
    },
    "Anhinga novaehollandiae": {
        "latinName": "Anhinga novaehollandiae",
        "germanName": ""
    },
    "Anhinga rufa": {
        "latinName": "Anhinga rufa",
        "germanName": ""
    },
    "Anous stolidus": {
        "latinName": "Anous stolidus",
        "germanName": "Noddi"
    },
    "Anser albifrons": {
        "latinName": "Anser albifrons",
        "germanName": "Blaessgans"
    },
    "Anser anser": {
        "latinName": "Anser anser",
        "germanName": "Graugans"
    },
    "Anser anser domesticus": {
        "latinName": "Anser anser domesticus",
        "germanName": ""
    },
    "Anser cygnoides domesticus": {
        "latinName": "Anser cygnoides domesticus",
        "germanName": ""
    },
    "Anthornis melanura": {
        "latinName": "Anthornis melanura",
        "germanName": ""
    },
    "Anthus novaeseelandiae novaeseelandiae": {
        "latinName": "Anthus novaeseelandiae novaeseelandiae",
        "germanName": ""
    },
    "Anthus pratensis": {
        "latinName": "Anthus pratensis",
        "germanName": "Wiesenpieper"
    },
    "Anthus rubescens": {
        "latinName": "Anthus rubescens",
        "germanName": "Pazifikpieper"
    },
    "Antigone canadensis": {
        "latinName": "Antigone canadensis",
        "germanName": "Kanadakranich"
    },
    "Aphelocoma californica": {
        "latinName": "Aphelocoma californica",
        "germanName": ""
    },
    "Aphelocoma coerulescens": {
        "latinName": "Aphelocoma coerulescens",
        "germanName": ""
    },
    "Aphelocoma wollweberi": {
        "latinName": "Aphelocoma wollweberi",
        "germanName": ""
    },
    "Aphelocoma woodhouseii": {
        "latinName": "Aphelocoma woodhouseii",
        "germanName": ""
    },
    "Apus apus": {
        "latinName": "Apus apus",
        "germanName": "Mauersegler"
    },
    "Aquila chrysaetos": {
        "latinName": "Aquila chrysaetos",
        "germanName": "Steinadler"
    },
    "Ara macao": {
        "latinName": "Ara macao",
        "germanName": ""
    },
    "Ara militaris": {
        "latinName": "Ara militaris",
        "germanName": ""
    },
    "Aramides cajaneus": {
        "latinName": "Aramides cajaneus",
        "germanName": ""
    },
    "Aramus guarauna": {
        "latinName": "Aramus guarauna",
        "germanName": ""
    },
    "Aratinga nenday": {
        "latinName": "Aratinga nenday",
        "germanName": ""
    },
    "Archilochus alexandri": {
        "latinName": "Archilochus alexandri",
        "germanName": ""
    },
    "Archilochus colubris": {
        "latinName": "Archilochus colubris",
        "germanName": ""
    },
    "Ardea alba": {
        "latinName": "Ardea alba",
        "germanName": "Silberreiher"
    },
    "Ardea alba modesta": {
        "latinName": "Ardea alba modesta",
        "germanName": ""
    },
    "Ardea cinerea": {
        "latinName": "Ardea cinerea",
        "germanName": "Graureiher"
    },
    "Ardea cocoi": {
        "latinName": "Ardea cocoi",
        "germanName": ""
    },
    "Ardea herodias": {
        "latinName": "Ardea herodias",
        "germanName": ""
    },
    "Ardea herodias occidentalis": {
        "latinName": "Ardea herodias occidentalis",
        "germanName": ""
    },
    "Ardea purpurea": {
        "latinName": "Ardea purpurea",
        "germanName": "Purpurreiher"
    },
    "Ardenna creatopus": {
        "latinName": "Ardenna creatopus",
        "germanName": ""
    },
    "Ardenna gravis": {
        "latinName": "Ardenna gravis",
        "germanName": "Kappensturmtaucher"
    },
    "Ardeola ralloides": {
        "latinName": "Ardeola ralloides",
        "germanName": "Rallenreiher"
    },
    "Ardeotis kori": {
        "latinName": "Ardeotis kori",
        "germanName": ""
    },
    "Arenaria interpres": {
        "latinName": "Arenaria interpres",
        "germanName": "Steinwaelzer"
    },
    "Arenaria melanocephala": {
        "latinName": "Arenaria melanocephala",
        "germanName": ""
    },
    "Arremonops rufivirgatus": {
        "latinName": "Arremonops rufivirgatus",
        "germanName": ""
    },
    "Artemisiospiza belli": {
        "latinName": "Artemisiospiza belli",
        "germanName": ""
    },
    "Asio flammeus": {
        "latinName": "Asio flammeus",
        "germanName": "Sumpfohreule"
    },
    "Asio otus": {
        "latinName": "Asio otus",
        "germanName": "Waldohreule"
    },
    "Athene cunicularia": {
        "latinName": "Athene cunicularia",
        "germanName": ""
    },
    "Athene noctua": {
        "latinName": "Athene noctua",
        "germanName": "Steinkauz"
    },
    "Aulacorhynchus prasinus": {
        "latinName": "Aulacorhynchus prasinus",
        "germanName": ""
    },
    "Auriparus flaviceps": {
        "latinName": "Auriparus flaviceps",
        "germanName": ""
    },
    "Aythya affinis": {
        "latinName": "Aythya affinis",
        "germanName": "Kanadabergente"
    },
    "Aythya americana": {
        "latinName": "Aythya americana",
        "germanName": "Rotkopfente"
    },
    "Aythya collaris": {
        "latinName": "Aythya collaris",
        "germanName": "Ringschnabelente"
    },
    "Aythya ferina": {
        "latinName": "Aythya ferina",
        "germanName": "Tafelente"
    },
    "Aythya fuligula": {
        "latinName": "Aythya fuligula",
        "germanName": "Reiherente"
    },
    "Aythya marila": {
        "latinName": "Aythya marila",
        "germanName": "Bergente"
    },
    "Aythya novaeseelandiae": {
        "latinName": "Aythya novaeseelandiae",
        "germanName": ""
    },
    "Aythya valisineria": {
        "latinName": "Aythya valisineria",
        "germanName": "Riesentafelente"
    },
    "Baeolophus atricristatus": {
        "latinName": "Baeolophus atricristatus",
        "germanName": ""
    },
    "Baeolophus bicolor": {
        "latinName": "Baeolophus bicolor",
        "germanName": ""
    },
    "Baeolophus inornatus": {
        "latinName": "Baeolophus inornatus",
        "germanName": ""
    },
    "Balearica regulorum": {
        "latinName": "Balearica regulorum",
        "germanName": ""
    },
    "Bartramia longicauda": {
        "latinName": "Bartramia longicauda",
        "germanName": "Praerielaeufer"
    },
    "Basileuterus rufifrons": {
        "latinName": "Basileuterus rufifrons",
        "germanName": ""
    },
    "Bombycilla cedrorum": {
        "latinName": "Bombycilla cedrorum",
        "germanName": ""
    },
    "Bombycilla garrulus": {
        "latinName": "Bombycilla garrulus",
        "germanName": "Seidenschwanz"
    },
    "Bonasa umbellus": {
        "latinName": "Bonasa umbellus",
        "germanName": ""
    },
    "Bostrychia hagedash": {
        "latinName": "Bostrychia hagedash",
        "germanName": ""
    },
    "Botaurus lentiginosus": {
        "latinName": "Botaurus lentiginosus",
        "germanName": ""
    },
    "Branta bernicla": {
        "latinName": "Branta bernicla",
        "germanName": "Ringelgans"
    },
    "Branta canadensis": {
        "latinName": "Branta canadensis",
        "germanName": "Kanadagans"
    },
    "Branta hutchinsii": {
        "latinName": "Branta hutchinsii",
        "germanName": "Zwergkanadagans"
    },
    "Branta leucopsis": {
        "latinName": "Branta leucopsis",
        "germanName": "Weisswangengans"
    },
    "Branta sandvicensis": {
        "latinName": "Branta sandvicensis",
        "germanName": ""
    },
    "Bubo scandiacus": {
        "latinName": "Bubo scandiacus",
        "germanName": "Schneeeule"
    },
    "Bubo virginianus": {
        "latinName": "Bubo virginianus",
        "germanName": "Virginiauhu"
    },
    "Bubulcus ibis": {
        "latinName": "Bubulcus ibis",
        "germanName": "Kuhreiher"
    },
    "Bucephala albeola": {
        "latinName": "Bucephala albeola",
        "germanName": "Bueffelkopfente"
    },
    "Bucephala clangula": {
        "latinName": "Bucephala clangula",
        "germanName": "Schellente"
    },
    "Bucephala islandica": {
        "latinName": "Bucephala islandica",
        "germanName": "Spatelente"
    },
    "Bucorvus leadbeateri": {
        "latinName": "Bucorvus leadbeateri",
        "germanName": ""
    },
    "Busarellus nigricollis": {
        "latinName": "Busarellus nigricollis",
        "germanName": ""
    },
    "Buteo albonotatus": {
        "latinName": "Buteo albonotatus",
        "germanName": ""
    },
    "Buteo brachyurus": {
        "latinName": "Buteo brachyurus",
        "germanName": ""
    },
    "Buteo buteo": {
        "latinName": "Buteo buteo",
        "germanName": "Maeusebussard"
    },
    "Buteo jamaicensis": {
        "latinName": "Buteo jamaicensis",
        "germanName": ""
    },
    "Buteo lagopus": {
        "latinName": "Buteo lagopus",
        "germanName": "Raufussbussard"
    },
    "Buteo lineatus": {
        "latinName": "Buteo lineatus",
        "germanName": ""
    },
    "Buteo lineatus elegans": {
        "latinName": "Buteo lineatus elegans",
        "germanName": ""
    },
    "Buteo plagiatus": {
        "latinName": "Buteo plagiatus",
        "germanName": ""
    },
    "Buteo platypterus": {
        "latinName": "Buteo platypterus",
        "germanName": ""
    },
    "Buteo regalis": {
        "latinName": "Buteo regalis",
        "germanName": ""
    },
    "Buteo swainsoni": {
        "latinName": "Buteo swainsoni",
        "germanName": ""
    },
    "Buteogallus anthracinus": {
        "latinName": "Buteogallus anthracinus",
        "germanName": ""
    },
    "Butorides striata": {
        "latinName": "Butorides striata",
        "germanName": ""
    },
    "Butorides virescens": {
        "latinName": "Butorides virescens",
        "germanName": ""
    },
    "Cacatua galerita": {
        "latinName": "Cacatua galerita",
        "germanName": ""
    },
    "Cairina moschata": {
        "latinName": "Cairina moschata",
        "germanName": "Moschusente"
    },
    "Cairina moschata domestica": {
        "latinName": "Cairina moschata domestica",
        "germanName": ""
    },
    "Calamospiza melanocorys": {
        "latinName": "Calamospiza melanocorys",
        "germanName": ""
    },
    "Calcarius lapponicus": {
        "latinName": "Calcarius lapponicus",
        "germanName": "Spornammer"
    },
    "Calidris alba": {
        "latinName": "Calidris alba",
        "germanName": "Sanderling"
    },
    "Calidris alpina": {
        "latinName": "Calidris alpina",
        "germanName": "Alpenstrandlaeufer"
    },
    "Calidris bairdii": {
        "latinName": "Calidris bairdii",
        "germanName": "Bairdstrandlaeufer"
    },
    "Calidris canutus": {
        "latinName": "Calidris canutus",
        "germanName": "Knutt"
    },
    "Calidris ferruginea": {
        "latinName": "Calidris ferruginea",
        "germanName": "Sichelstrandlaeufer"
    },
    "Calidris fuscicollis": {
        "latinName": "Calidris fuscicollis",
        "germanName": "Weissbuerzel-Strandlaeufer"
    },
    "Calidris himantopus": {
        "latinName": "Calidris himantopus",
        "germanName": "Bindenstrandlaeufer"
    },
    "Calidris maritima": {
        "latinName": "Calidris maritima",
        "germanName": "Meerstrandlaeufer"
    },
    "Calidris mauri": {
        "latinName": "Calidris mauri",
        "germanName": ""
    },
    "Calidris melanotos": {
        "latinName": "Calidris melanotos",
        "germanName": "Graubrust-Strandlaeufer"
    },
    "Calidris minutilla": {
        "latinName": "Calidris minutilla",
        "germanName": "Wiesenstrandlaeufer"
    },
    "Calidris pugnax": {
        "latinName": "Calidris pugnax",
        "germanName": "Kampflaeufer"
    },
    "Calidris pusilla": {
        "latinName": "Calidris pusilla",
        "germanName": "Sandstrandlaeufer"
    },
    "Calidris subruficollis": {
        "latinName": "Calidris subruficollis",
        "germanName": "Graslaeufer"
    },
    "Calidris virgata": {
        "latinName": "Calidris virgata",
        "germanName": ""
    },
    "Callipepla californica": {
        "latinName": "Callipepla californica",
        "germanName": ""
    },
    "Callipepla gambelii": {
        "latinName": "Callipepla gambelii",
        "germanName": ""
    },
    "Callipepla squamata": {
        "latinName": "Callipepla squamata",
        "germanName": ""
    },
    "Calocitta colliei": {
        "latinName": "Calocitta colliei",
        "germanName": ""
    },
    "Calocitta formosa": {
        "latinName": "Calocitta formosa",
        "germanName": ""
    },
    "Calothorax lucifer": {
        "latinName": "Calothorax lucifer",
        "germanName": ""
    },
    "Calypte anna": {
        "latinName": "Calypte anna",
        "germanName": ""
    },
    "Calypte costae": {
        "latinName": "Calypte costae",
        "germanName": ""
    },
    "Campephilus guatemalensis": {
        "latinName": "Campephilus guatemalensis",
        "germanName": ""
    },
    "Camptostoma imberbe": {
        "latinName": "Camptostoma imberbe",
        "germanName": ""
    },
    "Campylopterus hemileucurus": {
        "latinName": "Campylopterus hemileucurus",
        "germanName": ""
    },
    "Campylorhynchus brunneicapillus": {
        "latinName": "Campylorhynchus brunneicapillus",
        "germanName": ""
    },
    "Campylorhynchus rufinucha": {
        "latinName": "Campylorhynchus rufinucha",
        "germanName": ""
    },
    "Caracara cheriway": {
        "latinName": "Caracara cheriway",
        "germanName": ""
    },
    "Caracara plancus": {
        "latinName": "Caracara plancus",
        "germanName": ""
    },
    "Cardellina canadensis": {
        "latinName": "Cardellina canadensis",
        "germanName": ""
    },
    "Cardellina pusilla": {
        "latinName": "Cardellina pusilla",
        "germanName": ""
    },
    "Cardellina rubra": {
        "latinName": "Cardellina rubra",
        "germanName": ""
    },
    "Cardinalis cardinalis": {
        "latinName": "Cardinalis cardinalis",
        "germanName": ""
    },
    "Cardinalis sinuatus": {
        "latinName": "Cardinalis sinuatus",
        "germanName": ""
    },
    "Carduelis cannabina": {
        "latinName": "Carduelis cannabina",
        "germanName": ""
    },
    "Carduelis carduelis": {
        "latinName": "Carduelis carduelis",
        "germanName": "Stieglitz"
    },
    "Cassiculus melanicterus": {
        "latinName": "Cassiculus melanicterus",
        "germanName": ""
    },
    "Cathartes aura": {
        "latinName": "Cathartes aura",
        "germanName": ""
    },
    "Cathartes burrovianus": {
        "latinName": "Cathartes burrovianus",
        "germanName": ""
    },
    "Catharus fuscescens": {
        "latinName": "Catharus fuscescens",
        "germanName": ""
    },
    "Catharus guttatus": {
        "latinName": "Catharus guttatus",
        "germanName": "Einsiedler-Musendrossel"
    },
    "Catharus minimus": {
        "latinName": "Catharus minimus",
        "germanName": "Grauwangen-Musendrossel"
    },
    "Catharus ustulatus": {
        "latinName": "Catharus ustulatus",
        "germanName": "Zwergmusendrossel"
    },
    "Catherpes mexicanus": {
        "latinName": "Catherpes mexicanus",
        "germanName": ""
    },
    "Cepphus columba": {
        "latinName": "Cepphus columba",
        "germanName": ""
    },
    "Cepphus grylle": {
        "latinName": "Cepphus grylle",
        "germanName": "Gryllteiste"
    },
    "Cerorhinca monocerata": {
        "latinName": "Cerorhinca monocerata",
        "germanName": ""
    },
    "Certhia americana": {
        "latinName": "Certhia americana",
        "germanName": ""
    },
    "Ceryle rudis": {
        "latinName": "Ceryle rudis",
        "germanName": ""
    },
    "Chaetura pelagica": {
        "latinName": "Chaetura pelagica",
        "germanName": ""
    },
    "Chaetura vauxi": {
        "latinName": "Chaetura vauxi",
        "germanName": ""
    },
    "Chamaea fasciata": {
        "latinName": "Chamaea fasciata",
        "germanName": ""
    },
    "Charadrius dubius": {
        "latinName": "Charadrius dubius",
        "germanName": "Flussregenpfeifer"
    },
    "Charadrius hiaticula": {
        "latinName": "Charadrius hiaticula",
        "germanName": "Sandregenpfeifer"
    },
    "Charadrius melodus": {
        "latinName": "Charadrius melodus",
        "germanName": ""
    },
    "Charadrius montanus": {
        "latinName": "Charadrius montanus",
        "germanName": ""
    },
    "Charadrius nivosus": {
        "latinName": "Charadrius nivosus",
        "germanName": ""
    },
    "Charadrius semipalmatus": {
        "latinName": "Charadrius semipalmatus",
        "germanName": ""
    },
    "Charadrius vociferus": {
        "latinName": "Charadrius vociferus",
        "germanName": ""
    },
    "Charadrius wilsonia": {
        "latinName": "Charadrius wilsonia",
        "germanName": ""
    },
    "Chen caerulescens": {
        "latinName": "Chen caerulescens",
        "germanName": ""
    },
    "Chen rossii": {
        "latinName": "Chen rossii",
        "germanName": ""
    },
    "Chenonetta jubata": {
        "latinName": "Chenonetta jubata",
        "germanName": ""
    },
    "Chlidonias niger": {
        "latinName": "Chlidonias niger",
        "germanName": "Trauerseeschwalbe"
    },
    "Chloris chloris": {
        "latinName": "Chloris chloris",
        "germanName": "Gruenfink"
    },
    "Chloroceryle aenea": {
        "latinName": "Chloroceryle aenea",
        "germanName": ""
    },
    "Chloroceryle amazona": {
        "latinName": "Chloroceryle amazona",
        "germanName": ""
    },
    "Chloroceryle americana": {
        "latinName": "Chloroceryle americana",
        "germanName": ""
    },
    "Chlorophanes spiza": {
        "latinName": "Chlorophanes spiza",
        "germanName": ""
    },
    "Chondestes grammacus": {
        "latinName": "Chondestes grammacus",
        "germanName": ""
    },
    "Chordeiles acutipennis": {
        "latinName": "Chordeiles acutipennis",
        "germanName": ""
    },
    "Chordeiles minor": {
        "latinName": "Chordeiles minor",
        "germanName": ""
    },
    "Chroicocephalus novaehollandiae": {
        "latinName": "Chroicocephalus novaehollandiae",
        "germanName": ""
    },
    "Chroicocephalus philadelphia": {
        "latinName": "Chroicocephalus philadelphia",
        "germanName": "Bonapartemoewe"
    },
    "Chroicocephalus ridibundus": {
        "latinName": "Chroicocephalus ridibundus",
        "germanName": "Lachmoewe"
    },
    "Chroicocephalus scopulinus": {
        "latinName": "Chroicocephalus scopulinus",
        "germanName": ""
    },
    "Ciccaba virgata": {
        "latinName": "Ciccaba virgata",
        "germanName": ""
    },
    "Ciconia ciconia": {
        "latinName": "Ciconia ciconia",
        "germanName": "Weissstorch"
    },
    "Cinclus cinclus": {
        "latinName": "Cinclus cinclus",
        "germanName": "Wasseramsel"
    },
    "Cinclus mexicanus": {
        "latinName": "Cinclus mexicanus",
        "germanName": ""
    },
    "Cinnyris jugularis": {
        "latinName": "Cinnyris jugularis",
        "germanName": ""
    },
    "Circaetus gallicus": {
        "latinName": "Circaetus gallicus",
        "germanName": "Schlangenadler"
    },
    "Circus aeruginosus": {
        "latinName": "Circus aeruginosus",
        "germanName": "Rohrweihe"
    },
    "Circus approximans": {
        "latinName": "Circus approximans",
        "germanName": ""
    },
    "Circus cyaneus": {
        "latinName": "Circus cyaneus",
        "germanName": "Kornweihe"
    },
    "Circus cyaneus hudsonius": {
        "latinName": "Circus cyaneus hudsonius",
        "germanName": ""
    },
    "Cistothorus palustris": {
        "latinName": "Cistothorus palustris",
        "germanName": ""
    },
    "Cistothorus platensis": {
        "latinName": "Cistothorus platensis",
        "germanName": ""
    },
    "Clangula hyemalis": {
        "latinName": "Clangula hyemalis",
        "germanName": "Eisente"
    },
    "Coccothraustes coccothraustes": {
        "latinName": "Coccothraustes coccothraustes",
        "germanName": "Kernbeisser"
    },
    "Coccothraustes vespertinus": {
        "latinName": "Coccothraustes vespertinus",
        "germanName": ""
    },
    "Coccyzus americanus": {
        "latinName": "Coccyzus americanus",
        "germanName": ""
    },
    "Coccyzus erythropthalmus": {
        "latinName": "Coccyzus erythropthalmus",
        "germanName": "Schwarzschnabelkuckuck"
    },
    "Coccyzus minor": {
        "latinName": "Coccyzus minor",
        "germanName": ""
    },
    "Cochlearius cochlearius": {
        "latinName": "Cochlearius cochlearius",
        "germanName": ""
    },
    "Coereba flaveola": {
        "latinName": "Coereba flaveola",
        "germanName": ""
    },
    "Colaptes auratus": {
        "latinName": "Colaptes auratus",
        "germanName": ""
    },
    "Colaptes auratus auratus": {
        "latinName": "Colaptes auratus auratus",
        "germanName": ""
    },
    "Colaptes auratus cafer": {
        "latinName": "Colaptes auratus cafer",
        "germanName": ""
    },
    "Colaptes rubiginosus": {
        "latinName": "Colaptes rubiginosus",
        "germanName": ""
    },
    "Colinus virginianus": {
        "latinName": "Colinus virginianus",
        "germanName": ""
    },
    "Columba livia": {
        "latinName": "Columba livia",
        "germanName": ""
    },
    "Columba livia domestica": {
        "latinName": "Columba livia domestica",
        "germanName": ""
    },
    "Columba palumbus": {
        "latinName": "Columba palumbus",
        "germanName": "Ringeltaube"
    },
    "Columbina inca": {
        "latinName": "Columbina inca",
        "germanName": ""
    },
    "Columbina passerina": {
        "latinName": "Columbina passerina",
        "germanName": ""
    },
    "Columbina talpacoti": {
        "latinName": "Columbina talpacoti",
        "germanName": ""
    },
    "Contopus cooperi": {
        "latinName": "Contopus cooperi",
        "germanName": ""
    },
    "Contopus pertinax": {
        "latinName": "Contopus pertinax",
        "germanName": ""
    },
    "Contopus sordidulus": {
        "latinName": "Contopus sordidulus",
        "germanName": ""
    },
    "Contopus virens": {
        "latinName": "Contopus virens",
        "germanName": ""
    },
    "Copsychus malabaricus": {
        "latinName": "Copsychus malabaricus",
        "germanName": ""
    },
    "Copsychus saularis": {
        "latinName": "Copsychus saularis",
        "germanName": ""
    },
    "Coracias benghalensis": {
        "latinName": "Coracias benghalensis",
        "germanName": ""
    },
    "Coracias caudatus": {
        "latinName": "Coracias caudatus",
        "germanName": ""
    },
    "Coracias garrulus": {
        "latinName": "Coracias garrulus",
        "germanName": "Blauracke"
    },
    "Coragyps atratus": {
        "latinName": "Coragyps atratus",
        "germanName": ""
    },
    "Corvus albus": {
        "latinName": "Corvus albus",
        "germanName": ""
    },
    "Corvus brachyrhynchos": {
        "latinName": "Corvus brachyrhynchos",
        "germanName": ""
    },
    "Corvus caurinus": {
        "latinName": "Corvus caurinus",
        "germanName": ""
    },
    "Corvus corax": {
        "latinName": "Corvus corax",
        "germanName": "Kolkrabe"
    },
    "Corvus cornix": {
        "latinName": "Corvus cornix",
        "germanName": "Nebelkraehe"
    },
    "Corvus corone": {
        "latinName": "Corvus corone",
        "germanName": "Rabenkraehe"
    },
    "Corvus frugilegus": {
        "latinName": "Corvus frugilegus",
        "germanName": "Saatkraehe"
    },
    "Corvus monedula": {
        "latinName": "Corvus monedula",
        "germanName": ""
    },
    "Corvus ossifragus": {
        "latinName": "Corvus ossifragus",
        "germanName": ""
    },
    "Corvus splendens": {
        "latinName": "Corvus splendens",
        "germanName": ""
    },
    "Crax rubra": {
        "latinName": "Crax rubra",
        "germanName": ""
    },
    "Crotophaga ani": {
        "latinName": "Crotophaga ani",
        "germanName": ""
    },
    "Crotophaga sulcirostris": {
        "latinName": "Crotophaga sulcirostris",
        "germanName": ""
    },
    "Cuculus canorus": {
        "latinName": "Cuculus canorus",
        "germanName": "Kuckuck"
    },
    "Cyanerpes cyaneus": {
        "latinName": "Cyanerpes cyaneus",
        "germanName": ""
    },
    "Cyanistes caeruleus": {
        "latinName": "Cyanistes caeruleus",
        "germanName": "Blaumeise"
    },
    "Cyanocitta cristata": {
        "latinName": "Cyanocitta cristata",
        "germanName": ""
    },
    "Cyanocitta stelleri": {
        "latinName": "Cyanocitta stelleri",
        "germanName": ""
    },
    "Cyanocompsa parellina": {
        "latinName": "Cyanocompsa parellina",
        "germanName": ""
    },
    "Cyanocorax yncas": {
        "latinName": "Cyanocorax yncas",
        "germanName": ""
    },
    "Cyanocorax yucatanicus": {
        "latinName": "Cyanocorax yucatanicus",
        "germanName": ""
    },
    "Cyanoramphus novaezelandiae": {
        "latinName": "Cyanoramphus novaezelandiae",
        "germanName": ""
    },
    "Cygnus atratus": {
        "latinName": "Cygnus atratus",
        "germanName": "Schwarzschwan"
    },
    "Cygnus buccinator": {
        "latinName": "Cygnus buccinator",
        "germanName": ""
    },
    "Cygnus columbianus": {
        "latinName": "Cygnus columbianus",
        "germanName": "Zwergschwan"
    },
    "Cygnus cygnus": {
        "latinName": "Cygnus cygnus",
        "germanName": "Singschwan"
    },
    "Cygnus olor": {
        "latinName": "Cygnus olor",
        "germanName": "Hoeckerschwan"
    },
    "Cynanthus latirostris": {
        "latinName": "Cynanthus latirostris",
        "germanName": ""
    },
    "Cyrtonyx montezumae": {
        "latinName": "Cyrtonyx montezumae",
        "germanName": ""
    },
    "Dacelo novaeguineae": {
        "latinName": "Dacelo novaeguineae",
        "germanName": ""
    },
    "Delichon urbicum": {
        "latinName": "Delichon urbicum",
        "germanName": "Mehlschwalbe"
    },
    "Dendragapus fuliginosus": {
        "latinName": "Dendragapus fuliginosus",
        "germanName": ""
    },
    "Dendragapus obscurus": {
        "latinName": "Dendragapus obscurus",
        "germanName": ""
    },
    "Dendrocopos major": {
        "latinName": "Dendrocopos major",
        "germanName": "Buntspecht"
    },
    "Dendrocygna autumnalis": {
        "latinName": "Dendrocygna autumnalis",
        "germanName": ""
    },
    "Dendrocygna bicolor": {
        "latinName": "Dendrocygna bicolor",
        "germanName": ""
    },
    "Dendrocygna viduata": {
        "latinName": "Dendrocygna viduata",
        "germanName": ""
    },
    "Dicrurus adsimilis": {
        "latinName": "Dicrurus adsimilis",
        "germanName": ""
    },
    "Diglossa baritula": {
        "latinName": "Diglossa baritula",
        "germanName": ""
    },
    "Dives dives": {
        "latinName": "Dives dives",
        "germanName": ""
    },
    "Dolichonyx oryzivorus": {
        "latinName": "Dolichonyx oryzivorus",
        "germanName": ""
    },
    "Dryocopus lineatus": {
        "latinName": "Dryocopus lineatus",
        "germanName": ""
    },
    "Dryocopus pileatus": {
        "latinName": "Dryocopus pileatus",
        "germanName": ""
    },
    "Dumetella carolinensis": {
        "latinName": "Dumetella carolinensis",
        "germanName": "Katzenspottdrossel"
    },
    "Egretta caerulea": {
        "latinName": "Egretta caerulea",
        "germanName": ""
    },
    "Egretta garzetta": {
        "latinName": "Egretta garzetta",
        "germanName": "Seidenreiher"
    },
    "Egretta gularis": {
        "latinName": "Egretta gularis",
        "germanName": "Kuestenreiher"
    },
    "Egretta novaehollandiae": {
        "latinName": "Egretta novaehollandiae",
        "germanName": ""
    },
    "Egretta rufescens": {
        "latinName": "Egretta rufescens",
        "germanName": ""
    },
    "Egretta sacra": {
        "latinName": "Egretta sacra",
        "germanName": ""
    },
    "Egretta thula": {
        "latinName": "Egretta thula",
        "germanName": "Schmuckreiher"
    },
    "Egretta tricolor": {
        "latinName": "Egretta tricolor",
        "germanName": "Dreifarbenreiher"
    },
    "Elanoides forficatus": {
        "latinName": "Elanoides forficatus",
        "germanName": ""
    },
    "Elanus leucurus": {
        "latinName": "Elanus leucurus",
        "germanName": ""
    },
    "Emberiza calandra": {
        "latinName": "Emberiza calandra",
        "germanName": "Grauammer"
    },
    "Emberiza citrinella": {
        "latinName": "Emberiza citrinella",
        "germanName": "Goldammer"
    },
    "Emberiza schoeniclus": {
        "latinName": "Emberiza schoeniclus",
        "germanName": "Rohrammer"
    },
    "Empidonax difficilis": {
        "latinName": "Empidonax difficilis",
        "germanName": ""
    },
    "Empidonax fulvifrons": {
        "latinName": "Empidonax fulvifrons",
        "germanName": ""
    },
    "Empidonax hammondii": {
        "latinName": "Empidonax hammondii",
        "germanName": ""
    },
    "Empidonax minimus": {
        "latinName": "Empidonax minimus",
        "germanName": ""
    },
    "Empidonax occidentalis": {
        "latinName": "Empidonax occidentalis",
        "germanName": ""
    },
    "Empidonax traillii": {
        "latinName": "Empidonax traillii",
        "germanName": ""
    },
    "Eolophus roseicapilla": {
        "latinName": "Eolophus roseicapilla",
        "germanName": ""
    },
    "Ephippiorhynchus senegalensis": {
        "latinName": "Ephippiorhynchus senegalensis",
        "germanName": ""
    },
    "Eremophila alpestris": {
        "latinName": "Eremophila alpestris",
        "germanName": "Ohrenlerche"
    },
    "Erithacus rubecula": {
        "latinName": "Erithacus rubecula",
        "germanName": "Rotkehlchen"
    },
    "Estrilda astrild": {
        "latinName": "Estrilda astrild",
        "germanName": ""
    },
    "Eudocimus albus": {
        "latinName": "Eudocimus albus",
        "germanName": ""
    },
    "Eudyptula minor": {
        "latinName": "Eudyptula minor",
        "germanName": ""
    },
    "Eugenes fulgens": {
        "latinName": "Eugenes fulgens",
        "germanName": ""
    },
    "Eumomota superciliosa": {
        "latinName": "Eumomota superciliosa",
        "germanName": ""
    },
    "Euphagus carolinus": {
        "latinName": "Euphagus carolinus",
        "germanName": ""
    },
    "Euphagus cyanocephalus": {
        "latinName": "Euphagus cyanocephalus",
        "germanName": ""
    },
    "Euphonia affinis": {
        "latinName": "Euphonia affinis",
        "germanName": ""
    },
    "Euphonia elegantissima": {
        "latinName": "Euphonia elegantissima",
        "germanName": ""
    },
    "Euphonia hirundinacea": {
        "latinName": "Euphonia hirundinacea",
        "germanName": ""
    },
    "Eupsittula canicularis": {
        "latinName": "Eupsittula canicularis",
        "germanName": ""
    },
    "Eupsittula nana": {
        "latinName": "Eupsittula nana",
        "germanName": ""
    },
    "Falcipennis canadensis": {
        "latinName": "Falcipennis canadensis",
        "germanName": ""
    },
    "Falco columbarius": {
        "latinName": "Falco columbarius",
        "germanName": "Merlin"
    },
    "Falco femoralis": {
        "latinName": "Falco femoralis",
        "germanName": ""
    },
    "Falco mexicanus": {
        "latinName": "Falco mexicanus",
        "germanName": ""
    },
    "Falco novaeseelandiae": {
        "latinName": "Falco novaeseelandiae",
        "germanName": ""
    },
    "Falco peregrinus": {
        "latinName": "Falco peregrinus",
        "germanName": "Wanderfalke"
    },
    "Falco rufigularis": {
        "latinName": "Falco rufigularis",
        "germanName": ""
    },
    "Falco sparverius": {
        "latinName": "Falco sparverius",
        "germanName": "Buntfalke"
    },
    "Falco subbuteo": {
        "latinName": "Falco subbuteo",
        "germanName": "Baumfalke"
    },
    "Falco tinnunculus": {
        "latinName": "Falco tinnunculus",
        "germanName": "Turmfalke"
    },
    "Ficedula hypoleuca": {
        "latinName": "Ficedula hypoleuca",
        "germanName": "Trauerschnaepper"
    },
    "Florisuga mellivora": {
        "latinName": "Florisuga mellivora",
        "germanName": ""
    },
    "Francolinus pondicerianus": {
        "latinName": "Francolinus pondicerianus",
        "germanName": ""
    },
    "Fratercula arctica": {
        "latinName": "Fratercula arctica",
        "germanName": "Papageitaucher"
    },
    "Fratercula cirrhata": {
        "latinName": "Fratercula cirrhata",
        "germanName": ""
    },
    "Fregata magnificens": {
        "latinName": "Fregata magnificens",
        "germanName": ""
    },
    "Fregata minor": {
        "latinName": "Fregata minor",
        "germanName": ""
    },
    "Fringilla coelebs": {
        "latinName": "Fringilla coelebs",
        "germanName": "Buchfink"
    },
    "Fringilla montifringilla": {
        "latinName": "Fringilla montifringilla",
        "germanName": "Bergfink"
    },
    "Fulica americana": {
        "latinName": "Fulica americana",
        "germanName": ""
    },
    "Fulica atra": {
        "latinName": "Fulica atra",
        "germanName": "Blaesshuhn"
    },
    "Fulmarus glacialis": {
        "latinName": "Fulmarus glacialis",
        "germanName": "Eissturmvogel"
    },
    "Galbula ruficauda": {
        "latinName": "Galbula ruficauda",
        "germanName": ""
    },
    "Galerida cristata": {
        "latinName": "Galerida cristata",
        "germanName": "Haubenlerche"
    },
    "Gallinago delicata": {
        "latinName": "Gallinago delicata",
        "germanName": ""
    },
    "Gallinago gallinago": {
        "latinName": "Gallinago gallinago",
        "germanName": "Bekassine"
    },
    "Gallinula chloropus": {
        "latinName": "Gallinula chloropus",
        "germanName": "Teichhuhn"
    },
    "Gallinula galeata": {
        "latinName": "Gallinula galeata",
        "germanName": ""
    },
    "Gallinula tenebrosa": {
        "latinName": "Gallinula tenebrosa",
        "germanName": ""
    },
    "Gallirallus australis": {
        "latinName": "Gallirallus australis",
        "germanName": ""
    },
    "Gallus gallus": {
        "latinName": "Gallus gallus",
        "germanName": ""
    },
    "Gallus gallus domesticus": {
        "latinName": "Gallus gallus domesticus",
        "germanName": ""
    },
    "Garrulus glandarius": {
        "latinName": "Garrulus glandarius",
        "germanName": "Eichelhaeher"
    },
    "Gavia immer": {
        "latinName": "Gavia immer",
        "germanName": "Eistaucher"
    },
    "Gavia pacifica": {
        "latinName": "Gavia pacifica",
        "germanName": ""
    },
    "Gavia stellata": {
        "latinName": "Gavia stellata",
        "germanName": "Sterntaucher"
    },
    "Gelochelidon nilotica": {
        "latinName": "Gelochelidon nilotica",
        "germanName": "Lachseeschwalbe"
    },
    "Geococcyx californianus": {
        "latinName": "Geococcyx californianus",
        "germanName": ""
    },
    "Geococcyx velox": {
        "latinName": "Geococcyx velox",
        "germanName": ""
    },
    "Geopelia striata": {
        "latinName": "Geopelia striata",
        "germanName": ""
    },
    "Geothlypis formosa": {
        "latinName": "Geothlypis formosa",
        "germanName": ""
    },
    "Geothlypis philadelphia": {
        "latinName": "Geothlypis philadelphia",
        "germanName": ""
    },
    "Geothlypis tolmiei": {
        "latinName": "Geothlypis tolmiei",
        "germanName": ""
    },
    "Geothlypis trichas": {
        "latinName": "Geothlypis trichas",
        "germanName": ""
    },
    "Geranoaetus albicaudatus": {
        "latinName": "Geranoaetus albicaudatus",
        "germanName": ""
    },
    "Gerygone igata": {
        "latinName": "Gerygone igata",
        "germanName": ""
    },
    "Glaucidium brasilianum": {
        "latinName": "Glaucidium brasilianum",
        "germanName": ""
    },
    "Glaucidium gnoma": {
        "latinName": "Glaucidium gnoma",
        "germanName": ""
    },
    "Grallina cyanoleuca": {
        "latinName": "Grallina cyanoleuca",
        "germanName": ""
    },
    "Grus americana": {
        "latinName": "Grus americana",
        "germanName": ""
    },
    "Grus grus": {
        "latinName": "Grus grus",
        "germanName": "Kranich"
    },
    "Gygis alba": {
        "latinName": "Gygis alba",
        "germanName": ""
    },
    "Gymnogyps californianus": {
        "latinName": "Gymnogyps californianus",
        "germanName": ""
    },
    "Gymnorhina tibicen": {
        "latinName": "Gymnorhina tibicen",
        "germanName": ""
    },
    "Gyps africanus": {
        "latinName": "Gyps africanus",
        "germanName": ""
    },
    "Gyps fulvus": {
        "latinName": "Gyps fulvus",
        "germanName": "Gaensegeier"
    },
    "Haematopus bachmani": {
        "latinName": "Haematopus bachmani",
        "germanName": ""
    },
    "Haematopus finschi": {
        "latinName": "Haematopus finschi",
        "germanName": ""
    },
    "Haematopus ostralegus": {
        "latinName": "Haematopus ostralegus",
        "germanName": "Austernfischer"
    },
    "Haematopus palliatus": {
        "latinName": "Haematopus palliatus",
        "germanName": ""
    },
    "Haematopus unicolor": {
        "latinName": "Haematopus unicolor",
        "germanName": ""
    },
    "Haemorhous cassinii": {
        "latinName": "Haemorhous cassinii",
        "germanName": ""
    },
    "Haemorhous mexicanus": {
        "latinName": "Haemorhous mexicanus",
        "germanName": ""
    },
    "Haemorhous purpureus": {
        "latinName": "Haemorhous purpureus",
        "germanName": ""
    },
    "Halcyon smyrnensis": {
        "latinName": "Halcyon smyrnensis",
        "germanName": ""
    },
    "Haliaeetus leucocephalus": {
        "latinName": "Haliaeetus leucocephalus",
        "germanName": "Weisskopf-Seeadler"
    },
    "Haliaeetus leucogaster": {
        "latinName": "Haliaeetus leucogaster",
        "germanName": ""
    },
    "Haliaeetus vocifer": {
        "latinName": "Haliaeetus vocifer",
        "germanName": ""
    },
    "Haliastur indus": {
        "latinName": "Haliastur indus",
        "germanName": ""
    },
    "Helmitheros vermivorum": {
        "latinName": "Helmitheros vermivorum",
        "germanName": ""
    },
    "Hemiphaga novaeseelandiae": {
        "latinName": "Hemiphaga novaeseelandiae",
        "germanName": ""
    },
    "Herpetotheres cachinnans": {
        "latinName": "Herpetotheres cachinnans",
        "germanName": ""
    },
    "Himantopus himantopus": {
        "latinName": "Himantopus himantopus",
        "germanName": "Stelzenlaeufer"
    },
    "Himantopus leucocephalus": {
        "latinName": "Himantopus leucocephalus",
        "germanName": ""
    },
    "Himantopus mexicanus": {
        "latinName": "Himantopus mexicanus",
        "germanName": ""
    },
    "Hirundo neoxena": {
        "latinName": "Hirundo neoxena",
        "germanName": ""
    },
    "Hirundo rustica": {
        "latinName": "Hirundo rustica",
        "germanName": "Rauchschwalbe"
    },
    "Hirundo rustica erythrogaster": {
        "latinName": "Hirundo rustica erythrogaster",
        "germanName": ""
    },
    "Histrionicus histrionicus": {
        "latinName": "Histrionicus histrionicus",
        "germanName": "Kragenente"
    },
    "Hydroprogne caspia": {
        "latinName": "Hydroprogne caspia",
        "germanName": "Raubseeschwalbe"
    },
    "Hylocharis leucotis": {
        "latinName": "Hylocharis leucotis",
        "germanName": ""
    },
    "Hylocichla mustelina": {
        "latinName": "Hylocichla mustelina",
        "germanName": ""
    },
    "Hymenolaimus malacorhynchos": {
        "latinName": "Hymenolaimus malacorhynchos",
        "germanName": ""
    },
    "Icteria virens": {
        "latinName": "Icteria virens",
        "germanName": ""
    },
    "Icterus abeillei": {
        "latinName": "Icterus abeillei",
        "germanName": ""
    },
    "Icterus bullockii": {
        "latinName": "Icterus bullockii",
        "germanName": ""
    },
    "Icterus cucullatus": {
        "latinName": "Icterus cucullatus",
        "germanName": ""
    },
    "Icterus galbula": {
        "latinName": "Icterus galbula",
        "germanName": ""
    },
    "Icterus graduacauda": {
        "latinName": "Icterus graduacauda",
        "germanName": ""
    },
    "Icterus gularis": {
        "latinName": "Icterus gularis",
        "germanName": ""
    },
    "Icterus parisorum": {
        "latinName": "Icterus parisorum",
        "germanName": ""
    },
    "Icterus pustulatus": {
        "latinName": "Icterus pustulatus",
        "germanName": ""
    },
    "Icterus spurius": {
        "latinName": "Icterus spurius",
        "germanName": ""
    },
    "Icterus wagleri": {
        "latinName": "Icterus wagleri",
        "germanName": ""
    },
    "Ictinia mississippiensis": {
        "latinName": "Ictinia mississippiensis",
        "germanName": ""
    },
    "Ixobrychus exilis": {
        "latinName": "Ixobrychus exilis",
        "germanName": ""
    },
    "Ixoreus naevius": {
        "latinName": "Ixoreus naevius",
        "germanName": ""
    },
    "Jabiru mycteria": {
        "latinName": "Jabiru mycteria",
        "germanName": ""
    },
    "Jacana jacana": {
        "latinName": "Jacana jacana",
        "germanName": ""
    },
    "Jacana spinosa": {
        "latinName": "Jacana spinosa",
        "germanName": ""
    },
    "Junco hyemalis": {
        "latinName": "Junco hyemalis",
        "germanName": ""
    },
    "Junco hyemalis caniceps": {
        "latinName": "Junco hyemalis caniceps",
        "germanName": ""
    },
    "Junco hyemalis hyemalis": {
        "latinName": "Junco hyemalis hyemalis",
        "germanName": ""
    },
    "Junco hyemalis oreganus": {
        "latinName": "Junco hyemalis oreganus",
        "germanName": ""
    },
    "Junco phaeonotus": {
        "latinName": "Junco phaeonotus",
        "germanName": ""
    },
    "Lagopus lagopus": {
        "latinName": "Lagopus lagopus",
        "germanName": ""
    },
    "Lampornis clemenciae": {
        "latinName": "Lampornis clemenciae",
        "germanName": ""
    },
    "Lanius collurio": {
        "latinName": "Lanius collurio",
        "germanName": "Neuntoeter"
    },
    "Lanius excubitor": {
        "latinName": "Lanius excubitor",
        "germanName": "Raubwuerger"
    },
    "Lanius ludovicianus": {
        "latinName": "Lanius ludovicianus",
        "germanName": ""
    },
    "Larus argentatus": {
        "latinName": "Larus argentatus",
        "germanName": "Silbermoewe"
    },
    "Larus argentatus smithsonianus": {
        "latinName": "Larus argentatus smithsonianus",
        "germanName": ""
    },
    "Larus californicus": {
        "latinName": "Larus californicus",
        "germanName": ""
    },
    "Larus canus": {
        "latinName": "Larus canus",
        "germanName": "Sturmmoewe"
    },
    "Larus delawarensis": {
        "latinName": "Larus delawarensis",
        "germanName": "Ringschnabelmoewe"
    },
    "Larus dominicanus": {
        "latinName": "Larus dominicanus",
        "germanName": ""
    },
    "Larus dominicanus dominicanus": {
        "latinName": "Larus dominicanus dominicanus",
        "germanName": ""
    },
    "Larus fuscus": {
        "latinName": "Larus fuscus",
        "germanName": "Heringsmoewe"
    },
    "Larus glaucescens": {
        "latinName": "Larus glaucescens",
        "germanName": ""
    },
    "Larus glaucescens \u00c3\u2014 occidentalis": {
        "latinName": "Larus glaucescens \u00c3\u2014 occidentalis",
        "germanName": ""
    },
    "Larus glaucoides": {
        "latinName": "Larus glaucoides",
        "germanName": "Polarmoewe"
    },
    "Larus heermanni": {
        "latinName": "Larus heermanni",
        "germanName": ""
    },
    "Larus hyperboreus": {
        "latinName": "Larus hyperboreus",
        "germanName": "Eismoewe"
    },
    "Larus livens": {
        "latinName": "Larus livens",
        "germanName": ""
    },
    "Larus marinus": {
        "latinName": "Larus marinus",
        "germanName": "Mantelmoewe"
    },
    "Larus michahellis": {
        "latinName": "Larus michahellis",
        "germanName": "Mittelmeermoewe"
    },
    "Larus occidentalis": {
        "latinName": "Larus occidentalis",
        "germanName": ""
    },
    "Larus thayeri": {
        "latinName": "Larus thayeri",
        "germanName": ""
    },
    "Leptoptilos crumenifer": {
        "latinName": "Leptoptilos crumenifer",
        "germanName": ""
    },
    "Leptotila verreauxi": {
        "latinName": "Leptotila verreauxi",
        "germanName": ""
    },
    "Leucophaeus atricilla": {
        "latinName": "Leucophaeus atricilla",
        "germanName": "Aztekenmoewe"
    },
    "Leucophaeus pipixcan": {
        "latinName": "Leucophaeus pipixcan",
        "germanName": "Praeriemoewe"
    },
    "Limnodromus griseus": {
        "latinName": "Limnodromus griseus",
        "germanName": "Moorschlammlaeufer"
    },
    "Limnodromus scolopaceus": {
        "latinName": "Limnodromus scolopaceus",
        "germanName": "Tundraschlammlaeufer"
    },
    "Limosa fedoa": {
        "latinName": "Limosa fedoa",
        "germanName": ""
    },
    "Limosa haemastica": {
        "latinName": "Limosa haemastica",
        "germanName": ""
    },
    "Limosa lapponica": {
        "latinName": "Limosa lapponica",
        "germanName": "Pfuhlschnepfe"
    },
    "Limosa limosa": {
        "latinName": "Limosa limosa",
        "germanName": "Uferschnepfe"
    },
    "Lonchura oryzivora": {
        "latinName": "Lonchura oryzivora",
        "germanName": ""
    },
    "Lonchura punctulata": {
        "latinName": "Lonchura punctulata",
        "germanName": ""
    },
    "Lophodytes cucullatus": {
        "latinName": "Lophodytes cucullatus",
        "germanName": "Kappensaeger"
    },
    "Lophura leucomelanos": {
        "latinName": "Lophura leucomelanos",
        "germanName": ""
    },
    "Loxia curvirostra": {
        "latinName": "Loxia curvirostra",
        "germanName": "Fichtenkreuzschnabel"
    },
    "Loxia leucoptera": {
        "latinName": "Loxia leucoptera",
        "germanName": "Bindenkreuzschnabel"
    },
    "Luscinia svecica": {
        "latinName": "Luscinia svecica",
        "germanName": "Blaukehlchen"
    },
    "Malurus cyaneus": {
        "latinName": "Malurus cyaneus",
        "germanName": ""
    },
    "Manorina melanocephala": {
        "latinName": "Manorina melanocephala",
        "germanName": ""
    },
    "Megaceryle alcyon": {
        "latinName": "Megaceryle alcyon",
        "germanName": ""
    },
    "Megaceryle torquata": {
        "latinName": "Megaceryle torquata",
        "germanName": ""
    },
    "Megadyptes antipodes": {
        "latinName": "Megadyptes antipodes",
        "germanName": ""
    },
    "Megarynchus pitangua": {
        "latinName": "Megarynchus pitangua",
        "germanName": ""
    },
    "Megascops asio": {
        "latinName": "Megascops asio",
        "germanName": ""
    },
    "Megascops kennicottii": {
        "latinName": "Megascops kennicottii",
        "germanName": ""
    },
    "Melanerpes aurifrons": {
        "latinName": "Melanerpes aurifrons",
        "germanName": ""
    },
    "Melanerpes carolinus": {
        "latinName": "Melanerpes carolinus",
        "germanName": ""
    },
    "Melanerpes chrysogenys": {
        "latinName": "Melanerpes chrysogenys",
        "germanName": ""
    },
    "Melanerpes erythrocephalus": {
        "latinName": "Melanerpes erythrocephalus",
        "germanName": ""
    },
    "Melanerpes formicivorus": {
        "latinName": "Melanerpes formicivorus",
        "germanName": ""
    },
    "Melanerpes lewis": {
        "latinName": "Melanerpes lewis",
        "germanName": ""
    },
    "Melanerpes pucherani": {
        "latinName": "Melanerpes pucherani",
        "germanName": ""
    },
    "Melanerpes uropygialis": {
        "latinName": "Melanerpes uropygialis",
        "germanName": ""
    },
    "Melanitta americana": {
        "latinName": "Melanitta americana",
        "germanName": "Pazifiktrauerente"
    },
    "Melanitta fusca": {
        "latinName": "Melanitta fusca",
        "germanName": "Samtente"
    },
    "Melanitta perspicillata": {
        "latinName": "Melanitta perspicillata",
        "germanName": "Brillenente"
    },
    "Melanotis caerulescens": {
        "latinName": "Melanotis caerulescens",
        "germanName": ""
    },
    "Meleagris gallopavo": {
        "latinName": "Meleagris gallopavo",
        "germanName": "Truthuhn"
    },
    "Meleagris gallopavo intermedia": {
        "latinName": "Meleagris gallopavo intermedia",
        "germanName": ""
    },
    "Meleagris gallopavo silvestris": {
        "latinName": "Meleagris gallopavo silvestris",
        "germanName": ""
    },
    "Meleagris ocellata": {
        "latinName": "Meleagris ocellata",
        "germanName": ""
    },
    "Melopsittacus undulatus": {
        "latinName": "Melopsittacus undulatus",
        "germanName": ""
    },
    "Melospiza georgiana": {
        "latinName": "Melospiza georgiana",
        "germanName": ""
    },
    "Melospiza lincolnii": {
        "latinName": "Melospiza lincolnii",
        "germanName": ""
    },
    "Melospiza melodia": {
        "latinName": "Melospiza melodia",
        "germanName": "Singammer"
    },
    "Melozone aberti": {
        "latinName": "Melozone aberti",
        "germanName": ""
    },
    "Melozone crissalis": {
        "latinName": "Melozone crissalis",
        "germanName": ""
    },
    "Melozone fusca": {
        "latinName": "Melozone fusca",
        "germanName": ""
    },
    "Mergus merganser": {
        "latinName": "Mergus merganser",
        "germanName": "Gaensesaeger"
    },
    "Mergus serrator": {
        "latinName": "Mergus serrator",
        "germanName": "Mittelsaeger"
    },
    "Merops apiaster": {
        "latinName": "Merops apiaster",
        "germanName": "Bienenfresser"
    },
    "Merops orientalis": {
        "latinName": "Merops orientalis",
        "germanName": ""
    },
    "Merops pusillus": {
        "latinName": "Merops pusillus",
        "germanName": ""
    },
    "Microcarbo melanoleucos": {
        "latinName": "Microcarbo melanoleucos",
        "germanName": ""
    },
    "Microcarbo melanoleucos brevirostris": {
        "latinName": "Microcarbo melanoleucos brevirostris",
        "germanName": ""
    },
    "Milvago chimachima": {
        "latinName": "Milvago chimachima",
        "germanName": ""
    },
    "Milvus migrans": {
        "latinName": "Milvus migrans",
        "germanName": "Schwarzmilan"
    },
    "Milvus milvus": {
        "latinName": "Milvus milvus",
        "germanName": "Rotmilan"
    },
    "Mimus gilvus": {
        "latinName": "Mimus gilvus",
        "germanName": ""
    },
    "Mimus polyglottos": {
        "latinName": "Mimus polyglottos",
        "germanName": ""
    },
    "Mitrephanes phaeocercus": {
        "latinName": "Mitrephanes phaeocercus",
        "germanName": ""
    },
    "Mniotilta varia": {
        "latinName": "Mniotilta varia",
        "germanName": ""
    },
    "Molothrus aeneus": {
        "latinName": "Molothrus aeneus",
        "germanName": ""
    },
    "Molothrus ater": {
        "latinName": "Molothrus ater",
        "germanName": "Braunkopf-Kuhstaerling"
    },
    "Momotus coeruliceps": {
        "latinName": "Momotus coeruliceps",
        "germanName": ""
    },
    "Momotus lessonii": {
        "latinName": "Momotus lessonii",
        "germanName": ""
    },
    "Momotus mexicanus": {
        "latinName": "Momotus mexicanus",
        "germanName": ""
    },
    "Monticola solitarius": {
        "latinName": "Monticola solitarius",
        "germanName": "Blaumerle"
    },
    "Morus bassanus": {
        "latinName": "Morus bassanus",
        "germanName": "Basstoelpel"
    },
    "Morus serrator": {
        "latinName": "Morus serrator",
        "germanName": ""
    },
    "Motacilla aguimp": {
        "latinName": "Motacilla aguimp",
        "germanName": ""
    },
    "Motacilla alba": {
        "latinName": "Motacilla alba",
        "germanName": "Bachstelze"
    },
    "Motacilla cinerea": {
        "latinName": "Motacilla cinerea",
        "germanName": "Gebirgsstelze"
    },
    "Motacilla flava": {
        "latinName": "Motacilla flava",
        "germanName": "Schafstelze"
    },
    "Muscicapa striata": {
        "latinName": "Muscicapa striata",
        "germanName": "Grauschnaepper"
    },
    "Myadestes townsendi": {
        "latinName": "Myadestes townsendi",
        "germanName": ""
    },
    "Mycteria americana": {
        "latinName": "Mycteria americana",
        "germanName": ""
    },
    "Mycteria ibis": {
        "latinName": "Mycteria ibis",
        "germanName": ""
    },
    "Myiarchus cinerascens": {
        "latinName": "Myiarchus cinerascens",
        "germanName": ""
    },
    "Myiarchus crinitus": {
        "latinName": "Myiarchus crinitus",
        "germanName": ""
    },
    "Myiarchus tuberculifer": {
        "latinName": "Myiarchus tuberculifer",
        "germanName": ""
    },
    "Myiarchus tyrannulus": {
        "latinName": "Myiarchus tyrannulus",
        "germanName": ""
    },
    "Myioborus miniatus": {
        "latinName": "Myioborus miniatus",
        "germanName": ""
    },
    "Myioborus pictus": {
        "latinName": "Myioborus pictus",
        "germanName": ""
    },
    "Myiodynastes luteiventris": {
        "latinName": "Myiodynastes luteiventris",
        "germanName": ""
    },
    "Myiopsitta monachus": {
        "latinName": "Myiopsitta monachus",
        "germanName": ""
    },
    "Myiozetetes similis": {
        "latinName": "Myiozetetes similis",
        "germanName": ""
    },
    "Nestor meridionalis": {
        "latinName": "Nestor meridionalis",
        "germanName": ""
    },
    "Nestor meridionalis septentrionalis": {
        "latinName": "Nestor meridionalis septentrionalis",
        "germanName": ""
    },
    "Nestor notabilis": {
        "latinName": "Nestor notabilis",
        "germanName": ""
    },
    "Netta rufina": {
        "latinName": "Netta rufina",
        "germanName": "Kolbenente"
    },
    "Ninox novaeseelandiae novaeseelandiae": {
        "latinName": "Ninox novaeseelandiae novaeseelandiae",
        "germanName": ""
    },
    "None": {
        "latinName": "None",
        "germanName": ""
    },
    "Notiomystis cincta": {
        "latinName": "Notiomystis cincta",
        "germanName": ""
    },
    "Nucifraga columbiana": {
        "latinName": "Nucifraga columbiana",
        "germanName": ""
    },
    "Numenius americanus": {
        "latinName": "Numenius americanus",
        "germanName": ""
    },
    "Numenius arquata": {
        "latinName": "Numenius arquata",
        "germanName": "Brachvogel"
    },
    "Numenius phaeopus": {
        "latinName": "Numenius phaeopus",
        "germanName": "Regenbrachvogel"
    },
    "Numida meleagris": {
        "latinName": "Numida meleagris",
        "germanName": ""
    },
    "Nyctanassa violacea": {
        "latinName": "Nyctanassa violacea",
        "germanName": ""
    },
    "Nyctibius jamaicensis": {
        "latinName": "Nyctibius jamaicensis",
        "germanName": ""
    },
    "Nycticorax nycticorax": {
        "latinName": "Nycticorax nycticorax",
        "germanName": "Nachtreiher"
    },
    "Nyctidromus albicollis": {
        "latinName": "Nyctidromus albicollis",
        "germanName": ""
    },
    "Oceanites oceanicus": {
        "latinName": "Oceanites oceanicus",
        "germanName": "Buntfuss-Sturmschwalbe"
    },
    "Ocyphaps lophotes": {
        "latinName": "Ocyphaps lophotes",
        "germanName": ""
    },
    "Oenanthe oenanthe": {
        "latinName": "Oenanthe oenanthe",
        "germanName": "Steinschmaetzer"
    },
    "Onychognathus morio": {
        "latinName": "Onychognathus morio",
        "germanName": ""
    },
    "Onychoprion fuscatus": {
        "latinName": "Onychoprion fuscatus",
        "germanName": "Russseeschwalbe"
    },
    "Opisthocomus hoazin": {
        "latinName": "Opisthocomus hoazin",
        "germanName": ""
    },
    "Oreoscoptes montanus": {
        "latinName": "Oreoscoptes montanus",
        "germanName": ""
    },
    "Oreothlypis celata": {
        "latinName": "Oreothlypis celata",
        "germanName": ""
    },
    "Oreothlypis peregrina": {
        "latinName": "Oreothlypis peregrina",
        "germanName": ""
    },
    "Oreothlypis ruficapilla": {
        "latinName": "Oreothlypis ruficapilla",
        "germanName": ""
    },
    "Oriturus superciliosus": {
        "latinName": "Oriturus superciliosus",
        "germanName": ""
    },
    "Ortalis poliocephala": {
        "latinName": "Ortalis poliocephala",
        "germanName": ""
    },
    "Ortalis vetula": {
        "latinName": "Ortalis vetula",
        "germanName": ""
    },
    "Oxyura jamaicensis": {
        "latinName": "Oxyura jamaicensis",
        "germanName": "Schwarzkopf-Ruderente"
    },
    "Pachyramphus aglaiae": {
        "latinName": "Pachyramphus aglaiae",
        "germanName": ""
    },
    "Pandion haliaetus": {
        "latinName": "Pandion haliaetus",
        "germanName": "Fischadler"
    },
    "Parabuteo unicinctus": {
        "latinName": "Parabuteo unicinctus",
        "germanName": ""
    },
    "Parkesia motacilla": {
        "latinName": "Parkesia motacilla",
        "germanName": ""
    },
    "Parkesia noveboracensis": {
        "latinName": "Parkesia noveboracensis",
        "germanName": ""
    },
    "Paroaria capitata": {
        "latinName": "Paroaria capitata",
        "germanName": ""
    },
    "Paroaria coronata": {
        "latinName": "Paroaria coronata",
        "germanName": ""
    },
    "Parus major": {
        "latinName": "Parus major",
        "germanName": "Kohlmeise"
    },
    "Passer domesticus": {
        "latinName": "Passer domesticus",
        "germanName": "Haussperling"
    },
    "Passer italiae": {
        "latinName": "Passer italiae",
        "germanName": ""
    },
    "Passer montanus": {
        "latinName": "Passer montanus",
        "germanName": "Feldsperling"
    },
    "Passerculus sandwichensis": {
        "latinName": "Passerculus sandwichensis",
        "germanName": ""
    },
    "Passerella iliaca": {
        "latinName": "Passerella iliaca",
        "germanName": "Fuchsammer"
    },
    "Passerina amoena": {
        "latinName": "Passerina amoena",
        "germanName": "Lazulifink"
    },
    "Passerina caerulea": {
        "latinName": "Passerina caerulea",
        "germanName": ""
    },
    "Passerina ciris": {
        "latinName": "Passerina ciris",
        "germanName": ""
    },
    "Passerina cyanea": {
        "latinName": "Passerina cyanea",
        "germanName": "Indigofink"
    },
    "Passerina leclancherii": {
        "latinName": "Passerina leclancherii",
        "germanName": ""
    },
    "Passerina versicolor": {
        "latinName": "Passerina versicolor",
        "germanName": ""
    },
    "Patagioenas fasciata": {
        "latinName": "Patagioenas fasciata",
        "germanName": ""
    },
    "Patagioenas flavirostris": {
        "latinName": "Patagioenas flavirostris",
        "germanName": ""
    },
    "Patagioenas leucocephala": {
        "latinName": "Patagioenas leucocephala",
        "germanName": ""
    },
    "Pavo cristatus": {
        "latinName": "Pavo cristatus",
        "germanName": ""
    },
    "Pelecanus conspicillatus": {
        "latinName": "Pelecanus conspicillatus",
        "germanName": ""
    },
    "Pelecanus erythrorhynchos": {
        "latinName": "Pelecanus erythrorhynchos",
        "germanName": ""
    },
    "Pelecanus occidentalis": {
        "latinName": "Pelecanus occidentalis",
        "germanName": ""
    },
    "Pelecanus occidentalis californicus": {
        "latinName": "Pelecanus occidentalis californicus",
        "germanName": ""
    },
    "Pelecanus occidentalis carolinensis": {
        "latinName": "Pelecanus occidentalis carolinensis",
        "germanName": ""
    },
    "Pelecanus onocrotalus": {
        "latinName": "Pelecanus onocrotalus",
        "germanName": "Rosapelikan"
    },
    "Penelope purpurascens": {
        "latinName": "Penelope purpurascens",
        "germanName": ""
    },
    "Periparus ater": {
        "latinName": "Periparus ater",
        "germanName": "Tannenmeise"
    },
    "Perisoreus canadensis": {
        "latinName": "Perisoreus canadensis",
        "germanName": ""
    },
    "Petrochelidon fulva": {
        "latinName": "Petrochelidon fulva",
        "germanName": ""
    },
    "Petrochelidon pyrrhonota": {
        "latinName": "Petrochelidon pyrrhonota",
        "germanName": ""
    },
    "Petroica australis australis": {
        "latinName": "Petroica australis australis",
        "germanName": ""
    },
    "Petroica australis longipes": {
        "latinName": "Petroica australis longipes",
        "germanName": ""
    },
    "Petroica macrocephala macrocephala": {
        "latinName": "Petroica macrocephala macrocephala",
        "germanName": ""
    },
    "Peucaea ruficauda": {
        "latinName": "Peucaea ruficauda",
        "germanName": ""
    },
    "Phaethon aethereus": {
        "latinName": "Phaethon aethereus",
        "germanName": ""
    },
    "Phainopepla nitens": {
        "latinName": "Phainopepla nitens",
        "germanName": ""
    },
    "Phalacrocorax auritus": {
        "latinName": "Phalacrocorax auritus",
        "germanName": "Ohrenscharbe"
    },
    "Phalacrocorax brasilianus": {
        "latinName": "Phalacrocorax brasilianus",
        "germanName": ""
    },
    "Phalacrocorax carbo": {
        "latinName": "Phalacrocorax carbo",
        "germanName": "Kormoran"
    },
    "Phalacrocorax carbo novaehollandiae": {
        "latinName": "Phalacrocorax carbo novaehollandiae",
        "germanName": ""
    },
    "Phalacrocorax pelagicus": {
        "latinName": "Phalacrocorax pelagicus",
        "germanName": ""
    },
    "Phalacrocorax penicillatus": {
        "latinName": "Phalacrocorax penicillatus",
        "germanName": ""
    },
    "Phalacrocorax sulcirostris": {
        "latinName": "Phalacrocorax sulcirostris",
        "germanName": ""
    },
    "Phalacrocorax varius": {
        "latinName": "Phalacrocorax varius",
        "germanName": ""
    },
    "Phalacrocorax varius varius": {
        "latinName": "Phalacrocorax varius varius",
        "germanName": ""
    },
    "Phalaenoptilus nuttallii": {
        "latinName": "Phalaenoptilus nuttallii",
        "germanName": ""
    },
    "Phalaropus fulicarius": {
        "latinName": "Phalaropus fulicarius",
        "germanName": "Thorshuehnchen"
    },
    "Phalaropus lobatus": {
        "latinName": "Phalaropus lobatus",
        "germanName": "Odinshuehnchen"
    },
    "Phalaropus tricolor": {
        "latinName": "Phalaropus tricolor",
        "germanName": "Wilsonwassertreter"
    },
    "Pharomachrus mocinno": {
        "latinName": "Pharomachrus mocinno",
        "germanName": ""
    },
    "Phasianus colchicus": {
        "latinName": "Phasianus colchicus",
        "germanName": "Jagdfasan"
    },
    "Pheucticus ludovicianus": {
        "latinName": "Pheucticus ludovicianus",
        "germanName": "Rosenbrust-Kernknacker"
    },
    "Pheucticus melanocephalus": {
        "latinName": "Pheucticus melanocephalus",
        "germanName": ""
    },
    "Philesturnus rufusater": {
        "latinName": "Philesturnus rufusater",
        "germanName": ""
    },
    "Phoebastria immutabilis": {
        "latinName": "Phoebastria immutabilis",
        "germanName": ""
    },
    "Phoebastria nigripes": {
        "latinName": "Phoebastria nigripes",
        "germanName": ""
    },
    "Phoenicopterus roseus": {
        "latinName": "Phoenicopterus roseus",
        "germanName": "Rosaflamingo"
    },
    "Phoenicopterus ruber": {
        "latinName": "Phoenicopterus ruber",
        "germanName": "Kubaflamingo"
    },
    "Phoenicurus ochruros": {
        "latinName": "Phoenicurus ochruros",
        "germanName": "Hausrotschwanz"
    },
    "Phoenicurus phoenicurus": {
        "latinName": "Phoenicurus phoenicurus",
        "germanName": "Gartenrotschwanz"
    },
    "Phylloscopus collybita": {
        "latinName": "Phylloscopus collybita",
        "germanName": "Zilpzalp"
    },
    "Piaya cayana": {
        "latinName": "Piaya cayana",
        "germanName": ""
    },
    "Pica hudsonia": {
        "latinName": "Pica hudsonia",
        "germanName": ""
    },
    "Pica nuttalli": {
        "latinName": "Pica nuttalli",
        "germanName": ""
    },
    "Pica pica": {
        "latinName": "Pica pica",
        "germanName": "Elster"
    },
    "Picoides albolarvatus": {
        "latinName": "Picoides albolarvatus",
        "germanName": ""
    },
    "Picoides arcticus": {
        "latinName": "Picoides arcticus",
        "germanName": ""
    },
    "Picoides dorsalis": {
        "latinName": "Picoides dorsalis",
        "germanName": ""
    },
    "Picoides nuttallii": {
        "latinName": "Picoides nuttallii",
        "germanName": ""
    },
    "Picoides pubescens": {
        "latinName": "Picoides pubescens",
        "germanName": ""
    },
    "Picoides scalaris": {
        "latinName": "Picoides scalaris",
        "germanName": ""
    },
    "Picoides villosus": {
        "latinName": "Picoides villosus",
        "germanName": ""
    },
    "Picus viridis": {
        "latinName": "Picus viridis",
        "germanName": "Gruenspecht"
    },
    "Pinicola enucleator": {
        "latinName": "Pinicola enucleator",
        "germanName": "Hakengimpel"
    },
    "Pipilo chlorurus": {
        "latinName": "Pipilo chlorurus",
        "germanName": ""
    },
    "Pipilo erythrophthalmus": {
        "latinName": "Pipilo erythrophthalmus",
        "germanName": ""
    },
    "Pipilo maculatus": {
        "latinName": "Pipilo maculatus",
        "germanName": ""
    },
    "Piranga bidentata": {
        "latinName": "Piranga bidentata",
        "germanName": ""
    },
    "Piranga flava": {
        "latinName": "Piranga flava",
        "germanName": ""
    },
    "Piranga ludoviciana": {
        "latinName": "Piranga ludoviciana",
        "germanName": ""
    },
    "Piranga olivacea": {
        "latinName": "Piranga olivacea",
        "germanName": ""
    },
    "Piranga rubra": {
        "latinName": "Piranga rubra",
        "germanName": ""
    },
    "Pitangus sulphuratus": {
        "latinName": "Pitangus sulphuratus",
        "germanName": ""
    },
    "Platalea ajaja": {
        "latinName": "Platalea ajaja",
        "germanName": ""
    },
    "Platalea alba": {
        "latinName": "Platalea alba",
        "germanName": "Rotgesichtloeffler"
    },
    "Platalea leucorodia": {
        "latinName": "Platalea leucorodia",
        "germanName": "Loeffler"
    },
    "Platalea regia": {
        "latinName": "Platalea regia",
        "germanName": ""
    },
    "Platycercus elegans": {
        "latinName": "Platycercus elegans",
        "germanName": ""
    },
    "Platycercus eximius": {
        "latinName": "Platycercus eximius",
        "germanName": ""
    },
    "Plectrophenax nivalis": {
        "latinName": "Plectrophenax nivalis",
        "germanName": "Schneeammer"
    },
    "Plegadis chihi": {
        "latinName": "Plegadis chihi",
        "germanName": ""
    },
    "Plegadis falcinellus": {
        "latinName": "Plegadis falcinellus",
        "germanName": "Sichler"
    },
    "Pluvialis dominica": {
        "latinName": "Pluvialis dominica",
        "germanName": "Praerie-Goldregenpfeifer"
    },
    "Pluvialis fulva": {
        "latinName": "Pluvialis fulva",
        "germanName": "Tundra-Goldregenpfeifer"
    },
    "Pluvialis squatarola": {
        "latinName": "Pluvialis squatarola",
        "germanName": "Kiebitzregenpfeifer"
    },
    "Podiceps auritus": {
        "latinName": "Podiceps auritus",
        "germanName": "Ohrentaucher"
    },
    "Podiceps cristatus": {
        "latinName": "Podiceps cristatus",
        "germanName": "Haubentaucher"
    },
    "Podiceps grisegena": {
        "latinName": "Podiceps grisegena",
        "germanName": "Rothalstaucher"
    },
    "Podiceps nigricollis": {
        "latinName": "Podiceps nigricollis",
        "germanName": "Schwarzhalstaucher"
    },
    "Podilymbus podiceps": {
        "latinName": "Podilymbus podiceps",
        "germanName": "Bindentaucher"
    },
    "Poecile atricapillus": {
        "latinName": "Poecile atricapillus",
        "germanName": ""
    },
    "Poecile carolinensis": {
        "latinName": "Poecile carolinensis",
        "germanName": ""
    },
    "Poecile gambeli": {
        "latinName": "Poecile gambeli",
        "germanName": ""
    },
    "Poecile rufescens": {
        "latinName": "Poecile rufescens",
        "germanName": ""
    },
    "Polioptila caerulea": {
        "latinName": "Polioptila caerulea",
        "germanName": ""
    },
    "Polioptila melanura": {
        "latinName": "Polioptila melanura",
        "germanName": ""
    },
    "Pooecetes gramineus": {
        "latinName": "Pooecetes gramineus",
        "germanName": ""
    },
    "Porphyrio hochstetteri": {
        "latinName": "Porphyrio hochstetteri",
        "germanName": ""
    },
    "Porphyrio martinicus": {
        "latinName": "Porphyrio martinicus",
        "germanName": ""
    },
    "Porphyrio melanotus": {
        "latinName": "Porphyrio melanotus",
        "germanName": ""
    },
    "Porphyrio melanotus melanotus": {
        "latinName": "Porphyrio melanotus melanotus",
        "germanName": ""
    },
    "Porphyrio poliocephalus": {
        "latinName": "Porphyrio poliocephalus",
        "germanName": "Graukopf-Purpurhuhn"
    },
    "Porzana carolina": {
        "latinName": "Porzana carolina",
        "germanName": ""
    },
    "Progne subis": {
        "latinName": "Progne subis",
        "germanName": ""
    },
    "Prosthemadera novaeseelandiae": {
        "latinName": "Prosthemadera novaeseelandiae",
        "germanName": ""
    },
    "Prosthemadera novaeseelandiae novaeseelandiae": {
        "latinName": "Prosthemadera novaeseelandiae novaeseelandiae",
        "germanName": ""
    },
    "Protonotaria citrea": {
        "latinName": "Protonotaria citrea",
        "germanName": ""
    },
    "Prunella modularis": {
        "latinName": "Prunella modularis",
        "germanName": "Heckenbraunelle"
    },
    "Psaltriparus minimus": {
        "latinName": "Psaltriparus minimus",
        "germanName": ""
    },
    "Psarocolius montezuma": {
        "latinName": "Psarocolius montezuma",
        "germanName": ""
    },
    "Psilorhinus morio": {
        "latinName": "Psilorhinus morio",
        "germanName": ""
    },
    "Psittacara erythrogenys": {
        "latinName": "Psittacara erythrogenys",
        "germanName": ""
    },
    "Psittacara holochlorus": {
        "latinName": "Psittacara holochlorus",
        "germanName": ""
    },
    "Psittacula krameri": {
        "latinName": "Psittacula krameri",
        "germanName": "Halsbandsittich"
    },
    "Pteroglossus torquatus": {
        "latinName": "Pteroglossus torquatus",
        "germanName": ""
    },
    "Ptiliogonys cinereus": {
        "latinName": "Ptiliogonys cinereus",
        "germanName": ""
    },
    "Pycnonotus barbatus": {
        "latinName": "Pycnonotus barbatus",
        "germanName": ""
    },
    "Pycnonotus cafer": {
        "latinName": "Pycnonotus cafer",
        "germanName": ""
    },
    "Pycnonotus jocosus": {
        "latinName": "Pycnonotus jocosus",
        "germanName": ""
    },
    "Pyrocephalus rubinus": {
        "latinName": "Pyrocephalus rubinus",
        "germanName": ""
    },
    "Pyrrhocorax graculus": {
        "latinName": "Pyrrhocorax graculus",
        "germanName": "Alpendohle"
    },
    "Pyrrhula pyrrhula": {
        "latinName": "Pyrrhula pyrrhula",
        "germanName": "Gimpel"
    },
    "Quiscalus major": {
        "latinName": "Quiscalus major",
        "germanName": ""
    },
    "Quiscalus mexicanus": {
        "latinName": "Quiscalus mexicanus",
        "germanName": ""
    },
    "Quiscalus niger": {
        "latinName": "Quiscalus niger",
        "germanName": ""
    },
    "Quiscalus quiscula": {
        "latinName": "Quiscalus quiscula",
        "germanName": ""
    },
    "Rallus crepitans": {
        "latinName": "Rallus crepitans",
        "germanName": ""
    },
    "Rallus limicola": {
        "latinName": "Rallus limicola",
        "germanName": ""
    },
    "Rallus obsoletus": {
        "latinName": "Rallus obsoletus",
        "germanName": ""
    },
    "Ramphastos ambiguus": {
        "latinName": "Ramphastos ambiguus",
        "germanName": ""
    },
    "Ramphastos sulfuratus": {
        "latinName": "Ramphastos sulfuratus",
        "germanName": ""
    },
    "Ramphocelus passerinii": {
        "latinName": "Ramphocelus passerinii",
        "germanName": ""
    },
    "Recurvirostra americana": {
        "latinName": "Recurvirostra americana",
        "germanName": ""
    },
    "Recurvirostra avosetta": {
        "latinName": "Recurvirostra avosetta",
        "germanName": "Saebelschnaebler"
    },
    "Regulus calendula": {
        "latinName": "Regulus calendula",
        "germanName": ""
    },
    "Regulus ignicapilla": {
        "latinName": "Regulus ignicapilla",
        "germanName": "Sommergoldhaehnchen"
    },
    "Regulus regulus": {
        "latinName": "Regulus regulus",
        "germanName": "Wintergoldhaehnchen"
    },
    "Regulus satrapa": {
        "latinName": "Regulus satrapa",
        "germanName": ""
    },
    "Rhipidura fuliginosa": {
        "latinName": "Rhipidura fuliginosa",
        "germanName": ""
    },
    "Rhipidura fuliginosa fuliginosa": {
        "latinName": "Rhipidura fuliginosa fuliginosa",
        "germanName": ""
    },
    "Rhipidura fuliginosa placabilis": {
        "latinName": "Rhipidura fuliginosa placabilis",
        "germanName": ""
    },
    "Rhipidura leucophrys": {
        "latinName": "Rhipidura leucophrys",
        "germanName": ""
    },
    "Riparia riparia": {
        "latinName": "Riparia riparia",
        "germanName": "Uferschwalbe"
    },
    "Rissa tridactyla": {
        "latinName": "Rissa tridactyla",
        "germanName": "Dreizehenmoewe"
    },
    "Rostrhamus sociabilis": {
        "latinName": "Rostrhamus sociabilis",
        "germanName": ""
    },
    "Rupornis magnirostris": {
        "latinName": "Rupornis magnirostris",
        "germanName": ""
    },
    "Rynchops niger": {
        "latinName": "Rynchops niger",
        "germanName": ""
    },
    "Sagittarius serpentarius": {
        "latinName": "Sagittarius serpentarius",
        "germanName": ""
    },
    "Salpinctes obsoletus": {
        "latinName": "Salpinctes obsoletus",
        "germanName": ""
    },
    "Saltator atriceps": {
        "latinName": "Saltator atriceps",
        "germanName": ""
    },
    "Saltator coerulescens": {
        "latinName": "Saltator coerulescens",
        "germanName": ""
    },
    "Sarcoramphus papa": {
        "latinName": "Sarcoramphus papa",
        "germanName": ""
    },
    "Saxicola rubetra": {
        "latinName": "Saxicola rubetra",
        "germanName": "Braunkehlchen"
    },
    "Saxicola rubicola": {
        "latinName": "Saxicola rubicola",
        "germanName": "Schwarzkehlchen"
    },
    "Sayornis nigricans": {
        "latinName": "Sayornis nigricans",
        "germanName": ""
    },
    "Sayornis phoebe": {
        "latinName": "Sayornis phoebe",
        "germanName": ""
    },
    "Sayornis saya": {
        "latinName": "Sayornis saya",
        "germanName": ""
    },
    "Sciurus vulgaris":{
        "latinName": "Sciurus vulgaris",
        "germanName": "Eurasisches Eichhoernchen"
    },
    "Scolopax minor": {
        "latinName": "Scolopax minor",
        "germanName": ""
    },
    "Scopus umbretta": {
        "latinName": "Scopus umbretta",
        "germanName": ""
    },
    "Seiurus aurocapilla": {
        "latinName": "Seiurus aurocapilla",
        "germanName": ""
    },
    "Selasphorus calliope": {
        "latinName": "Selasphorus calliope",
        "germanName": ""
    },
    "Selasphorus platycercus": {
        "latinName": "Selasphorus platycercus",
        "germanName": ""
    },
    "Selasphorus rufus": {
        "latinName": "Selasphorus rufus",
        "germanName": ""
    },
    "Selasphorus sasin": {
        "latinName": "Selasphorus sasin",
        "germanName": ""
    },
    "Serinus mozambicus": {
        "latinName": "Serinus mozambicus",
        "germanName": ""
    },
    "Serinus serinus": {
        "latinName": "Serinus serinus",
        "germanName": "Girlitz"
    },
    "Setophaga americana": {
        "latinName": "Setophaga americana",
        "germanName": "Meisenwaldsaenger"
    },
    "Setophaga caerulescens": {
        "latinName": "Setophaga caerulescens",
        "germanName": ""
    },
    "Setophaga castanea": {
        "latinName": "Setophaga castanea",
        "germanName": ""
    },
    "Setophaga cerulea": {
        "latinName": "Setophaga cerulea",
        "germanName": ""
    },
    "Setophaga chrysoparia": {
        "latinName": "Setophaga chrysoparia",
        "germanName": ""
    },
    "Setophaga citrina": {
        "latinName": "Setophaga citrina",
        "germanName": ""
    },
    "Setophaga coronata": {
        "latinName": "Setophaga coronata",
        "germanName": ""
    },
    "Setophaga coronata auduboni": {
        "latinName": "Setophaga coronata auduboni",
        "germanName": ""
    },
    "Setophaga coronata coronata": {
        "latinName": "Setophaga coronata coronata",
        "germanName": ""
    },
    "Setophaga discolor": {
        "latinName": "Setophaga discolor",
        "germanName": ""
    },
    "Setophaga dominica": {
        "latinName": "Setophaga dominica",
        "germanName": ""
    },
    "Setophaga fusca": {
        "latinName": "Setophaga fusca",
        "germanName": ""
    },
    "Setophaga magnolia": {
        "latinName": "Setophaga magnolia",
        "germanName": ""
    },
    "Setophaga nigrescens": {
        "latinName": "Setophaga nigrescens",
        "germanName": ""
    },
    "Setophaga occidentalis": {
        "latinName": "Setophaga occidentalis",
        "germanName": ""
    },
    "Setophaga palmarum": {
        "latinName": "Setophaga palmarum",
        "germanName": ""
    },
    "Setophaga pensylvanica": {
        "latinName": "Setophaga pensylvanica",
        "germanName": ""
    },
    "Setophaga petechia": {
        "latinName": "Setophaga petechia",
        "germanName": ""
    },
    "Setophaga pinus": {
        "latinName": "Setophaga pinus",
        "germanName": ""
    },
    "Setophaga ruticilla": {
        "latinName": "Setophaga ruticilla",
        "germanName": ""
    },
    "Setophaga striata": {
        "latinName": "Setophaga striata",
        "germanName": ""
    },
    "Setophaga tigrina": {
        "latinName": "Setophaga tigrina",
        "germanName": ""
    },
    "Setophaga townsendi": {
        "latinName": "Setophaga townsendi",
        "germanName": ""
    },
    "Setophaga virens": {
        "latinName": "Setophaga virens",
        "germanName": "Gruenmantel-Waldsaenger"
    },
    "Sialia currucoides": {
        "latinName": "Sialia currucoides",
        "germanName": ""
    },
    "Sialia mexicana": {
        "latinName": "Sialia mexicana",
        "germanName": ""
    },
    "Sialia sialis": {
        "latinName": "Sialia sialis",
        "germanName": ""
    },
    "Sicalis flaveola": {
        "latinName": "Sicalis flaveola",
        "germanName": ""
    },
    "Sitta canadensis": {
        "latinName": "Sitta canadensis",
        "germanName": ""
    },
    "Sitta carolinensis": {
        "latinName": "Sitta carolinensis",
        "germanName": ""
    },
    "Sitta europaea": {
        "latinName": "Sitta europaea",
        "germanName": "Kleiber"
    },
    "Sitta pusilla": {
        "latinName": "Sitta pusilla",
        "germanName": ""
    },
    "Sitta pygmaea": {
        "latinName": "Sitta pygmaea",
        "germanName": ""
    },
    "Somateria mollissima": {
        "latinName": "Somateria mollissima",
        "germanName": "Eiderente"
    },
    "Spheniscus demersus": {
        "latinName": "Spheniscus demersus",
        "germanName": ""
    },
    "Sphyrapicus nuchalis": {
        "latinName": "Sphyrapicus nuchalis",
        "germanName": ""
    },
    "Sphyrapicus ruber": {
        "latinName": "Sphyrapicus ruber",
        "germanName": ""
    },
    "Sphyrapicus thyroideus": {
        "latinName": "Sphyrapicus thyroideus",
        "germanName": ""
    },
    "Sphyrapicus varius": {
        "latinName": "Sphyrapicus varius",
        "germanName": ""
    },
    "Spinus lawrencei": {
        "latinName": "Spinus lawrencei",
        "germanName": ""
    },
    "Spinus pinus": {
        "latinName": "Spinus pinus",
        "germanName": ""
    },
    "Spinus psaltria": {
        "latinName": "Spinus psaltria",
        "germanName": ""
    },
    "Spinus spinus": {
        "latinName": "Spinus spinus",
        "germanName": "Erlenzeisig"
    },
    "Spinus tristis": {
        "latinName": "Spinus tristis",
        "germanName": ""
    },
    "Spiza americana": {
        "latinName": "Spiza americana",
        "germanName": ""
    },
    "Spizella atrogularis": {
        "latinName": "Spizella atrogularis",
        "germanName": ""
    },
    "Spizella breweri": {
        "latinName": "Spizella breweri",
        "germanName": ""
    },
    "Spizella pallida": {
        "latinName": "Spizella pallida",
        "germanName": ""
    },
    "Spizella passerina": {
        "latinName": "Spizella passerina",
        "germanName": ""
    },
    "Spizella pusilla": {
        "latinName": "Spizella pusilla",
        "germanName": ""
    },
    "Spizelloides arborea": {
        "latinName": "Spizelloides arborea",
        "germanName": ""
    },
    "Sporophila torqueola": {
        "latinName": "Sporophila torqueola",
        "germanName": ""
    },
    "Stelgidopteryx serripennis": {
        "latinName": "Stelgidopteryx serripennis",
        "germanName": ""
    },
    "Stercorarius parasiticus": {
        "latinName": "Stercorarius parasiticus",
        "germanName": "Schmarotzerraubmoewe"
    },
    "Stercorarius pomarinus": {
        "latinName": "Stercorarius pomarinus",
        "germanName": "Spatelraubmoewe"
    },
    "Sterna forsteri": {
        "latinName": "Sterna forsteri",
        "germanName": ""
    },
    "Sterna hirundo": {
        "latinName": "Sterna hirundo",
        "germanName": "Flussseeschwalbe"
    },
    "Sterna paradisaea": {
        "latinName": "Sterna paradisaea",
        "germanName": "Kuestenseeschwalbe"
    },
    "Sterna striata": {
        "latinName": "Sterna striata",
        "germanName": ""
    },
    "Sternula antillarum": {
        "latinName": "Sternula antillarum",
        "germanName": ""
    },
    "Streptopelia chinensis": {
        "latinName": "Streptopelia chinensis",
        "germanName": ""
    },
    "Streptopelia decaocto": {
        "latinName": "Streptopelia decaocto",
        "germanName": "Tuerkentaube"
    },
    "Streptopelia senegalensis": {
        "latinName": "Streptopelia senegalensis",
        "germanName": ""
    },
    "Streptopelia turtur": {
        "latinName": "Streptopelia turtur",
        "germanName": "Turteltaube"
    },
    "Strix nebulosa": {
        "latinName": "Strix nebulosa",
        "germanName": ""
    },
    "Strix varia": {
        "latinName": "Strix varia",
        "germanName": ""
    },
    "Struthio camelus": {
        "latinName": "Struthio camelus",
        "germanName": ""
    },
    "Sturnella magna": {
        "latinName": "Sturnella magna",
        "germanName": ""
    },
    "Sturnella neglecta": {
        "latinName": "Sturnella neglecta",
        "germanName": ""
    },
    "Sturnus vulgaris": {
        "latinName": "Sturnus vulgaris",
        "germanName": "Star"
    },
    "Sula dactylatra": {
        "latinName": "Sula dactylatra",
        "germanName": ""
    },
    "Sula granti": {
        "latinName": "Sula granti",
        "germanName": ""
    },
    "Sula leucogaster": {
        "latinName": "Sula leucogaster",
        "germanName": "Weissbauchtoelpel"
    },
    "Sula nebouxii": {
        "latinName": "Sula nebouxii",
        "germanName": ""
    },
    "Sula sula": {
        "latinName": "Sula sula",
        "germanName": ""
    },
    "Surnia ulula": {
        "latinName": "Surnia ulula",
        "germanName": "Sperbereule"
    },
    "Sylvia atricapilla": {
        "latinName": "Sylvia atricapilla",
        "germanName": "Moenchsgrasmuecke"
    },
    "Sylvia communis": {
        "latinName": "Sylvia communis",
        "germanName": "Dorngrasmuecke"
    },
    "Tachybaptus dominicus": {
        "latinName": "Tachybaptus dominicus",
        "germanName": ""
    },
    "Tachybaptus ruficollis": {
        "latinName": "Tachybaptus ruficollis",
        "germanName": "Zwergtaucher"
    },
    "Tachycineta albilinea": {
        "latinName": "Tachycineta albilinea",
        "germanName": ""
    },
    "Tachycineta bicolor": {
        "latinName": "Tachycineta bicolor",
        "germanName": ""
    },
    "Tachycineta thalassina": {
        "latinName": "Tachycineta thalassina",
        "germanName": ""
    },
    "Tadorna ferruginea": {
        "latinName": "Tadorna ferruginea",
        "germanName": "Rostgans"
    },
    "Tadorna tadorna": {
        "latinName": "Tadorna tadorna",
        "germanName": "Brandgans"
    },
    "Tadorna variegata": {
        "latinName": "Tadorna variegata",
        "germanName": ""
    },
    "Terathopius ecaudatus": {
        "latinName": "Terathopius ecaudatus",
        "germanName": ""
    },
    "Thalasseus bergii": {
        "latinName": "Thalasseus bergii",
        "germanName": ""
    },
    "Thalasseus elegans": {
        "latinName": "Thalasseus elegans",
        "germanName": "Schmuckseeschwalbe"
    },
    "Thalasseus maximus": {
        "latinName": "Thalasseus maximus",
        "germanName": ""
    },
    "Thalasseus sandvicensis": {
        "latinName": "Thalasseus sandvicensis",
        "germanName": "Brandseeschwalbe"
    },
    "Thamnophilus doliatus": {
        "latinName": "Thamnophilus doliatus",
        "germanName": ""
    },
    "Thraupis abbas": {
        "latinName": "Thraupis abbas",
        "germanName": ""
    },
    "Thraupis episcopus": {
        "latinName": "Thraupis episcopus",
        "germanName": ""
    },
    "Thraupis palmarum": {
        "latinName": "Thraupis palmarum",
        "germanName": ""
    },
    "Threskiornis aethiopicus": {
        "latinName": "Threskiornis aethiopicus",
        "germanName": "Pharaonenibis"
    },
    "Threskiornis moluccus": {
        "latinName": "Threskiornis moluccus",
        "germanName": ""
    },
    "Thryomanes bewickii": {
        "latinName": "Thryomanes bewickii",
        "germanName": ""
    },
    "Thryothorus ludovicianus": {
        "latinName": "Thryothorus ludovicianus",
        "germanName": ""
    },
    "Tiaris olivaceus": {
        "latinName": "Tiaris olivaceus",
        "germanName": ""
    },
    "Tigrisoma mexicanum": {
        "latinName": "Tigrisoma mexicanum",
        "germanName": ""
    },
    "Tityra semifasciata": {
        "latinName": "Tityra semifasciata",
        "germanName": ""
    },
    "Todiramphus chloris": {
        "latinName": "Todiramphus chloris",
        "germanName": ""
    },
    "Todiramphus sanctus": {
        "latinName": "Todiramphus sanctus",
        "germanName": ""
    },
    "Todiramphus sanctus vagans": {
        "latinName": "Todiramphus sanctus vagans",
        "germanName": ""
    },
    "Toxostoma curvirostre": {
        "latinName": "Toxostoma curvirostre",
        "germanName": ""
    },
    "Toxostoma longirostre": {
        "latinName": "Toxostoma longirostre",
        "germanName": ""
    },
    "Toxostoma redivivum": {
        "latinName": "Toxostoma redivivum",
        "germanName": ""
    },
    "Toxostoma rufum": {
        "latinName": "Toxostoma rufum",
        "germanName": ""
    },
    "Trichoglossus haematodus": {
        "latinName": "Trichoglossus haematodus",
        "germanName": ""
    },
    "Tringa flavipes": {
        "latinName": "Tringa flavipes",
        "germanName": "Gelbschenkel"
    },
    "Tringa glareola": {
        "latinName": "Tringa glareola",
        "germanName": "Bruchwasserlaeufer"
    },
    "Tringa incana": {
        "latinName": "Tringa incana",
        "germanName": ""
    },
    "Tringa melanoleuca": {
        "latinName": "Tringa melanoleuca",
        "germanName": ""
    },
    "Tringa nebularia": {
        "latinName": "Tringa nebularia",
        "germanName": "Gruenschenkel"
    },
    "Tringa ochropus": {
        "latinName": "Tringa ochropus",
        "germanName": "Waldwasserlaeufer"
    },
    "Tringa semipalmata": {
        "latinName": "Tringa semipalmata",
        "germanName": ""
    },
    "Tringa semipalmata inornatus": {
        "latinName": "Tringa semipalmata inornatus",
        "germanName": ""
    },
    "Tringa solitaria": {
        "latinName": "Tringa solitaria",
        "germanName": ""
    },
    "Tringa totanus": {
        "latinName": "Tringa totanus",
        "germanName": "Rotschenkel"
    },
    "Troglodytes aedon": {
        "latinName": "Troglodytes aedon",
        "germanName": ""
    },
    "Troglodytes hiemalis": {
        "latinName": "Troglodytes hiemalis",
        "germanName": ""
    },
    "Troglodytes pacificus": {
        "latinName": "Troglodytes pacificus",
        "germanName": ""
    },
    "Troglodytes troglodytes": {
        "latinName": "Troglodytes troglodytes",
        "germanName": "Zaunkoenig"
    },
    "Trogon caligatus": {
        "latinName": "Trogon caligatus",
        "germanName": ""
    },
    "Trogon citreolus": {
        "latinName": "Trogon citreolus",
        "germanName": ""
    },
    "Trogon collaris": {
        "latinName": "Trogon collaris",
        "germanName": ""
    },
    "Trogon elegans": {
        "latinName": "Trogon elegans",
        "germanName": ""
    },
    "Trogon massena": {
        "latinName": "Trogon massena",
        "germanName": ""
    },
    "Trogon melanocephalus": {
        "latinName": "Trogon melanocephalus",
        "germanName": ""
    },
    "Turdus grayi": {
        "latinName": "Turdus grayi",
        "germanName": ""
    },
    "Turdus merula": {
        "latinName": "Turdus merula",
        "germanName": "Amsel"
    },
    "Turdus migratorius": {
        "latinName": "Turdus migratorius",
        "germanName": "Wanderdrossel"
    },
    "Turdus philomelos": {
        "latinName": "Turdus philomelos",
        "germanName": "Singdrossel"
    },
    "Turdus pilaris": {
        "latinName": "Turdus pilaris",
        "germanName": "Wacholderdrossel"
    },
    "Turdus plumbeus": {
        "latinName": "Turdus plumbeus",
        "germanName": ""
    },
    "Turdus rufopalliatus": {
        "latinName": "Turdus rufopalliatus",
        "germanName": ""
    },
    "Turdus viscivorus": {
        "latinName": "Turdus viscivorus",
        "germanName": "Misteldrossel"
    },
    "Tyrannus couchii": {
        "latinName": "Tyrannus couchii",
        "germanName": ""
    },
    "Tyrannus crassirostris": {
        "latinName": "Tyrannus crassirostris",
        "germanName": ""
    },
    "Tyrannus dominicensis": {
        "latinName": "Tyrannus dominicensis",
        "germanName": ""
    },
    "Tyrannus forficatus": {
        "latinName": "Tyrannus forficatus",
        "germanName": ""
    },
    "Tyrannus melancholicus": {
        "latinName": "Tyrannus melancholicus",
        "germanName": ""
    },
    "Tyrannus savana": {
        "latinName": "Tyrannus savana",
        "germanName": ""
    },
    "Tyrannus tyrannus": {
        "latinName": "Tyrannus tyrannus",
        "germanName": ""
    },
    "Tyrannus verticalis": {
        "latinName": "Tyrannus verticalis",
        "germanName": ""
    },
    "Tyrannus vociferans": {
        "latinName": "Tyrannus vociferans",
        "germanName": ""
    },
    "Tyto alba": {
        "latinName": "Tyto alba",
        "germanName": "Schleiereule"
    },
    "Upupa epops": {
        "latinName": "Upupa epops",
        "germanName": "Wiedehopf"
    },
    "Uria aalge": {
        "latinName": "Uria aalge",
        "germanName": "Trottellumme"
    },
    "Vanellus armatus": {
        "latinName": "Vanellus armatus",
        "germanName": ""
    },
    "Vanellus chilensis": {
        "latinName": "Vanellus chilensis",
        "germanName": ""
    },
    "Vanellus miles": {
        "latinName": "Vanellus miles",
        "germanName": ""
    },
    "Vanellus spinosus": {
        "latinName": "Vanellus spinosus",
        "germanName": "Spornkiebitz"
    },
    "Vanellus vanellus": {
        "latinName": "Vanellus vanellus",
        "germanName": "Kiebitz"
    },
    "Vermivora chrysoptera": {
        "latinName": "Vermivora chrysoptera",
        "germanName": ""
    },
    "Vermivora cyanoptera": {
        "latinName": "Vermivora cyanoptera",
        "germanName": ""
    },
    "Vireo bellii": {
        "latinName": "Vireo bellii",
        "germanName": ""
    },
    "Vireo cassinii": {
        "latinName": "Vireo cassinii",
        "germanName": ""
    },
    "Vireo flavifrons": {
        "latinName": "Vireo flavifrons",
        "germanName": "Gelbkehlvireo"
    },
    "Vireo gilvus": {
        "latinName": "Vireo gilvus",
        "germanName": ""
    },
    "Vireo griseus": {
        "latinName": "Vireo griseus",
        "germanName": ""
    },
    "Vireo huttoni": {
        "latinName": "Vireo huttoni",
        "germanName": ""
    },
    "Vireo olivaceus": {
        "latinName": "Vireo olivaceus",
        "germanName": "Rotaugenvireo"
    },
    "Vireo philadelphicus": {
        "latinName": "Vireo philadelphicus",
        "germanName": ""
    },
    "Vireo plumbeus": {
        "latinName": "Vireo plumbeus",
        "germanName": ""
    },
    "Vireo solitarius": {
        "latinName": "Vireo solitarius",
        "germanName": ""
    },
    "Volatinia jacarina": {
        "latinName": "Volatinia jacarina",
        "germanName": ""
    },
    "Xanthocephalus xanthocephalus": {
        "latinName": "Xanthocephalus xanthocephalus",
        "germanName": ""
    },
    "Xema sabini": {
        "latinName": "Xema sabini",
        "germanName": "Schwalbenmoewe"
    },
    "Xiphorhynchus flavigaster": {
        "latinName": "Xiphorhynchus flavigaster",
        "germanName": ""
    },
    "Zenaida asiatica": {
        "latinName": "Zenaida asiatica",
        "germanName": ""
    },
    "Zenaida auriculata": {
        "latinName": "Zenaida auriculata",
        "germanName": ""
    },
    "Zenaida aurita": {
        "latinName": "Zenaida aurita",
        "germanName": ""
    },
    "Zenaida macroura": {
        "latinName": "Zenaida macroura",
        "germanName": "Carolinataube"
    },
    "Zonotrichia albicollis": {
        "latinName": "Zonotrichia albicollis",
        "germanName": "Weisskehlammer"
    },
    "Zonotrichia atricapilla": {
        "latinName": "Zonotrichia atricapilla",
        "germanName": ""
    },
    "Zonotrichia capensis": {
        "latinName": "Zonotrichia capensis",
        "germanName": ""
    },
    "Zonotrichia leucophrys": {
        "latinName": "Zonotrichia leucophrys",
        "germanName": "Dachsammer"
    },
    "Zonotrichia querula": {
        "latinName": "Zonotrichia querula",
        "germanName": ""
    },
    "Zosterops japonicus": {
        "latinName": "Zosterops japonicus",
        "germanName": ""
    },
    "Zosterops lateralis": {
        "latinName": "Zosterops lateralis",
        "germanName": ""
    },
    "Zosterops lateralis lateralis": {
        "latinName": "Zosterops lateralis lateralis",
        "germanName": ""
    }
}


const validationOptions = {
    "Human": {
        "latinName": "human",
        "germanName": "Mensch"
    },
    "Mensch": {
        "latinName": "human",
        "germanName": "Mensch"
    },
    "Haussperling": {
        "latinName": "Passer domesticus",
        "germanName": "Haussperling"
    },
    "Kohlmeise": {
        "latinName": "Parus major",
        "germanName": "Kohlmeise"
    },
    "Blaumeise": {
        "latinName": "Cyanistes caeruleus",
        "germanName": "Blaumeise"
    },
    "Amsel": {
        "latinName": "Turdus merula",
        "germanName": "Amsel"
    },
    "Eurasisches Eichhörnchen": {
        "latinName": "Sciurus vulgaris",
        "germanName": "Eurasisches Eichhoernchen"
    },
    "Rotkehlchen": {
        "latinName": "Erithacus rubecula",
        "germanName": "Rotkehlchen"
    },
    "Adlerbussard": {
        "latinName": "Buteo rufinus",
        "germanName": "Adlerbussard"
    },
    "Albatrosse": {
        "latinName": "Familie Diomedeidae",
        "germanName": "Albatrosse"
    },
    "Alexandersittich": {
        "latinName": "Psittacula eupatria",
        "germanName": "Alexandersittich"
    },
    "Alke": {
        "latinName": "Familie Alcidae",
        "germanName": "Alke"
    },
    "Alpenbirkenzeisig": {
        "latinName": "Acanthis cabaret",
        "germanName": "Alpenbirkenzeisig"
    },
    "Alpenbraunelle": {
        "latinName": "Prunella collaris",
        "germanName": "Alpenbraunelle"
    },
    "Alpendohle": {
        "latinName": "Pyrrhocorax graculus",
        "germanName": "Alpendohle"
    },
    "Alpenkraehe": {
        "latinName": "Pyrrhocorax pyrrhocorax",
        "germanName": "Alpenkraehe"
    },
    "Alpenschneehuhn": {
        "latinName": "Lagopus muta",
        "germanName": "Alpenschneehuhn"
    },
    "Alpensegler": {
        "latinName": "Tachymarptis melba",
        "germanName": "Alpensegler"
    },
    "Alpenstrandlaeufer": {
        "latinName": "Calidris alpina",
        "germanName": "Alpenstrandlaeufer"
    },
    "Altweltpapageien": {
        "latinName": "Familie Psittaculidae",
        "germanName": "Altweltpapageien"
    },
    "Ammern": {
        "latinName": "Familie Emberizidae",
        "germanName": "Ammern"
    },
    "Amurdrossel": {
        "latinName": "Turdus hortulorum",
        "germanName": "Amurdrossel"
    },
    "Anadyrknutt": {
        "latinName": "Calidris tenuirostris",
        "germanName": "Anadyrknutt"
    },
    "Atlantiksturmtaucher": {
        "latinName": "Puffinus puffinus",
        "germanName": "Atlantiksturmtaucher"
    },
    "Auerhuhn": {
        "latinName": "Tetrao urogallus",
        "germanName": "Auerhuhn"
    },
    "Austernfischer": {
        "latinName": "Haematopus ostralegus",
        "germanName": "Austernfischer"
    },
    "Aztekenmoewe": {
        "latinName": "Leucophaeus atricilla",
        "germanName": "Aztekenmoewe"
    },
    "Azurelster": {
        "latinName": "Cyanopica cyanus",
        "germanName": "Azurelster"
    },
    "Bachstelze": {
        "latinName": "Motacilla alba",
        "germanName": "Bachstelze"
    },
    "Bahamaente": {
        "latinName": "Anas bahamensis",
        "germanName": "Bahamaente"
    },
    "Bairdstrandlaeufer": {
        "latinName": "Calidris bairdii",
        "germanName": "Bairdstrandlaeufer"
    },
    "Balearensturmtaucher": {
        "latinName": "Puffinus mauretanicus",
        "germanName": "Balearensturmtaucher"
    },
    "Barolosturmtaucher": {
        "latinName": "Puffinus baroli",
        "germanName": "Barolosturmtaucher"
    },
    "Bartgeier": {
        "latinName": "Gypaetus barbatus",
        "germanName": "Bartgeier"
    },
    "Bartlaubsaenger": {
        "latinName": "Phylloscopus schwarzi",
        "germanName": "Bartlaubsaenger"
    },
    "Bartmeise": {
        "latinName": "Panurus biarmicus",
        "germanName": "Bartmeise"
    },
    "Bartmeisen": {
        "latinName": "Familie Panuridae",
        "germanName": "Bartmeisen"
    },
    "Basstoelpel": {
        "latinName": "Morus bassanus",
        "germanName": "Basstoelpel"
    },
    "Baumfalke": {
        "latinName": "Falco subbuteo",
        "germanName": "Baumfalke"
    },
    "Baumlaeufer": {
        "latinName": "Familie Certhiidae",
        "germanName": "Baumlaeufer"
    },
    "Baumpieper": {
        "latinName": "Anthus trivialis",
        "germanName": "Baumpieper"
    },
    "Bekassine": {
        "latinName": "Gallinago gallinago",
        "germanName": "Bekassine"
    },
    "Bergbraunelle": {
        "latinName": "Prunella montanella",
        "germanName": "Bergbraunelle"
    },
    "Bergente": {
        "latinName": "Aythya marila",
        "germanName": "Bergente"
    },
    "Bergfink": {
        "latinName": "Fringilla montifringilla",
        "germanName": "Bergfink"
    },
    "Berghaenfling": {
        "latinName": "Linaria flavirostris",
        "germanName": "Berghaenfling"
    },
    "Bergkalanderlerche": {
        "latinName": "Melanocorypha bimaculata",
        "germanName": "Bergkalanderlerche"
    },
    "Berglaubsaenger": {
        "latinName": "Phylloscopus bonelli",
        "germanName": "Berglaubsaenger"
    },
    "Bergpieper": {
        "latinName": "Anthus spinoletta",
        "germanName": "Bergpieper"
    },
    "Beutelmeise": {
        "latinName": "Remiz pendulinus",
        "germanName": "Beutelmeise"
    },
    "Beutelmeisen": {
        "latinName": "Familie Remizidae",
        "germanName": "Beutelmeisen"
    },
    "Bienenfresser": {
        "latinName": "Merops apiaster",
        "germanName": "Bienenfresser"
    },
    "Bindenkreuzschnabel": {
        "latinName": "Loxia leucoptera",
        "germanName": "Bindenkreuzschnabel"
    },
    "Bindenseeadler": {
        "latinName": "Haliaeetus leucoryphus",
        "germanName": "Bindenseeadler"
    },
    "Bindenstrandlaeufer": {
        "latinName": "Calidris himantopus",
        "germanName": "Bindenstrandlaeufer"
    },
    "Bindentaucher": {
        "latinName": "Podilymbus podiceps",
        "germanName": "Bindentaucher"
    },
    "Birkhuhn": {
        "latinName": "Lyrurus tetrix",
        "germanName": "Birkhuhn"
    },
    "Blaessgans": {
        "latinName": "Anser albifrons",
        "germanName": "Blaessgans"
    },
    "Blaesshuhn": {
        "latinName": "Fulica atra",
        "germanName": "Blaesshuhn"
    },
    "Blassspoetter": {
        "latinName": "Iduna pallida",
        "germanName": "Blassspoetter"
    },
    "Blaufluegelente": {
        "latinName": "Spatula discors",
        "germanName": "Blaufluegelente"
    },
    "Blaukehlchen": {
        "latinName": "Luscinia svecica",
        "germanName": "Blaukehlchen"
    },
    "Blaumerle": {
        "latinName": "Monticola solitarius",
        "germanName": "Blaumerle"
    },
    "Blauracke": {
        "latinName": "Coracias garrulus",
        "germanName": "Blauracke"
    },
    "Blauschwanz": {
        "latinName": "Tarsiger cyanurus",
        "germanName": "Blauschwanz"
    },
    "Blaustirnamazone": {
        "latinName": "Amazona aestiva",
        "germanName": "Blaustirnamazone"
    },
    "Blauwangenspint": {
        "latinName": "Merops persicus",
        "germanName": "Blauwangenspint"
    },
    "Bluthaenfling": {
        "latinName": "Linaria cannabina",
        "germanName": "Bluthaenfling"
    },
    "Blutspecht": {
        "latinName": "Dendrocopos syriacus",
        "germanName": "Blutspecht"
    },
    "Bonapartemoewe": {
        "latinName": "Chroicocephalus philadelphia",
        "germanName": "Bonapartemoewe"
    },
    "Brachpieper": {
        "latinName": "Anthus campestris",
        "germanName": "Brachpieper"
    },
    "Brachschwalbenverwandte": {
        "latinName": "Familie Glareolidae",
        "germanName": "Brachschwalbenverwandte"
    },
    "Brachvogel": {
        "latinName": "Numenius arquata",
        "germanName": "Brachvogel"
    },
    "Brandgans": {
        "latinName": "Tadorna tadorna",
        "germanName": "Brandgans"
    },
    "Brandseeschwalbe": {
        "latinName": "Thalasseus sandvicensis",
        "germanName": "Brandseeschwalbe"
    },
    "Braunellen": {
        "latinName": "Familie Prunellidae",
        "germanName": "Braunellen"
    },
    "Braunkehlchen": {
        "latinName": "Saxicola rubetra",
        "germanName": "Braunkehlchen"
    },
    "Braunkopf-Kuhstaerling": {
        "latinName": "Molothrus ater",
        "germanName": "Braunkopf-Kuhstaerling"
    },
    "Braunkopfammer": {
        "latinName": "Emberiza bruniceps",
        "germanName": "Braunkopfammer"
    },
    "Braunwuerger": {
        "latinName": "Lanius cristatus",
        "germanName": "Braunwuerger"
    },
    "Brautente": {
        "latinName": "Aix sponsa",
        "germanName": "Brautente"
    },
    "Brillenente": {
        "latinName": "Melanitta perspicillata",
        "germanName": "Brillenente"
    },
    "Brillengrasmuecke": {
        "latinName": "Sylvia conspicillata",
        "germanName": "Brillengrasmuecke"
    },
    "Bronzesultanshuhn": {
        "latinName": "Porphyrio alleni",
        "germanName": "Bronzesultanshuhn"
    },
    "Bruchwasserlaeufer": {
        "latinName": "Tringa glareola",
        "germanName": "Bruchwasserlaeufer"
    },
    "Buchfink": {
        "latinName": "Fringilla coelebs",
        "germanName": "Buchfink"
    },
    "Bueffelkopfente": {
        "latinName": "Bucephala albeola",
        "germanName": "Bueffelkopfente"
    },
    "Bulwersturmvogel": {
        "latinName": "Bulweria bulwerii",
        "germanName": "Bulwersturmvogel"
    },
    "Buntfalke": {
        "latinName": "Falco sparverius",
        "germanName": "Buntfalke"
    },
    "Buntfuss-Sturmschwalbe": {
        "latinName": "Oceanites oceanicus",
        "germanName": "Buntfuss-Sturmschwalbe"
    },
    "Buntspecht": {
        "latinName": "Dendrocopos major",
        "germanName": "Buntspecht"
    },
    "Buschrohrsaenger": {
        "latinName": "Acrocephalus dumetorum",
        "germanName": "Buschrohrsaenger"
    },
    "Buschsaenger": {
        "latinName": "Familie Cettiidae",
        "germanName": "Buschsaenger"
    },
    "Buschspoetter": {
        "latinName": "Iduna caligata",
        "germanName": "Buschspoetter"
    },
    "Carolinakrickente": {
        "latinName": "Anas carolinensis",
        "germanName": "Carolinakrickente"
    },
    "Carolinataube": {
        "latinName": "Zenaida macroura",
        "germanName": "Carolinataube"
    },
    "Chileflamingo": {
        "latinName": "Phoenicopterus chilensis",
        "germanName": "Chileflamingo"
    },
    "Corysturmtaucher": {
        "latinName": "Calonectris borealis",
        "germanName": "Corysturmtaucher"
    },
    "Dachsammer": {
        "latinName": "Zonotrichia leucophrys",
        "germanName": "Dachsammer"
    },
    "Dickschnabellumme": {
        "latinName": "Uria lomvia",
        "germanName": "Dickschnabellumme"
    },
    "Dohle": {
        "latinName": "Coloeus monedula",
        "germanName": "Dohle"
    },
    "Doppelschnepfe": {
        "latinName": "Gallinago media",
        "germanName": "Doppelschnepfe"
    },
    "Dorngrasmuecke": {
        "latinName": "Sylvia communis",
        "germanName": "Dorngrasmuecke"
    },
    "Dreifarbenreiher": {
        "latinName": "Egretta tricolor",
        "germanName": "Dreifarbenreiher"
    },
    "Dreizehenmoewe": {
        "latinName": "Rissa tridactyla",
        "germanName": "Dreizehenmoewe"
    },
    "Dreizehenspecht": {
        "latinName": "Picoides tridactylus",
        "germanName": "Dreizehenspecht"
    },
    "Drosseln": {
        "latinName": "Familie Turdidae",
        "germanName": "Drosseln"
    },
    "Drosselrohrsaenger": {
        "latinName": "Acrocephalus arundinaceus",
        "germanName": "Drosselrohrsaenger"
    },
    "Drosseluferlaeufer": {
        "latinName": "Actitis macularius",
        "germanName": "Drosseluferlaeufer"
    },
    "Duennschnabel-Brachvogel": {
        "latinName": "Numenius tenuirostris",
        "germanName": "Duennschnabel-Brachvogel"
    },
    "Duennschnabelmoewe": {
        "latinName": "Chroicocephalus genei",
        "germanName": "Duennschnabelmoewe"
    },
    "Dunkelente": {
        "latinName": "Anas rubripes",
        "germanName": "Dunkelente"
    },
    "Dunkellaubsaenger": {
        "latinName": "Phylloscopus fuscatus",
        "germanName": "Dunkellaubsaenger"
    },
    "Dunkelsturmtaucher": {
        "latinName": "Ardenna grisea",
        "germanName": "Dunkelsturmtaucher"
    },
    "Dunkelwasserlaeufer": {
        "latinName": "Tringa erythropus",
        "germanName": "Dunkelwasserlaeufer"
    },
    "Eichelhaeher": {
        "latinName": "Garrulus glandarius",
        "germanName": "Eichelhaeher"
    },
    "Eiderente": {
        "latinName": "Somateria mollissima",
        "germanName": "Eiderente"
    },
    "Einfarbdrossel": {
        "latinName": "Turdus unicolor",
        "germanName": "Einfarbdrossel"
    },
    "Einsiedler-Musendrossel": {
        "latinName": "Catharus guttatus",
        "germanName": "Einsiedler-Musendrossel"
    },
    "Eisente": {
        "latinName": "Clangula hyemalis",
        "germanName": "Eisente"
    },
    "Eismoewe": {
        "latinName": "Larus hyperboreus",
        "germanName": "Eismoewe"
    },
    "Eissturmvogel": {
        "latinName": "Fulmarus glacialis",
        "germanName": "Eissturmvogel"
    },
    "Eistaucher": {
        "latinName": "Gavia immer",
        "germanName": "Eistaucher"
    },
    "Eisvoegel": {
        "latinName": "Familie Alcedinidae",
        "germanName": "Eisvoegel"
    },
    "Eisvogel": {
        "latinName": "Alcedo atthis",
        "germanName": "Eisvogel"
    },
    "Eleonorenfalke": {
        "latinName": "Falco eleonorae",
        "germanName": "Eleonorenfalke"
    },
    "Elfenbeinmoewe": {
        "latinName": "Pagophila eburnea",
        "germanName": "Elfenbeinmoewe"
    },
    "Elster": {
        "latinName": "Pica pica",
        "germanName": "Elster"
    },
    "Elsterdohle": {
        "latinName": "Coloeus dauuricus",
        "germanName": "Elsterdohle"
    },
    "Erddrossel": {
        "latinName": "Zoothera aurea",
        "germanName": "Erddrossel"
    },
    "Erlenzeisig": {
        "latinName": "Spinus spinus",
        "germanName": "Erlenzeisig"
    },
    "Eulen": {
        "latinName": "Familie Strigidae",
        "germanName": "Eulen"
    },
    "Fahldrossel": {
        "latinName": "Turdus pallidus",
        "germanName": "Fahldrossel"
    },
    "Fahlsegler": {
        "latinName": "Apus pallidus",
        "germanName": "Fahlsegler"
    },
    "Falken": {
        "latinName": "Familie Falconidae",
        "germanName": "Falken"
    },
    "Falkenraubmoewe": {
        "latinName": "Stercorarius longicaudus",
        "germanName": "Falkenraubmoewe"
    },
    "Feldlerche": {
        "latinName": "Alauda arvensis",
        "germanName": "Feldlerche"
    },
    "Feldrohrsaenger": {
        "latinName": "Acrocephalus agricola",
        "germanName": "Feldrohrsaenger"
    },
    "Feldschwirl": {
        "latinName": "Locustella naevia",
        "germanName": "Feldschwirl"
    },
    "Feldsperling": {
        "latinName": "Passer montanus",
        "germanName": "Feldsperling"
    },
    "Felsenschwalbe": {
        "latinName": "Ptyonoprogne rupestris",
        "germanName": "Felsenschwalbe"
    },
    "Fichtenammer": {
        "latinName": "Emberiza leucocephalos",
        "germanName": "Fichtenammer"
    },
    "Fichtenkreuzschnabel": {
        "latinName": "Loxia curvirostra",
        "germanName": "Fichtenkreuzschnabel"
    },
    "Finkenverwandte": {
        "latinName": "Familie Fringillidae",
        "germanName": "Finkenverwandte"
    },
    "Fischadler": {
        "latinName": "Pandion haliaetus",
        "germanName": "Fischadler"
    },
    "Fischmoewe": {
        "latinName": "Ichthyaetus ichthyaetus",
        "germanName": "Fischmoewe"
    },
    "Fitis": {
        "latinName": "Phylloscopus trochilus",
        "germanName": "Fitis"
    },
    "Flussregenpfeifer": {
        "latinName": "Charadrius dubius",
        "germanName": "Flussregenpfeifer"
    },
    "Flussseeschwalbe": {
        "latinName": "Sterna hirundo",
        "germanName": "Flussseeschwalbe"
    },
    "Flussuferlaeufer": {
        "latinName": "Actitis hypoleucos",
        "germanName": "Flussuferlaeufer"
    },
    "Fuchsammer": {
        "latinName": "Passerella iliaca",
        "germanName": "Fuchsammer"
    },
    "Gaensegeier": {
        "latinName": "Gyps fulvus",
        "germanName": "Gaensegeier"
    },
    "Gaensesaeger": {
        "latinName": "Mergus merganser",
        "germanName": "Gaensesaeger"
    },
    "Gartenbaumlaeufer": {
        "latinName": "Certhia brachydactyla",
        "germanName": "Gartenbaumlaeufer"
    },
    "Gartengrasmuecke": {
        "latinName": "Sylvia borin",
        "germanName": "Gartengrasmuecke"
    },
    "Gartenrotschwanz": {
        "latinName": "Phoenicurus phoenicurus",
        "germanName": "Gartenrotschwanz"
    },
    "Gebirgsstelze": {
        "latinName": "Motacilla cinerea",
        "germanName": "Gebirgsstelze"
    },
    "Gelbbrauen-Laubsaenger": {
        "latinName": "Phylloscopus inornatus",
        "germanName": "Gelbbrauen-Laubsaenger"
    },
    "Gelbkehlammer": {
        "latinName": "Emberiza elegans",
        "germanName": "Gelbkehlammer"
    },
    "Gelbkehlvireo": {
        "latinName": "Vireo flavifrons",
        "germanName": "Gelbkehlvireo"
    },
    "Gelbkopfamazone": {
        "latinName": "Amazona oratrix",
        "germanName": "Gelbkopfamazone"
    },
    "Gelbschenkel": {
        "latinName": "Tringa flavipes",
        "germanName": "Gelbschenkel"
    },
    "Gelbschnabeltaucher": {
        "latinName": "Gavia adamsii",
        "germanName": "Gelbschnabeltaucher"
    },
    "Gelbspoetter": {
        "latinName": "Hippolais icterina",
        "germanName": "Gelbspoetter"
    },
    "Gerfalke": {
        "latinName": "Falco rusticolus",
        "germanName": "Gerfalke"
    },
    "Gimpel": {
        "latinName": "Pyrrhula pyrrhula",
        "germanName": "Gimpel"
    },
    "Girlitz": {
        "latinName": "Serinus serinus",
        "germanName": "Girlitz"
    },
    "Gleitaar": {
        "latinName": "Elanus caeruleus",
        "germanName": "Gleitaar"
    },
    "Gluckente": {
        "latinName": "Sibirionetta formosa",
        "germanName": "Gluckente"
    },
    "Goldammer": {
        "latinName": "Emberiza citrinella",
        "germanName": "Goldammer"
    },
    "Goldhaehnchen": {
        "latinName": "Familie Regulidae",
        "germanName": "Goldhaehnchen"
    },
    "Goldhaehnchen-Laubsaenger": {
        "latinName": "Phylloscopus proregulus",
        "germanName": "Goldhaehnchen-Laubsaenger"
    },
    "Goldregenpfeifer": {
        "latinName": "Pluvialis apricaria",
        "germanName": "Goldregenpfeifer"
    },
    "Graslaeufer": {
        "latinName": "Calidris subruficollis",
        "germanName": "Graslaeufer"
    },
    "Grasmueckenverwandte": {
        "latinName": "Familie Sylviidae",
        "germanName": "Grasmueckenverwandte"
    },
    "Grauammer": {
        "latinName": "Emberiza calandra",
        "germanName": "Grauammer"
    },
    "Graubrust-Strandlaeufer": {
        "latinName": "Calidris melanotos",
        "germanName": "Graubrust-Strandlaeufer"
    },
    "Graugans": {
        "latinName": "Anser anser",
        "germanName": "Graugans"
    },
    "Graukopf-Purpurhuhn": {
        "latinName": "Porphyrio poliocephalus",
        "germanName": "Graukopf-Purpurhuhn"
    },
    "Grauortolan": {
        "latinName": "Emberiza caesia",
        "germanName": "Grauortolan"
    },
    "Graureiher": {
        "latinName": "Ardea cinerea",
        "germanName": "Graureiher"
    },
    "Grauschnaepper": {
        "latinName": "Muscicapa striata",
        "germanName": "Grauschnaepper"
    },
    "Grauspecht": {
        "latinName": "Picus canus",
        "germanName": "Grauspecht"
    },
    "Grauwangen-Musendrossel": {
        "latinName": "Catharus minimus",
        "germanName": "Grauwangen-Musendrossel"
    },
    "Grosstrappe": {
        "latinName": "Otis tarda",
        "germanName": "Grosstrappe"
    },
    "Gruenfink": {
        "latinName": "Chloris chloris",
        "germanName": "Gruenfink"
    },
    "Gruenlaubsaenger": {
        "latinName": "Phylloscopus trochiloides",
        "germanName": "Gruenlaubsaenger"
    },
    "Gruenmantel-Waldsaenger": {
        "latinName": "Setophaga virens",
        "germanName": "Gruenmantel-Waldsaenger"
    },
    "Gruenschenkel": {
        "latinName": "Tringa nebularia",
        "germanName": "Gruenschenkel"
    },
    "Gruenspecht": {
        "latinName": "Picus viridis",
        "germanName": "Gruenspecht"
    },
    "Gryllteiste": {
        "latinName": "Cepphus grylle",
        "germanName": "Gryllteiste"
    },
    "Habicht": {
        "latinName": "Accipiter gentilis",
        "germanName": "Habicht"
    },
    "Habichtsadler": {
        "latinName": "Aquila fasciata",
        "germanName": "Habichtsadler"
    },
    "Habichtskauz": {
        "latinName": "Strix uralensis",
        "germanName": "Habichtskauz"
    },
    "Habichtverwandte": {
        "latinName": "Familie Accipitridae",
        "germanName": "Habichtverwandte"
    },
    "Haeherkuckuck": {
        "latinName": "Clamator glandarius",
        "germanName": "Haeherkuckuck"
    },
    "Hakengimpel": {
        "latinName": "Pinicola enucleator",
        "germanName": "Hakengimpel"
    },
    "Halmsaenger": {
        "latinName": "Familie Cisticolidae",
        "germanName": "Halmsaenger"
    },
    "Halsbandschnaepper": {
        "latinName": "Ficedula albicollis",
        "germanName": "Halsbandschnaepper"
    },
    "Halsbandsittich": {
        "latinName": "Psittacula krameri",
        "germanName": "Halsbandsittich"
    },
    "Haselhuhn": {
        "latinName": "Tetrastes bonasia",
        "germanName": "Haselhuhn"
    },
    "Haubenlerche": {
        "latinName": "Galerida cristata",
        "germanName": "Haubenlerche"
    },
    "Haubenmeise": {
        "latinName": "Lophophanes cristatus",
        "germanName": "Haubenmeise"
    },
    "Haubentaucher": {
        "latinName": "Podiceps cristatus",
        "germanName": "Haubentaucher"
    },
    "Hausrotschwanz": {
        "latinName": "Phoenicurus ochruros",
        "germanName": "Hausrotschwanz"
    },
    "Haussegler": {
        "latinName": "Apus affinis",
        "germanName": "Haussegler"
    },
    "Heckenbraunelle": {
        "latinName": "Prunella modularis",
        "germanName": "Heckenbraunelle"
    },
    "Heckensaenger": {
        "latinName": "Cercotrichas galactotes",
        "germanName": "Heckensaenger"
    },
    "Heidelerche": {
        "latinName": "Lullula arborea",
        "germanName": "Heidelerche"
    },
    "Heringsmoewe": {
        "latinName": "Larus fuscus",
        "germanName": "Heringsmoewe"
    },
    "Hirtenmaina": {
        "latinName": "Acridotheres tristis",
        "germanName": "Hirtenmaina"
    },
    "Hoeckergans": {
        "latinName": "Anser cygnoid f. domestica",
        "germanName": "Hoeckergans"
    },
    "Hoeckerschwan": {
        "latinName": "Cygnus olor",
        "germanName": "Hoeckerschwan"
    },
    "Hohltaube": {
        "latinName": "Columba oenas",
        "germanName": "Hohltaube"
    },
    "Iberienzilpzalp": {
        "latinName": "Phylloscopus ibericus",
        "germanName": "Iberienzilpzalp"
    },
    "Ibisse": {
        "latinName": "Familie Threskiornithidae",
        "germanName": "Ibisse"
    },
    "Indien-Fleckschnabelente": {
        "latinName": "Anas poecilorhyncha",
        "germanName": "Indien-Fleckschnabelente"
    },
    "Indigofink": {
        "latinName": "Passerina cyanea",
        "germanName": "Indigofink"
    },
    "Isabellsteinschmaetzer": {
        "latinName": "Oenanthe isabellina",
        "germanName": "Isabellsteinschmaetzer"
    },
    "Isabellwuerger": {
        "latinName": "Lanius isabellinus",
        "germanName": "Isabellwuerger"
    },
    "Jagdfasan": {
        "latinName": "Phasianus colchicus",
        "germanName": "Jagdfasan"
    },
    "Jungfernkranich": {
        "latinName": "Grus virgo",
        "germanName": "Jungfernkranich"
    },
    "Kaiseradler": {
        "latinName": "Aquila heliaca",
        "germanName": "Kaiseradler"
    },
    "Kalanderlerche": {
        "latinName": "Melanocorypha calandra",
        "germanName": "Kalanderlerche"
    },
    "Kampflaeufer": {
        "latinName": "Calidris pugnax",
        "germanName": "Kampflaeufer"
    },
    "Kamtschatkasamtente": {
        "latinName": "Melanitta stejnegeri",
        "germanName": "Kamtschatkasamtente"
    },
    "Kanadabergente": {
        "latinName": "Aythya affinis",
        "germanName": "Kanadabergente"
    },
    "Kanadagans": {
        "latinName": "Branta canadensis",
        "germanName": "Kanadagans"
    },
    "Kanadakranich": {
        "latinName": "Antigone canadensis",
        "germanName": "Kanadakranich"
    },
    "Kanadamoewe": {
        "latinName": "Larus smithsonianus",
        "germanName": "Kanadamoewe"
    },
    "Kanadapfeifente": {
        "latinName": "Mareca americana",
        "germanName": "Kanadapfeifente"
    },
    "Kappenammer": {
        "latinName": "Emberiza melanocephala",
        "germanName": "Kappenammer"
    },
    "Kappensaeger": {
        "latinName": "Lophodytes cucullatus",
        "germanName": "Kappensaeger"
    },
    "Kappensturmtaucher": {
        "latinName": "Ardenna gravis",
        "germanName": "Kappensturmtaucher"
    },
    "Karmingimpel": {
        "latinName": "Carpodacus erythrinus",
        "germanName": "Karmingimpel"
    },
    "Katzenspottdrossel": {
        "latinName": "Dumetella carolinensis",
        "germanName": "Katzenspottdrossel"
    },
    "Kernbeisser": {
        "latinName": "Coccothraustes coccothraustes",
        "germanName": "Kernbeisser"
    },
    "Kiebitz": {
        "latinName": "Vanellus vanellus",
        "germanName": "Kiebitz"
    },
    "Kiebitzregenpfeifer": {
        "latinName": "Pluvialis squatarola",
        "germanName": "Kiebitzregenpfeifer"
    },
    "Kiefernkreuzschnabel": {
        "latinName": "Loxia pytyopsittacus",
        "germanName": "Kiefernkreuzschnabel"
    },
    "Klappergrasmuecke": {
        "latinName": "Sylvia curruca",
        "germanName": "Klappergrasmuecke"
    },
    "Kleiber": {
        "latinName": "Sitta europaea",
        "germanName": "Kleiber"
    },
    "Kleinspecht": {
        "latinName": "Dryobates minor",
        "germanName": "Kleinspecht"
    },
    "Kleinsumpfhuhn": {
        "latinName": "Zapornia parva",
        "germanName": "Kleinsumpfhuhn"
    },
    "Knaekente": {
        "latinName": "Spatula querquedula",
        "germanName": "Knaekente"
    },
    "Knutt": {
        "latinName": "Calidris canutus",
        "germanName": "Knutt"
    },
    "Kolbenente": {
        "latinName": "Netta rufina",
        "germanName": "Kolbenente"
    },
    "Kolkrabe": {
        "latinName": "Corvus corax",
        "germanName": "Kolkrabe"
    },
    "Korallenmoewe": {
        "latinName": "Ichthyaetus audouinii",
        "germanName": "Korallenmoewe"
    },
    "Kormoran": {
        "latinName": "Phalacrocorax carbo",
        "germanName": "Kormoran"
    },
    "Kornweihe": {
        "latinName": "Circus cyaneus",
        "germanName": "Kornweihe"
    },
    "Krabbentaucher": {
        "latinName": "Alle alle",
        "germanName": "Krabbentaucher"
    },
    "Kraehenscharbe": {
        "latinName": "Phalacrocorax aristotelis",
        "germanName": "Kraehenscharbe"
    },
    "Kraehenverwandte": {
        "latinName": "Familie Corvidae",
        "germanName": "Kraehenverwandte"
    },
    "Kragenente": {
        "latinName": "Histrionicus histrionicus",
        "germanName": "Kragenente"
    },
    "Kranich": {
        "latinName": "Grus grus",
        "germanName": "Kranich"
    },
    "Kraniche": {
        "latinName": "Familie Gruidae",
        "germanName": "Kraniche"
    },
    "Krauskopfpelikan": {
        "latinName": "Pelecanus crispus",
        "germanName": "Krauskopfpelikan"
    },
    "Krickente": {
        "latinName": "Anas crecca",
        "germanName": "Krickente"
    },
    "Kronenlaubsaenger": {
        "latinName": "Phylloscopus coronatus",
        "germanName": "Kronenlaubsaenger"
    },
    "Kubaflamingo": {
        "latinName": "Phoenicopterus ruber",
        "germanName": "Kubaflamingo"
    },
    "Kuckuck": {
        "latinName": "Cuculus canorus",
        "germanName": "Kuckuck"
    },
    "Kuestenreiher": {
        "latinName": "Egretta gularis",
        "germanName": "Kuestenreiher"
    },
    "Kuestenseeschwalbe": {
        "latinName": "Sterna paradisaea",
        "germanName": "Kuestenseeschwalbe"
    },
    "Kuhreiher": {
        "latinName": "Bubulcus ibis",
        "germanName": "Kuhreiher"
    },
    "Kurzschnabelgans": {
        "latinName": "Anser brachyrhynchus",
        "germanName": "Kurzschnabelgans"
    },
    "Kurzzehenlerche": {
        "latinName": "Calandrella brachydactyla",
        "germanName": "Kurzzehenlerche"
    },
    "Lachmoewe": {
        "latinName": "Chroicocephalus ridibundus",
        "germanName": "Lachmoewe"
    },
    "Lachseeschwalbe": {
        "latinName": "Gelochelidon nilotica",
        "germanName": "Lachseeschwalbe"
    },
    "Langzehen-Strandlaeufer": {
        "latinName": "Calidris subminuta",
        "germanName": "Langzehen-Strandlaeufer"
    },
    "Lannerfalke": {
        "latinName": "Falco biarmicus",
        "germanName": "Lannerfalke"
    },
    "Lasurmeise": {
        "latinName": "Cyanistes cyanus",
        "germanName": "Lasurmeise"
    },
    "Laubsaenger": {
        "latinName": "Familie Phylloscopidae",
        "germanName": "Laubsaenger"
    },
    "Lazulifink": {
        "latinName": "Passerina amoena",
        "germanName": "Lazulifink"
    },
    "Lerchen": {
        "latinName": "Familie Alaudidae",
        "germanName": "Lerchen"
    },
    "Ligurien-Bartgrasmuecke": {
        "latinName": "Sylvia subalpina",
        "germanName": "Ligurien-Bartgrasmuecke"
    },
    "Loeffelente": {
        "latinName": "Spatula clypeata",
        "germanName": "Loeffelente"
    },
    "Loeffler": {
        "latinName": "Platalea leucorodia",
        "germanName": "Loeffler"
    },
    "Maeusebussard": {
        "latinName": "Buteo buteo",
        "germanName": "Maeusebussard"
    },
    "Mandarinente": {
        "latinName": "Aix galericulata",
        "germanName": "Mandarinente"
    },
    "Mantelmoewe": {
        "latinName": "Larus marinus",
        "germanName": "Mantelmoewe"
    },
    "Mariskenrohrsaenger": {
        "latinName": "Acrocephalus melanopogon",
        "germanName": "Mariskenrohrsaenger"
    },
    "Marmelente": {
        "latinName": "Marmaronetta angustirostris",
        "germanName": "Marmelente"
    },
    "Maskenammer": {
        "latinName": "Emberiza spodocephala",
        "germanName": "Maskenammer"
    },
    "Maskenwuerger": {
        "latinName": "Lanius nubicus",
        "germanName": "Maskenwuerger"
    },
    "Mauerlaeufer": {
        "latinName": "Tichodroma muraria",
        "germanName": "Mauerlaeufer"
    },
    "Mauersegler": {
        "latinName": "Apus apus",
        "germanName": "Mauersegler"
    },
    "Meerstrandlaeufer": {
        "latinName": "Calidris maritima",
        "germanName": "Meerstrandlaeufer"
    },
    "Mehlschwalbe": {
        "latinName": "Delichon urbicum",
        "germanName": "Mehlschwalbe"
    },
    "Meisen": {
        "latinName": "Familie Paridae",
        "germanName": "Meisen"
    },
    "Meisengimpel": {
        "latinName": "Carpodacus sibiricus",
        "germanName": "Meisengimpel"
    },
    "Meisenwaldsaenger": {
        "latinName": "Setophaga americana",
        "germanName": "Meisenwaldsaenger"
    },
    "Merlin": {
        "latinName": "Falco columbarius",
        "germanName": "Merlin"
    },
    "Middendorff-Laubsaenger": {
        "latinName": "Phylloscopus plumbeitarsus",
        "germanName": "Middendorff-Laubsaenger"
    },
    "Misteldrossel": {
        "latinName": "Turdus viscivorus",
        "germanName": "Misteldrossel"
    },
    "Mittelmeer-Steinschmaetzer*": {
        "latinName": "Oenanthe hispanica",
        "germanName": "Mittelmeer-Steinschmaetzer*"
    },
    "Mittelmeermoewe": {
        "latinName": "Larus michahellis",
        "germanName": "Mittelmeermoewe"
    },
    "Mittelsaeger": {
        "latinName": "Mergus serrator",
        "germanName": "Mittelsaeger"
    },
    "Mittelspecht": {
        "latinName": "Dendrocoptes medius",
        "germanName": "Mittelspecht"
    },
    "Moenchsgeier": {
        "latinName": "Aegypius monachus",
        "germanName": "Moenchsgeier"
    },
    "Moenchsgrasmuecke": {
        "latinName": "Sylvia atricapilla",
        "germanName": "Moenchsgrasmuecke"
    },
    "Moewenverwandte": {
        "latinName": "Familie Laridae",
        "germanName": "Moewenverwandte"
    },
    "Mongolenstar": {
        "latinName": "Agropsar sturninus",
        "germanName": "Mongolenstar"
    },
    "Moorente": {
        "latinName": "Aythya nyroca",
        "germanName": "Moorente"
    },
    "Moorschlammlaeufer": {
        "latinName": "Limnodromus griseus",
        "germanName": "Moorschlammlaeufer"
    },
    "Mornellregenpfeifer": {
        "latinName": "Charadrius morinellus",
        "germanName": "Mornellregenpfeifer"
    },
    "Moschusente": {
        "latinName": "Cairina moschata",
        "germanName": "Moschusente"
    },
    "Nachtigall": {
        "latinName": "Luscinia megarhynchos",
        "germanName": "Nachtigall"
    },
    "Nachtreiher": {
        "latinName": "Nycticorax nycticorax",
        "germanName": "Nachtreiher"
    },
    "Nachtschwalbe": {
        "latinName": "Caprimulgus europaeus",
        "germanName": "Nachtschwalbe"
    },
    "Nandu": {
        "latinName": "Rhea americana",
        "germanName": "Nandu"
    },
    "Nebelkraehe": {
        "latinName": "Corvus cornix",
        "germanName": "Nebelkraehe"
    },
    "Neuntoeter": {
        "latinName": "Lanius collurio",
        "germanName": "Neuntoeter"
    },
    "Nilgans": {
        "latinName": "Alopochen aegyptiaca",
        "germanName": "Nilgans"
    },
    "Noddi": {
        "latinName": "Anous stolidus",
        "germanName": "Noddi"
    },
    "Nonnensteinschmaetzer": {
        "latinName": "Oenanthe pleschanka",
        "germanName": "Nonnensteinschmaetzer"
    },
    "Odinshuehnchen": {
        "latinName": "Phalaropus lobatus",
        "germanName": "Odinshuehnchen"
    },
    "Ohrenlerche": {
        "latinName": "Eremophila alpestris",
        "germanName": "Ohrenlerche"
    },
    "Ohrenscharbe": {
        "latinName": "Phalacrocorax auritus",
        "germanName": "Ohrenscharbe"
    },
    "Ohrentaucher": {
        "latinName": "Podiceps auritus",
        "germanName": "Ohrentaucher"
    },
    "Orientturteltaube": {
        "latinName": "Streptopelia orientalis",
        "germanName": "Orientturteltaube"
    },
    "Orpheusgrasmuecke": {
        "latinName": "Sylvia hortensis",
        "germanName": "Orpheusgrasmuecke"
    },
    "Orpheusspoetter": {
        "latinName": "Hippolais polyglotta",
        "germanName": "Orpheusspoetter"
    },
    "Ortolan": {
        "latinName": "Emberiza hortulana",
        "germanName": "Ortolan"
    },
    "Pallasschwarzkehlchen": {
        "latinName": "Saxicola maurus",
        "germanName": "Pallasschwarzkehlchen"
    },
    "Palmtaube": {
        "latinName": "Spilopelia senegalensis",
        "germanName": "Palmtaube"
    },
    "Papageitaucher": {
        "latinName": "Fratercula arctica",
        "germanName": "Papageitaucher"
    },
    "Pazifikpieper": {
        "latinName": "Anthus rubescens",
        "germanName": "Pazifikpieper"
    },
    "Pazifiksegler": {
        "latinName": "Apus pacificus",
        "germanName": "Pazifiksegler"
    },
    "Pazifiktrauerente": {
        "latinName": "Melanitta americana",
        "germanName": "Pazifiktrauerente"
    },
    "Pelikane": {
        "latinName": "Familie Pelecanidae",
        "germanName": "Pelikane"
    },
    "Petschorapieper": {
        "latinName": "Anthus gustavi",
        "germanName": "Petschorapieper"
    },
    "Pfeifente": {
        "latinName": "Mareca penelope",
        "germanName": "Pfeifente"
    },
    "Pfuhlschnepfe": {
        "latinName": "Limosa lapponica",
        "germanName": "Pfuhlschnepfe"
    },
    "Pharaonenibis": {
        "latinName": "Threskiornis aethiopicus",
        "germanName": "Pharaonenibis"
    },
    "Pharaonennachtschwalbe": {
        "latinName": "Caprimulgus aegyptius",
        "germanName": "Pharaonennachtschwalbe"
    },
    "Pirol": {
        "latinName": "Oriolus oriolus",
        "germanName": "Pirol"
    },
    "Pirole": {
        "latinName": "Familie Oriolidae",
        "germanName": "Pirole"
    },
    "Polarbirkenzeisig": {
        "latinName": "Acanthis hornemanni",
        "germanName": "Polarbirkenzeisig"
    },
    "Polarmoewe": {
        "latinName": "Larus glaucoides",
        "germanName": "Polarmoewe"
    },
    "Prachteiderente": {
        "latinName": "Somateria spectabilis",
        "germanName": "Prachteiderente"
    },
    "Prachttaucher": {
        "latinName": "Gavia arctica",
        "germanName": "Prachttaucher"
    },
    "Praerie-Goldregenpfeifer": {
        "latinName": "Pluvialis dominica",
        "germanName": "Praerie-Goldregenpfeifer"
    },
    "Praerielaeufer": {
        "latinName": "Bartramia longicauda",
        "germanName": "Praerielaeufer"
    },
    "Praeriemoewe": {
        "latinName": "Leucophaeus pipixcan",
        "germanName": "Praeriemoewe"
    },
    "Provencegrasmuecke": {
        "latinName": "Sylvia undata",
        "germanName": "Provencegrasmuecke"
    },
    "Purpurhuhn": {
        "latinName": "Porphyrio porphyrio",
        "germanName": "Purpurhuhn"
    },
    "Purpurreiher": {
        "latinName": "Ardea purpurea",
        "germanName": "Purpurreiher"
    },
    "Rabenkraehe": {
        "latinName": "Corvus corone",
        "germanName": "Rabenkraehe"
    },
    "Racken": {
        "latinName": "Familie Coraciidae",
        "germanName": "Racken"
    },
    "Rallenreiher": {
        "latinName": "Ardeola ralloides",
        "germanName": "Rallenreiher"
    },
    "Raubmoewen": {
        "latinName": "Familie Stercorariidae",
        "germanName": "Raubmoewen"
    },
    "Raubseeschwalbe": {
        "latinName": "Hydroprogne caspia",
        "germanName": "Raubseeschwalbe"
    },
    "Raubwuerger": {
        "latinName": "Lanius excubitor",
        "germanName": "Raubwuerger"
    },
    "Rauchschwalbe": {
        "latinName": "Hirundo rustica",
        "germanName": "Rauchschwalbe"
    },
    "Raufussbussard": {
        "latinName": "Buteo lagopus",
        "germanName": "Raufussbussard"
    },
    "Raufusskauz": {
        "latinName": "Aegolius funereus",
        "germanName": "Raufusskauz"
    },
    "Rebhuhn": {
        "latinName": "Perdix perdix",
        "germanName": "Rebhuhn"
    },
    "Regenbrachvogel": {
        "latinName": "Numenius phaeopus",
        "germanName": "Regenbrachvogel"
    },
    "Regenpfeiferverwandte": {
        "latinName": "Familie Charadriidae",
        "germanName": "Regenpfeiferverwandte"
    },
    "Reiher": {
        "latinName": "Familie Ardeidae",
        "germanName": "Reiher"
    },
    "Reiherente": {
        "latinName": "Aythya fuligula",
        "germanName": "Reiherente"
    },
    "Rennvogel": {
        "latinName": "Cursorius cursor",
        "germanName": "Rennvogel"
    },
    "Riesenseeadler": {
        "latinName": "Haliaeetus pelagicus",
        "germanName": "Riesenseeadler"
    },
    "Riesentafelente": {
        "latinName": "Aythya valisineria",
        "germanName": "Riesentafelente"
    },
    "Ringdrossel": {
        "latinName": "Turdus torquatus",
        "germanName": "Ringdrossel"
    },
    "Ringelgans": {
        "latinName": "Branta bernicla",
        "germanName": "Ringelgans"
    },
    "Ringeltaube": {
        "latinName": "Columba palumbus",
        "germanName": "Ringeltaube"
    },
    "Ringschnabelente": {
        "latinName": "Aythya collaris",
        "germanName": "Ringschnabelente"
    },
    "Ringschnabelmoewe": {
        "latinName": "Larus delawarensis",
        "germanName": "Ringschnabelmoewe"
    },
    "Roetelfalke": {
        "latinName": "Falco naumanni",
        "germanName": "Roetelfalke"
    },
    "Roetelpelikan": {
        "latinName": "Pelecanus rufescens",
        "germanName": "Roetelpelikan"
    },
    "Roetelschwalbe": {
        "latinName": "Cecropis daurica",
        "germanName": "Roetelschwalbe"
    },
    "Rohrammer": {
        "latinName": "Emberiza schoeniclus",
        "germanName": "Rohrammer"
    },
    "Rohrdommel": {
        "latinName": "Botaurus stellaris",
        "germanName": "Rohrdommel"
    },
    "Rohrsaengerverwandte": {
        "latinName": "Familie Acrocephalidae",
        "germanName": "Rohrsaengerverwandte"
    },
    "Rohrschwirl": {
        "latinName": "Locustella luscinioides",
        "germanName": "Rohrschwirl"
    },
    "Rohrweihe": {
        "latinName": "Circus aeruginosus",
        "germanName": "Rohrweihe"
    },
    "Rosaflamingo": {
        "latinName": "Phoenicopterus roseus",
        "germanName": "Rosaflamingo"
    },
    "Rosapelikan": {
        "latinName": "Pelecanus onocrotalus",
        "germanName": "Rosapelikan"
    },
    "Rosenbrust-Kernknacker": {
        "latinName": "Pheucticus ludovicianus",
        "germanName": "Rosenbrust-Kernknacker"
    },
    "Rosenmoewe": {
        "latinName": "Rhodostethia rosea",
        "germanName": "Rosenmoewe"
    },
    "Rosenseeschwalbe": {
        "latinName": "Sterna dougallii",
        "germanName": "Rosenseeschwalbe"
    },
    "Rosenstar": {
        "latinName": "Pastor roseus",
        "germanName": "Rosenstar"
    },
    "Rostfluegeldrossel": {
        "latinName": "Turdus eunomus",
        "germanName": "Rostfluegeldrossel"
    },
    "Rostgans": {
        "latinName": "Tadorna ferruginea",
        "germanName": "Rostgans"
    },
    "Rostschwanzdrossel": {
        "latinName": "Turdus naumanni",
        "germanName": "Rostschwanzdrossel"
    },
    "Rotaugenvireo": {
        "latinName": "Vireo olivaceus",
        "germanName": "Rotaugenvireo"
    },
    "Rotdrossel": {
        "latinName": "Turdus iliacus",
        "germanName": "Rotdrossel"
    },
    "Rotfluegel-Brachschwalbe": {
        "latinName": "Glareola pratincola",
        "germanName": "Rotfluegel-Brachschwalbe"
    },
    "Rotfussfalke": {
        "latinName": "Falco vespertinus",
        "germanName": "Rotfussfalke"
    },
    "Rotgesichtloeffler": {
        "latinName": "Platalea alba",
        "germanName": "Rotgesichtloeffler"
    },
    "Rothalsgans": {
        "latinName": "Branta ruficollis",
        "germanName": "Rothalsgans"
    },
    "Rothalstaucher": {
        "latinName": "Podiceps grisegena",
        "germanName": "Rothalstaucher"
    },
    "Rothuhn": {
        "latinName": "Alectoris rufa",
        "germanName": "Rothuhn"
    },
    "Rotkehl-Strandlaeufer": {
        "latinName": "Calidris ruficollis",
        "germanName": "Rotkehl-Strandlaeufer"
    },
    "Rotkehldrossel": {
        "latinName": "Turdus ruficollis",
        "germanName": "Rotkehldrossel"
    },
    "Rotkehlpieper": {
        "latinName": "Anthus cervinus",
        "germanName": "Rotkehlpieper"
    },
    "Rotkopfente": {
        "latinName": "Aythya americana",
        "germanName": "Rotkopfente"
    },
    "Rotkopfwuerger": {
        "latinName": "Lanius senator",
        "germanName": "Rotkopfwuerger"
    },
    "Rotmilan": {
        "latinName": "Milvus milvus",
        "germanName": "Rotmilan"
    },
    "Rotschenkel": {
        "latinName": "Tringa totanus",
        "germanName": "Rotschenkel"
    },
    "Rotschulterente": {
        "latinName": "Callonetta leucophrys",
        "germanName": "Rotschulterente"
    },
    "Rotschwanzwuerger": {
        "latinName": "Lanius phoenicuroides",
        "germanName": "Rotschwanzwuerger"
    },
    "Rubinkehlchen": {
        "latinName": "Calliope calliope",
        "germanName": "Rubinkehlchen"
    },
    "Rueppellseeschwalbe": {
        "latinName": "Thalasseus bengalensis",
        "germanName": "Rueppellseeschwalbe"
    },
    "Russschnaepper": {
        "latinName": "Muscicapa sibirica",
        "germanName": "Russschnaepper"
    },
    "Russseeschwalbe": {
        "latinName": "Onychoprion fuscatus",
        "germanName": "Russseeschwalbe"
    },
    "SPERLINGSVoeGEL": {
        "latinName": "ORDNUNG PASSERIFORMES",
        "germanName": "SPERLINGSVoeGEL"
    },
    "Saatkraehe": {
        "latinName": "Corvus frugilegus",
        "germanName": "Saatkraehe"
    },
    "Saebelschnaebler": {
        "latinName": "Recurvirostra avosetta",
        "germanName": "Saebelschnaebler"
    },
    "Saebelschnaeblerverwandte": {
        "latinName": "Familie Recurvirostridae",
        "germanName": "Saebelschnaeblerverwandte"
    },
    "Saharasteinschmaetzer": {
        "latinName": "Oenanthe leucopyga",
        "germanName": "Saharasteinschmaetzer"
    },
    "Samtente": {
        "latinName": "Melanitta fusca",
        "germanName": "Samtente"
    },
    "Samtkopf-Grasmuecke": {
        "latinName": "Sylvia melanocephala",
        "germanName": "Samtkopf-Grasmuecke"
    },
    "Sanderling": {
        "latinName": "Calidris alba",
        "germanName": "Sanderling"
    },
    "Sandflughuhn": {
        "latinName": "Pterocles orientalis",
        "germanName": "Sandflughuhn"
    },
    "Sandregenpfeifer": {
        "latinName": "Charadrius hiaticula",
        "germanName": "Sandregenpfeifer"
    },
    "Sandstrandlaeufer": {
        "latinName": "Calidris pusilla",
        "germanName": "Sandstrandlaeufer"
    },
    "Schafstelze": {
        "latinName": "Motacilla flava",
        "germanName": "Schafstelze"
    },
    "Scharben": {
        "latinName": "Familie Phalacrocoracidae",
        "germanName": "Scharben"
    },
    "Scheckente": {
        "latinName": "Polysticta stelleri",
        "germanName": "Scheckente"
    },
    "Schelladler": {
        "latinName": "Clanga clanga",
        "germanName": "Schelladler"
    },
    "Schellente": {
        "latinName": "Bucephala clangula",
        "germanName": "Schellente"
    },
    "Schieferdrossel": {
        "latinName": "Geokichla sibirica",
        "germanName": "Schieferdrossel"
    },
    "Schilfrohrsaenger": {
        "latinName": "Acrocephalus schoenobaenus",
        "germanName": "Schilfrohrsaenger"
    },
    "Schlagschwirl": {
        "latinName": "Locustella fluviatilis",
        "germanName": "Schlagschwirl"
    },
    "Schlangenadler": {
        "latinName": "Circaetus gallicus",
        "germanName": "Schlangenadler"
    },
    "Schleiereule": {
        "latinName": "Tyto alba",
        "germanName": "Schleiereule"
    },
    "Schleiereulen": {
        "latinName": "Familie Tytonidae",
        "germanName": "Schleiereulen"
    },
    "Schmarotzerraubmoewe": {
        "latinName": "Stercorarius parasiticus",
        "germanName": "Schmarotzerraubmoewe"
    },
    "Schmuckreiher": {
        "latinName": "Egretta thula",
        "germanName": "Schmuckreiher"
    },
    "Schmuckseeschwalbe": {
        "latinName": "Thalasseus elegans",
        "germanName": "Schmuckseeschwalbe"
    },
    "Schmutzgeier": {
        "latinName": "Neophron percnopterus",
        "germanName": "Schmutzgeier"
    },
    "Schnaepperverwandte": {
        "latinName": "Familie Muscicapidae",
        "germanName": "Schnaepperverwandte"
    },
    "Schnatterente": {
        "latinName": "Mareca strepera",
        "germanName": "Schnatterente"
    },
    "Schneeammer": {
        "latinName": "Plectrophenax nivalis",
        "germanName": "Schneeammer"
    },
    "Schneeeule": {
        "latinName": "Bubo scandiacus",
        "germanName": "Schneeeule"
    },
    "Schneegans": {
        "latinName": "Anser caerulescens",
        "germanName": "Schneegans"
    },
    "Schneesperling": {
        "latinName": "Montifringilla nivalis",
        "germanName": "Schneesperling"
    },
    "Schnepfenverwandte": {
        "latinName": "Familie Scolopacidae",
        "germanName": "Schnepfenverwandte"
    },
    "Schreiadler": {
        "latinName": "Clanga pomarina",
        "germanName": "Schreiadler"
    },
    "Schwalben": {
        "latinName": "Familie Hirundinidae",
        "germanName": "Schwalben"
    },
    "Schwalbenmoewe": {
        "latinName": "Xema sabini",
        "germanName": "Schwalbenmoewe"
    },
    "Schwanzmeise": {
        "latinName": "Aegithalos caudatus",
        "germanName": "Schwanzmeise"
    },
    "Schwanzmeisen": {
        "latinName": "Familie Aegithalidae",
        "germanName": "Schwanzmeisen"
    },
    "Schwarzbrauenalbatros": {
        "latinName": "Thalassarche melanophris",
        "germanName": "Schwarzbrauenalbatros"
    },
    "Schwarzfluegel-Brachschwalbe": {
        "latinName": "Glareola nordmanni",
        "germanName": "Schwarzfluegel-Brachschwalbe"
    },
    "Schwarzhalsreiher": {
        "latinName": "Ardea melanocephala",
        "germanName": "Schwarzhalsreiher"
    },
    "Schwarzhalstaucher": {
        "latinName": "Podiceps nigricollis",
        "germanName": "Schwarzhalstaucher"
    },
    "Schwarzkehlbraunelle": {
        "latinName": "Prunella atrogularis",
        "germanName": "Schwarzkehlbraunelle"
    },
    "Schwarzkehlchen": {
        "latinName": "Saxicola rubicola",
        "germanName": "Schwarzkehlchen"
    },
    "Schwarzkehldrossel": {
        "latinName": "Turdus atrogularis",
        "germanName": "Schwarzkehldrossel"
    },
    "Schwarzkopf-Ruderente": {
        "latinName": "Oxyura jamaicensis",
        "germanName": "Schwarzkopf-Ruderente"
    },
    "Schwarzkopfmoewe": {
        "latinName": "Ichthyaetus melanocephalus",
        "germanName": "Schwarzkopfmoewe"
    },
    "Schwarzmilan": {
        "latinName": "Milvus migrans",
        "germanName": "Schwarzmilan"
    },
    "Schwarzschnabelkuckuck": {
        "latinName": "Coccyzus erythropthalmus",
        "germanName": "Schwarzschnabelkuckuck"
    },
    "Schwarzschwan": {
        "latinName": "Cygnus atratus",
        "germanName": "Schwarzschwan"
    },
    "Schwarzspecht": {
        "latinName": "Dryocopus martius",
        "germanName": "Schwarzspecht"
    },
    "Schwarzsteppenlerche": {
        "latinName": "Melanocorypha yeltoniensis",
        "germanName": "Schwarzsteppenlerche"
    },
    "Schwarzstirnwuerger": {
        "latinName": "Lanius minor",
        "germanName": "Schwarzstirnwuerger"
    },
    "Schwarzstorch": {
        "latinName": "Ciconia nigra",
        "germanName": "Schwarzstorch"
    },
    "Schwirlverwandte": {
        "latinName": "Familie Locustellidae",
        "germanName": "Schwirlverwandte"
    },
    "Seeadler": {
        "latinName": "Haliaeetus albicilla",
        "germanName": "Seeadler"
    },
    "Seeregenpfeifer": {
        "latinName": "Charadrius alexandrinus",
        "germanName": "Seeregenpfeifer"
    },
    "Seggenrohrsaenger": {
        "latinName": "Acrocephalus paludicola",
        "germanName": "Seggenrohrsaenger"
    },
    "Seidenreiher": {
        "latinName": "Egretta garzetta",
        "germanName": "Seidenreiher"
    },
    "Seidensaenger": {
        "latinName": "Cettia cetti",
        "germanName": "Seidensaenger"
    },
    "Seidenschwaenze": {
        "latinName": "Familie Bombycillidae",
        "germanName": "Seidenschwaenze"
    },
    "Seidenschwanz": {
        "latinName": "Bombycilla garrulus",
        "germanName": "Seidenschwanz"
    },
    "Sepiasturmtaucher": {
        "latinName": "Calonectris diomedea",
        "germanName": "Sepiasturmtaucher"
    },
    "Sichelente": {
        "latinName": "Mareca falcata",
        "germanName": "Sichelente"
    },
    "Sichelstrandlaeufer": {
        "latinName": "Calidris ferruginea",
        "germanName": "Sichelstrandlaeufer"
    },
    "Sichler": {
        "latinName": "Plegadis falcinellus",
        "germanName": "Sichler"
    },
    "Silbermoewe": {
        "latinName": "Larus argentatus",
        "germanName": "Silbermoewe"
    },
    "Silberreiher": {
        "latinName": "Ardea alba",
        "germanName": "Silberreiher"
    },
    "Singammer": {
        "latinName": "Melospiza melodia",
        "germanName": "Singammer"
    },
    "Singdrossel": {
        "latinName": "Turdus philomelos",
        "germanName": "Singdrossel"
    },
    "Singschwan": {
        "latinName": "Cygnus cygnus",
        "germanName": "Singschwan"
    },
    "Skua": {
        "latinName": "Stercorarius skua",
        "germanName": "Skua"
    },
    "Sommergoldhaehnchen": {
        "latinName": "Regulus ignicapilla",
        "germanName": "Sommergoldhaehnchen"
    },
    "Spatelente": {
        "latinName": "Bucephala islandica",
        "germanName": "Spatelente"
    },
    "Spatelraubmoewe": {
        "latinName": "Stercorarius pomarinus",
        "germanName": "Spatelraubmoewe"
    },
    "Spechte": {
        "latinName": "Familie Picidae",
        "germanName": "Spechte"
    },
    "Sperber": {
        "latinName": "Accipiter nisus",
        "germanName": "Sperber"
    },
    "Sperbereule": {
        "latinName": "Surnia ulula",
        "germanName": "Sperbereule"
    },
    "Sperbergeier": {
        "latinName": "Gyps rueppelli",
        "germanName": "Sperbergeier"
    },
    "Sperbergrasmuecke": {
        "latinName": "Sylvia nisoria",
        "germanName": "Sperbergrasmuecke"
    },
    "Sperlinge": {
        "latinName": "Familie Passeridae",
        "germanName": "Sperlinge"
    },
    "Sperlingskauz": {
        "latinName": "Glaucidium passerinum",
        "germanName": "Sperlingskauz"
    },
    "Spiessente": {
        "latinName": "Anas acuta",
        "germanName": "Spiessente"
    },
    "Spiessflughuhn": {
        "latinName": "Pterocles alchata",
        "germanName": "Spiessflughuhn"
    },
    "Spinte": {
        "latinName": "Familie Meropidae",
        "germanName": "Spinte"
    },
    "Spitzschwanz-Strandlaeufer": {
        "latinName": "Calidris acuminata",
        "germanName": "Spitzschwanz-Strandlaeufer"
    },
    "Spornammer": {
        "latinName": "Calcarius lapponicus",
        "germanName": "Spornammer"
    },
    "Spornkiebitz": {
        "latinName": "Vanellus spinosus",
        "germanName": "Spornkiebitz"
    },
    "Spornpieper": {
        "latinName": "Anthus richardi",
        "germanName": "Spornpieper"
    },
    "Spottdrosseln": {
        "latinName": "Familie Mimidae",
        "germanName": "Spottdrosseln"
    },
    "Sprosser": {
        "latinName": "Luscinia luscinia",
        "germanName": "Sprosser"
    },
    "Star": {
        "latinName": "Sturnus vulgaris",
        "germanName": "Star"
    },
    "Starenverwandte": {
        "latinName": "Familie Sturnidae",
        "germanName": "Starenverwandte"
    },
    "Steinadler": {
        "latinName": "Aquila chrysaetos",
        "germanName": "Steinadler"
    },
    "Steinhuhn": {
        "latinName": "Alectoris graeca",
        "germanName": "Steinhuhn"
    },
    "Steinkauz": {
        "latinName": "Athene noctua",
        "germanName": "Steinkauz"
    },
    "Steinortolan": {
        "latinName": "Emberiza buchanani",
        "germanName": "Steinortolan"
    },
    "Steinroetel": {
        "latinName": "Monticola saxatilis",
        "germanName": "Steinroetel"
    },
    "Steinschmaetzer": {
        "latinName": "Oenanthe oenanthe",
        "germanName": "Steinschmaetzer"
    },
    "Steinsperling": {
        "latinName": "Petronia petronia",
        "germanName": "Steinsperling"
    },
    "Steinwaelzer": {
        "latinName": "Arenaria interpres",
        "germanName": "Steinwaelzer"
    },
    "Stelzenlaeufer": {
        "latinName": "Himantopus himantopus",
        "germanName": "Stelzenlaeufer"
    },
    "Stelzenverwandte": {
        "latinName": "Familie Motacillidae",
        "germanName": "Stelzenverwandte"
    },
    "Steppenadler": {
        "latinName": "Aquila nipalensis",
        "germanName": "Steppenadler"
    },
    "Steppenflughuhn": {
        "latinName": "Syrrhaptes paradoxus",
        "germanName": "Steppenflughuhn"
    },
    "Steppenkiebitz": {
        "latinName": "Vanellus gregarius",
        "germanName": "Steppenkiebitz"
    },
    "Steppenkragentrappe": {
        "latinName": "Chlamydotis macqueenii",
        "germanName": "Steppenkragentrappe"
    },
    "Steppenmoewe": {
        "latinName": "Larus cachinnans",
        "germanName": "Steppenmoewe"
    },
    "Steppenpieper": {
        "latinName": "Anthus godlewskii",
        "germanName": "Steppenpieper"
    },
    "Steppenspoetter": {
        "latinName": "Iduna rama",
        "germanName": "Steppenspoetter"
    },
    "Steppenweihe": {
        "latinName": "Circus macrourus",
        "germanName": "Steppenweihe"
    },
    "Sterntaucher": {
        "latinName": "Gavia stellata",
        "germanName": "Sterntaucher"
    },
    "Stieglitz": {
        "latinName": "Carduelis carduelis",
        "germanName": "Stieglitz"
    },
    "Stockente": {
        "latinName": "Anas platyrhynchos",
        "germanName": "Stockente"
    },
    "Stoerche": {
        "latinName": "Familie Ciconiidae",
        "germanName": "Stoerche"
    },
    "Strandpieper": {
        "latinName": "Anthus petrosus",
        "germanName": "Strandpieper"
    },
    "Strassentaube": {
        "latinName": "Columba livia f. domestica",
        "germanName": "Strassentaube"
    },
    "Streifengans": {
        "latinName": "Anser indicus",
        "germanName": "Streifengans"
    },
    "Streifenschwirl": {
        "latinName": "Helopsaltes certhiola",
        "germanName": "Streifenschwirl"
    },
    "Strichelschwirl": {
        "latinName": "Locustella lanceolata",
        "germanName": "Strichelschwirl"
    },
    "Stummellerche": {
        "latinName": "Alaudala rufescens",
        "germanName": "Stummellerche"
    },
    "Sturmmoewe": {
        "latinName": "Larus canus",
        "germanName": "Sturmmoewe"
    },
    "Sturmschwalben": {
        "latinName": "Familie Oceanitidae",
        "germanName": "Sturmschwalben"
    },
    "Sturmvoegel": {
        "latinName": "Familie Procellariidae",
        "germanName": "Sturmvoegel"
    },
    "Sturmwellenlaeufer": {
        "latinName": "Hydrobates pelagicus",
        "germanName": "Sturmwellenlaeufer"
    },
    "Sumpflaeufer": {
        "latinName": "Calidris falcinellus",
        "germanName": "Sumpflaeufer"
    },
    "Sumpfmeise": {
        "latinName": "Poecile palustris",
        "germanName": "Sumpfmeise"
    },
    "Sumpfohreule": {
        "latinName": "Asio flammeus",
        "germanName": "Sumpfohreule"
    },
    "Sumpfrohrsaenger": {
        "latinName": "Acrocephalus palustris",
        "germanName": "Sumpfrohrsaenger"
    },
    "Tafelente": {
        "latinName": "Aythya ferina",
        "germanName": "Tafelente"
    },
    "Taigabirkenzeisig": {
        "latinName": "Acanthis flammea",
        "germanName": "Taigabirkenzeisig"
    },
    "Tannenhaeher": {
        "latinName": "Nucifraga caryocatactes",
        "germanName": "Tannenhaeher"
    },
    "Tannenmeise": {
        "latinName": "Periparus ater",
        "germanName": "Tannenmeise"
    },
    "Teichhuhn": {
        "latinName": "Gallinula chloropus",
        "germanName": "Teichhuhn"
    },
    "Teichrohrsaenger": {
        "latinName": "Acrocephalus scirpaceus",
        "germanName": "Teichrohrsaenger"
    },
    "Teichwasserlaeufer": {
        "latinName": "Tringa stagnatilis",
        "germanName": "Teichwasserlaeufer"
    },
    "Temminckstrandlaeufer": {
        "latinName": "Calidris temminckii",
        "germanName": "Temminckstrandlaeufer"
    },
    "Terekwasserlaeufer": {
        "latinName": "Xenus cinereus",
        "germanName": "Terekwasserlaeufer"
    },
    "Thorshuehnchen": {
        "latinName": "Phalaropus fulicarius",
        "germanName": "Thorshuehnchen"
    },
    "Tienschan-Laubsaenger": {
        "latinName": "Phylloscopus humei",
        "germanName": "Tienschan-Laubsaenger"
    },
    "Toelpel": {
        "latinName": "Familie Sulidae",
        "germanName": "Toelpel"
    },
    "Tordalk": {
        "latinName": "Alca torda",
        "germanName": "Tordalk"
    },
    "Trauerente": {
        "latinName": "Melanitta nigra",
        "germanName": "Trauerente"
    },
    "Trauerschnaepper": {
        "latinName": "Ficedula hypoleuca",
        "germanName": "Trauerschnaepper"
    },
    "Trauerseeschwalbe": {
        "latinName": "Chlidonias niger",
        "germanName": "Trauerseeschwalbe"
    },
    "Triel": {
        "latinName": "Burhinus oedicnemus",
        "germanName": "Triel"
    },
    "Trottellumme": {
        "latinName": "Uria aalge",
        "germanName": "Trottellumme"
    },
    "Truthuhn": {
        "latinName": "Meleagris gallopavo",
        "germanName": "Truthuhn"
    },
    "Tuepfelsumpfhuhn": {
        "latinName": "Porzana porzana",
        "germanName": "Tuepfelsumpfhuhn"
    },
    "Tuerkenammer": {
        "latinName": "Emberiza cineracea",
        "germanName": "Tuerkenammer"
    },
    "Tuerkentaube": {
        "latinName": "Streptopelia decaocto",
        "germanName": "Tuerkentaube"
    },
    "Tundra-Goldregenpfeifer": {
        "latinName": "Pluvialis fulva",
        "germanName": "Tundra-Goldregenpfeifer"
    },
    "Tundraammern": {
        "latinName": "Familie Calcariidae",
        "germanName": "Tundraammern"
    },
    "Tundrasaatgans": {
        "latinName": "Anser serrirostris",
        "germanName": "Tundrasaatgans"
    },
    "Tundraschlammlaeufer": {
        "latinName": "Limnodromus scolopaceus",
        "germanName": "Tundraschlammlaeufer"
    },
    "Turmfalke": {
        "latinName": "Falco tinnunculus",
        "germanName": "Turmfalke"
    },
    "Turteltaube": {
        "latinName": "Streptopelia turtur",
        "germanName": "Turteltaube"
    },
    "Uferschnepfe": {
        "latinName": "Limosa limosa",
        "germanName": "Uferschnepfe"
    },
    "Uferschwalbe": {
        "latinName": "Riparia riparia",
        "germanName": "Uferschwalbe"
    },
    "Uhu": {
        "latinName": "Bubo bubo",
        "germanName": "Uhu"
    },
    "Vireos": {
        "latinName": "Familie Vireonidae",
        "germanName": "Vireos"
    },
    "Virginiauhu": {
        "latinName": "Bubo virginianus",
        "germanName": "Virginiauhu"
    },
    "Wacholderdrossel": {
        "latinName": "Turdus pilaris",
        "germanName": "Wacholderdrossel"
    },
    "Wacholderlaubsaenger": {
        "latinName": "Phylloscopus nitidus",
        "germanName": "Wacholderlaubsaenger"
    },
    "Wachtel": {
        "latinName": "Coturnix coturnix",
        "germanName": "Wachtel"
    },
    "Wachtelkoenig": {
        "latinName": "Crex crex",
        "germanName": "Wachtelkoenig"
    },
    "Waldammer": {
        "latinName": "Emberiza rustica",
        "germanName": "Waldammer"
    },
    "Waldbaumlaeufer": {
        "latinName": "Certhia familiaris",
        "germanName": "Waldbaumlaeufer"
    },
    "Waldkauz": {
        "latinName": "Strix aluco",
        "germanName": "Waldkauz"
    },
    "Waldlaubsaenger": {
        "latinName": "Phylloscopus sibilatrix",
        "germanName": "Waldlaubsaenger"
    },
    "Waldohreule": {
        "latinName": "Asio otus",
        "germanName": "Waldohreule"
    },
    "Waldpieper": {
        "latinName": "Anthus hodgsoni",
        "germanName": "Waldpieper"
    },
    "Waldrapp": {
        "latinName": "Geronticus eremita",
        "germanName": "Waldrapp"
    },
    "Waldsaatgans": {
        "latinName": "Anser fabalis",
        "germanName": "Waldsaatgans"
    },
    "Waldsaenger": {
        "latinName": "Familie Parulidae",
        "germanName": "Waldsaenger"
    },
    "Waldschnepfe": {
        "latinName": "Scolopax rusticola",
        "germanName": "Waldschnepfe"
    },
    "Waldwasserlaeufer": {
        "latinName": "Tringa ochropus",
        "germanName": "Waldwasserlaeufer"
    },
    "Wanderdrossel": {
        "latinName": "Turdus migratorius",
        "germanName": "Wanderdrossel"
    },
    "Wanderfalke": {
        "latinName": "Falco peregrinus",
        "germanName": "Wanderfalke"
    },
    "Wanderlaubsaenger": {
        "latinName": "Phylloscopus borealis",
        "germanName": "Wanderlaubsaenger"
    },
    "Wasseramsel": {
        "latinName": "Cinclus cinclus",
        "germanName": "Wasseramsel"
    },
    "Wasseramseln": {
        "latinName": "Familie Cinclidae",
        "germanName": "Wasseramseln"
    },
    "Wasserralle": {
        "latinName": "Rallus aquaticus",
        "germanName": "Wasserralle"
    },
    "Weidenammer": {
        "latinName": "Emberiza aureola",
        "germanName": "Weidenammer"
    },
    "Weidenmeise": {
        "latinName": "Poecile montanus",
        "germanName": "Weidenmeise"
    },
    "Weissbart-Grasmuecke": {
        "latinName": "Sylvia cantillans",
        "germanName": "Weissbart-Grasmuecke"
    },
    "Weissbart-Seeschwalbe": {
        "latinName": "Chlidonias hybrida",
        "germanName": "Weissbart-Seeschwalbe"
    },
    "Weissbauchtoelpel": {
        "latinName": "Sula leucogaster",
        "germanName": "Weissbauchtoelpel"
    },
    "Weissbrauendrossel": {
        "latinName": "Turdus obscurus",
        "germanName": "Weissbrauendrossel"
    },
    "Weissbuerzel-Strandlaeufer": {
        "latinName": "Calidris fuscicollis",
        "germanName": "Weissbuerzel-Strandlaeufer"
    },
    "Weissfluegel-Seeschwalbe": {
        "latinName": "Chlidonias leucopterus",
        "germanName": "Weissfluegel-Seeschwalbe"
    },
    "Weissfluegellerche": {
        "latinName": "Alauda leucoptera",
        "germanName": "Weissfluegellerche"
    },
    "Weisskehlammer": {
        "latinName": "Zonotrichia albicollis",
        "germanName": "Weisskehlammer"
    },
    "Weisskopf-Ruderente": {
        "latinName": "Oxyura leucocephala",
        "germanName": "Weisskopf-Ruderente"
    },
    "Weisskopf-Seeadler": {
        "latinName": "Haliaeetus leucocephalus",
        "germanName": "Weisskopf-Seeadler"
    },
    "Weissrueckenspecht": {
        "latinName": "Dendrocopos leucotos",
        "germanName": "Weissrueckenspecht"
    },
    "Weissschwanzkiebitz": {
        "latinName": "Vanellus leucurus",
        "germanName": "Weissschwanzkiebitz"
    },
    "Weissstorch": {
        "latinName": "Ciconia ciconia",
        "germanName": "Weissstorch"
    },
    "Weisswangengans": {
        "latinName": "Branta leucopsis",
        "germanName": "Weisswangengans"
    },
    "Wellenlaeufer": {
        "latinName": "Oceanodroma leucorhoa",
        "germanName": "Wellenlaeufer"
    },
    "Wendehals": {
        "latinName": "Jynx torquilla",
        "germanName": "Wendehals"
    },
    "Wermutregenpfeifer": {
        "latinName": "Charadrius asiaticus",
        "germanName": "Wermutregenpfeifer"
    },
    "Wespenbussard": {
        "latinName": "Pernis apivorus",
        "germanName": "Wespenbussard"
    },
    "Wiedehopf": {
        "latinName": "Upupa epops",
        "germanName": "Wiedehopf"
    },
    "Wiedehopfe": {
        "latinName": "Familie Upupidae",
        "germanName": "Wiedehopfe"
    },
    "Wiesenammer": {
        "latinName": "Emberiza cioides",
        "germanName": "Wiesenammer"
    },
    "Wiesenpieper": {
        "latinName": "Anthus pratensis",
        "germanName": "Wiesenpieper"
    },
    "Wiesenstrandlaeufer": {
        "latinName": "Calidris minutilla",
        "germanName": "Wiesenstrandlaeufer"
    },
    "Wiesenweihe": {
        "latinName": "Circus pygargus",
        "germanName": "Wiesenweihe"
    },
    "Wilsonwassertreter": {
        "latinName": "Phalaropus tricolor",
        "germanName": "Wilsonwassertreter"
    },
    "Wintergoldhaehnchen": {
        "latinName": "Regulus regulus",
        "germanName": "Wintergoldhaehnchen"
    },
    "Wuerger": {
        "latinName": "Familie Laniidae",
        "germanName": "Wuerger"
    },
    "Wuergfalke": {
        "latinName": "Falco cherrug",
        "germanName": "Wuergfalke"
    },
    "Wuestengimpel": {
        "latinName": "Bucanetes githagineus",
        "germanName": "Wuestengimpel"
    },
    "Wuestengrasmuecke": {
        "latinName": "Sylvia nana",
        "germanName": "Wuestengrasmuecke"
    },
    "Wuestenregenpfeifer": {
        "latinName": "Charadrius leschenaultii",
        "germanName": "Wuestenregenpfeifer"
    },
    "Wuestensteinschmaetzer": {
        "latinName": "Oenanthe deserti",
        "germanName": "Wuestensteinschmaetzer"
    },
    "Zaunammer": {
        "latinName": "Emberiza cirlus",
        "germanName": "Zaunammer"
    },
    "Zaunkoenig": {
        "latinName": "Troglodytes troglodytes",
        "germanName": "Zaunkoenig"
    },
    "Zaunkoenige": {
        "latinName": "Familie Troglodytidae",
        "germanName": "Zaunkoenige"
    },
    "Zilpzalp": {
        "latinName": "Phylloscopus collybita",
        "germanName": "Zilpzalp"
    },
    "Zippammer": {
        "latinName": "Emberiza cia",
        "germanName": "Zippammer"
    },
    "Zistensaenger": {
        "latinName": "Cisticola juncidis",
        "germanName": "Zistensaenger"
    },
    "Zitronenstelze": {
        "latinName": "Motacilla citreola",
        "germanName": "Zitronenstelze"
    },
    "Zitronenzeisig": {
        "latinName": "Carduelis citrinella",
        "germanName": "Zitronenzeisig"
    },
    "Zuegelseeschwalbe": {
        "latinName": "Onychoprion anaethetus",
        "germanName": "Zuegelseeschwalbe"
    },
    "Zwergadler": {
        "latinName": "Hieraaetus pennatus",
        "germanName": "Zwergadler"
    },
    "Zwergammer": {
        "latinName": "Emberiza pusilla",
        "germanName": "Zwergammer"
    },
    "Zwergdommel": {
        "latinName": "Ixobrychus minutus",
        "germanName": "Zwergdommel"
    },
    "Zwergflamingo": {
        "latinName": "Phoeniconaias minor",
        "germanName": "Zwergflamingo"
    },
    "Zwerggans": {
        "latinName": "Anser erythropus",
        "germanName": "Zwerggans"
    },
    "Zwergkanadagans": {
        "latinName": "Branta hutchinsii",
        "germanName": "Zwergkanadagans"
    },
    "Zwergmoewe": {
        "latinName": "Hydrocoloeus minutus",
        "germanName": "Zwergmoewe"
    },
    "Zwergmusendrossel": {
        "latinName": "Catharus ustulatus",
        "germanName": "Zwergmusendrossel"
    },
    "Zwergohreule": {
        "latinName": "Otus scops",
        "germanName": "Zwergohreule"
    },
    "Zwergsaeger": {
        "latinName": "Mergellus albellus",
        "germanName": "Zwergsaeger"
    },
    "Zwergscharbe": {
        "latinName": "Microcarbo pygmaeus",
        "germanName": "Zwergscharbe"
    },
    "Zwergschnaepper": {
        "latinName": "Ficedula parva",
        "germanName": "Zwergschnaepper"
    },
    "Zwergschneegans": {
        "latinName": "Anser rossii",
        "germanName": "Zwergschneegans"
    },
    "Zwergschnepfe": {
        "latinName": "Lymnocryptes minimus",
        "germanName": "Zwergschnepfe"
    },
    "Zwergschwan": {
        "latinName": "Cygnus columbianus",
        "germanName": "Zwergschwan"
    },
    "Zwergseeschwalbe": {
        "latinName": "Sternula albifrons",
        "germanName": "Zwergseeschwalbe"
    },
    "Zwergstrandlaeufer": {
        "latinName": "Calidris minuta",
        "germanName": "Zwergstrandlaeufer"
    },
    "Zwergsumpfhuhn": {
        "latinName": "Zapornia pusilla",
        "germanName": "Zwergsumpfhuhn"
    },
    "Zwergtaucher": {
        "latinName": "Tachybaptus ruficollis",
        "germanName": "Zwergtaucher"
    },
    "Zwergtrappe": {
        "latinName": "Tetrax tetrax",
        "germanName": "Zwergtrappe"
    },
    "Zypernsteinschmaetzer": {
        "latinName": "Oenanthe cypriaca",
        "germanName": "Zypernsteinschmaetzer"
    },
    "Acanthis cabaret": {
        "latinName": "Acanthis cabaret",
        "germanName": "Alpenbirkenzeisig"
    },
    "Acanthis flammea": {
        "latinName": "Acanthis flammea",
        "germanName": "Taigabirkenzeisig"
    },
    "Acanthis hornemanni": {
        "latinName": "Acanthis hornemanni",
        "germanName": "Polarbirkenzeisig"
    },
    "Accipiter cooperii": {
        "latinName": "Accipiter cooperii",
        "germanName": ""
    },
    "Accipiter gentilis": {
        "latinName": "Accipiter gentilis",
        "germanName": "Habicht"
    },
    "Accipiter nisus": {
        "latinName": "Accipiter nisus",
        "germanName": "Sperber"
    },
    "Accipiter striatus": {
        "latinName": "Accipiter striatus",
        "germanName": ""
    },
    "Acridotheres tristis": {
        "latinName": "Acridotheres tristis",
        "germanName": "Hirtenmaina"
    },
    "Acrocephalus agricola": {
        "latinName": "Acrocephalus agricola",
        "germanName": "Feldrohrsaenger"
    },
    "Acrocephalus arundinaceus": {
        "latinName": "Acrocephalus arundinaceus",
        "germanName": "Drosselrohrsaenger"
    },
    "Acrocephalus dumetorum": {
        "latinName": "Acrocephalus dumetorum",
        "germanName": "Buschrohrsaenger"
    },
    "Acrocephalus melanopogon": {
        "latinName": "Acrocephalus melanopogon",
        "germanName": "Mariskenrohrsaenger"
    },
    "Acrocephalus paludicola": {
        "latinName": "Acrocephalus paludicola",
        "germanName": "Seggenrohrsaenger"
    },
    "Acrocephalus palustris": {
        "latinName": "Acrocephalus palustris",
        "germanName": "Sumpfrohrsaenger"
    },
    "Acrocephalus schoenobaenus": {
        "latinName": "Acrocephalus schoenobaenus",
        "germanName": "Schilfrohrsaenger"
    },
    "Acrocephalus scirpaceus": {
        "latinName": "Acrocephalus scirpaceus",
        "germanName": "Teichrohrsaenger"
    },
    "Actitis hypoleucos": {
        "latinName": "Actitis hypoleucos",
        "germanName": "Flussuferlaeufer"
    },
    "Actitis macularius": {
        "latinName": "Actitis macularius",
        "germanName": "Drosseluferlaeufer"
    },
    "Actophilornis africanus": {
        "latinName": "Actophilornis africanus",
        "germanName": ""
    },
    "Aechmophorus clarkii": {
        "latinName": "Aechmophorus clarkii",
        "germanName": ""
    },
    "Aechmophorus occidentalis": {
        "latinName": "Aechmophorus occidentalis",
        "germanName": ""
    },
    "Aegithalos caudatus": {
        "latinName": "Aegithalos caudatus",
        "germanName": "Schwanzmeise"
    },
    "Aegolius acadicus": {
        "latinName": "Aegolius acadicus",
        "germanName": ""
    },
    "Aegolius funereus": {
        "latinName": "Aegolius funereus",
        "germanName": "Raufusskauz"
    },
    "Aegypius monachus": {
        "latinName": "Aegypius monachus",
        "germanName": "Moenchsgeier"
    },
    "Aeronautes saxatalis": {
        "latinName": "Aeronautes saxatalis",
        "germanName": ""
    },
    "Agelaius phoeniceus": {
        "latinName": "Agelaius phoeniceus",
        "germanName": ""
    },
    "Agelaius tricolor": {
        "latinName": "Agelaius tricolor",
        "germanName": ""
    },
    "Agropsar sturninus": {
        "latinName": "Agropsar sturninus",
        "germanName": "Mongolenstar"
    },
    "Aimophila ruficeps": {
        "latinName": "Aimophila ruficeps",
        "germanName": ""
    },
    "Aix galericulata": {
        "latinName": "Aix galericulata",
        "germanName": "Mandarinente"
    },
    "Aix sponsa": {
        "latinName": "Aix sponsa",
        "germanName": "Brautente"
    },
    "Alauda arvensis": {
        "latinName": "Alauda arvensis",
        "germanName": "Feldlerche"
    },
    "Alauda leucoptera": {
        "latinName": "Alauda leucoptera",
        "germanName": "Weissfluegellerche"
    },
    "Alaudala rufescens": {
        "latinName": "Alaudala rufescens",
        "germanName": "Stummellerche"
    },
    "Alca torda": {
        "latinName": "Alca torda",
        "germanName": "Tordalk"
    },
    "Alcedo atthis": {
        "latinName": "Alcedo atthis",
        "germanName": "Eisvogel"
    },
    "Alectoris chukar": {
        "latinName": "Alectoris chukar",
        "germanName": ""
    },
    "Alectoris graeca": {
        "latinName": "Alectoris graeca",
        "germanName": "Steinhuhn"
    },
    "Alectoris rufa": {
        "latinName": "Alectoris rufa",
        "germanName": "Rothuhn"
    },
    "Alectura lathami": {
        "latinName": "Alectura lathami",
        "germanName": ""
    },
    "Alisterus scapularis": {
        "latinName": "Alisterus scapularis",
        "germanName": ""
    },
    "Alle alle": {
        "latinName": "Alle alle",
        "germanName": "Krabbentaucher"
    },
    "Alopochen aegyptiaca": {
        "latinName": "Alopochen aegyptiaca",
        "germanName": "Nilgans"
    },
    "Amaurornis phoenicurus": {
        "latinName": "Amaurornis phoenicurus",
        "germanName": ""
    },
    "Amazilia beryllina": {
        "latinName": "Amazilia beryllina",
        "germanName": ""
    },
    "Amazilia rutila": {
        "latinName": "Amazilia rutila",
        "germanName": ""
    },
    "Amazilia tzacatl": {
        "latinName": "Amazilia tzacatl",
        "germanName": ""
    },
    "Amazilia violiceps": {
        "latinName": "Amazilia violiceps",
        "germanName": ""
    },
    "Amazilia yucatanensis": {
        "latinName": "Amazilia yucatanensis",
        "germanName": ""
    },
    "Amazona aestiva": {
        "latinName": "Amazona aestiva",
        "germanName": "Blaustirnamazone"
    },
    "Amazona albifrons": {
        "latinName": "Amazona albifrons",
        "germanName": ""
    },
    "Amazona autumnalis": {
        "latinName": "Amazona autumnalis",
        "germanName": ""
    },
    "Amazona oratrix": {
        "latinName": "Amazona oratrix",
        "germanName": "Gelbkopfamazone"
    },
    "Amazona viridigenalis": {
        "latinName": "Amazona viridigenalis",
        "germanName": ""
    },
    "Ammodramus maritimus": {
        "latinName": "Ammodramus maritimus",
        "germanName": ""
    },
    "Ammodramus nelsoni": {
        "latinName": "Ammodramus nelsoni",
        "germanName": ""
    },
    "Ammodramus savannarum": {
        "latinName": "Ammodramus savannarum",
        "germanName": ""
    },
    "Amphispiza bilineata": {
        "latinName": "Amphispiza bilineata",
        "germanName": ""
    },
    "Anas acuta": {
        "latinName": "Anas acuta",
        "germanName": "Spiessente"
    },
    "Anas americana": {
        "latinName": "Anas americana",
        "germanName": ""
    },
    "Anas bahamensis": {
        "latinName": "Anas bahamensis",
        "germanName": "Bahamaente"
    },
    "Anas carolinensis": {
        "latinName": "Anas carolinensis",
        "germanName": "Carolinakrickente"
    },
    "Anas chlorotis": {
        "latinName": "Anas chlorotis",
        "germanName": ""
    },
    "Anas clypeata": {
        "latinName": "Anas clypeata",
        "germanName": ""
    },
    "Anas crecca": {
        "latinName": "Anas crecca",
        "germanName": "Krickente"
    },
    "Anas crecca carolinensis": {
        "latinName": "Anas crecca carolinensis",
        "germanName": ""
    },
    "Anas cyanoptera": {
        "latinName": "Anas cyanoptera",
        "germanName": ""
    },
    "Anas discors": {
        "latinName": "Anas discors",
        "germanName": ""
    },
    "Anas fulvigula": {
        "latinName": "Anas fulvigula",
        "germanName": ""
    },
    "Anas gracilis": {
        "latinName": "Anas gracilis",
        "germanName": ""
    },
    "Anas penelope": {
        "latinName": "Anas penelope",
        "germanName": ""
    },
    "Anas platyrhynchos": {
        "latinName": "Anas platyrhynchos",
        "germanName": "Stockente"
    },
    "Anas platyrhynchos diazi": {
        "latinName": "Anas platyrhynchos diazi",
        "germanName": ""
    },
    "Anas platyrhynchos domesticus": {
        "latinName": "Anas platyrhynchos domesticus",
        "germanName": ""
    },
    "Anas poecilorhyncha": {
        "latinName": "Anas poecilorhyncha",
        "germanName": "Indien-Fleckschnabelente"
    },
    "Anas querquedula": {
        "latinName": "Anas querquedula",
        "germanName": ""
    },
    "Anas rubripes": {
        "latinName": "Anas rubripes",
        "germanName": "Dunkelente"
    },
    "Anas strepera": {
        "latinName": "Anas strepera",
        "germanName": ""
    },
    "Anas superciliosa": {
        "latinName": "Anas superciliosa",
        "germanName": ""
    },
    "Anas superciliosa \u00c3\u2014 platyrhynchos": {
        "latinName": "Anas superciliosa \u00c3\u2014 platyrhynchos",
        "germanName": ""
    },
    "Anastomus lamelligerus": {
        "latinName": "Anastomus lamelligerus",
        "germanName": ""
    },
    "Anhinga anhinga": {
        "latinName": "Anhinga anhinga",
        "germanName": ""
    },
    "Anhinga novaehollandiae": {
        "latinName": "Anhinga novaehollandiae",
        "germanName": ""
    },
    "Anhinga rufa": {
        "latinName": "Anhinga rufa",
        "germanName": ""
    },
    "Anous stolidus": {
        "latinName": "Anous stolidus",
        "germanName": "Noddi"
    },
    "Anser albifrons": {
        "latinName": "Anser albifrons",
        "germanName": "Blaessgans"
    },
    "Anser anser": {
        "latinName": "Anser anser",
        "germanName": "Graugans"
    },
    "Anser anser domesticus": {
        "latinName": "Anser anser domesticus",
        "germanName": ""
    },
    "Anser brachyrhynchus": {
        "latinName": "Anser brachyrhynchus",
        "germanName": "Kurzschnabelgans"
    },
    "Anser caerulescens": {
        "latinName": "Anser caerulescens",
        "germanName": "Schneegans"
    },
    "Anser cygnoid f. domestica": {
        "latinName": "Anser cygnoid f. domestica",
        "germanName": "Hoeckergans"
    },
    "Anser cygnoides domesticus": {
        "latinName": "Anser cygnoides domesticus",
        "germanName": ""
    },
    "Anser erythropus": {
        "latinName": "Anser erythropus",
        "germanName": "Zwerggans"
    },
    "Anser fabalis": {
        "latinName": "Anser fabalis",
        "germanName": "Waldsaatgans"
    },
    "Anser indicus": {
        "latinName": "Anser indicus",
        "germanName": "Streifengans"
    },
    "Anser rossii": {
        "latinName": "Anser rossii",
        "germanName": "Zwergschneegans"
    },
    "Anser serrirostris": {
        "latinName": "Anser serrirostris",
        "germanName": "Tundrasaatgans"
    },
    "Anthornis melanura": {
        "latinName": "Anthornis melanura",
        "germanName": ""
    },
    "Anthus campestris": {
        "latinName": "Anthus campestris",
        "germanName": "Brachpieper"
    },
    "Anthus cervinus": {
        "latinName": "Anthus cervinus",
        "germanName": "Rotkehlpieper"
    },
    "Anthus godlewskii": {
        "latinName": "Anthus godlewskii",
        "germanName": "Steppenpieper"
    },
    "Anthus gustavi": {
        "latinName": "Anthus gustavi",
        "germanName": "Petschorapieper"
    },
    "Anthus hodgsoni": {
        "latinName": "Anthus hodgsoni",
        "germanName": "Waldpieper"
    },
    "Anthus novaeseelandiae novaeseelandiae": {
        "latinName": "Anthus novaeseelandiae novaeseelandiae",
        "germanName": ""
    },
    "Anthus petrosus": {
        "latinName": "Anthus petrosus",
        "germanName": "Strandpieper"
    },
    "Anthus pratensis": {
        "latinName": "Anthus pratensis",
        "germanName": "Wiesenpieper"
    },
    "Anthus richardi": {
        "latinName": "Anthus richardi",
        "germanName": "Spornpieper"
    },
    "Anthus rubescens": {
        "latinName": "Anthus rubescens",
        "germanName": "Pazifikpieper"
    },
    "Anthus spinoletta": {
        "latinName": "Anthus spinoletta",
        "germanName": "Bergpieper"
    },
    "Anthus trivialis": {
        "latinName": "Anthus trivialis",
        "germanName": "Baumpieper"
    },
    "Antigone canadensis": {
        "latinName": "Antigone canadensis",
        "germanName": "Kanadakranich"
    },
    "Aphelocoma californica": {
        "latinName": "Aphelocoma californica",
        "germanName": ""
    },
    "Aphelocoma coerulescens": {
        "latinName": "Aphelocoma coerulescens",
        "germanName": ""
    },
    "Aphelocoma wollweberi": {
        "latinName": "Aphelocoma wollweberi",
        "germanName": ""
    },
    "Aphelocoma woodhouseii": {
        "latinName": "Aphelocoma woodhouseii",
        "germanName": ""
    },
    "Apus affinis": {
        "latinName": "Apus affinis",
        "germanName": "Haussegler"
    },
    "Apus apus": {
        "latinName": "Apus apus",
        "germanName": "Mauersegler"
    },
    "Apus pacificus": {
        "latinName": "Apus pacificus",
        "germanName": "Pazifiksegler"
    },
    "Apus pallidus": {
        "latinName": "Apus pallidus",
        "germanName": "Fahlsegler"
    },
    "Aquila chrysaetos": {
        "latinName": "Aquila chrysaetos",
        "germanName": "Steinadler"
    },
    "Aquila fasciata": {
        "latinName": "Aquila fasciata",
        "germanName": "Habichtsadler"
    },
    "Aquila heliaca": {
        "latinName": "Aquila heliaca",
        "germanName": "Kaiseradler"
    },
    "Aquila nipalensis": {
        "latinName": "Aquila nipalensis",
        "germanName": "Steppenadler"
    },
    "Ara macao": {
        "latinName": "Ara macao",
        "germanName": ""
    },
    "Ara militaris": {
        "latinName": "Ara militaris",
        "germanName": ""
    },
    "Aramides cajaneus": {
        "latinName": "Aramides cajaneus",
        "germanName": ""
    },
    "Aramus guarauna": {
        "latinName": "Aramus guarauna",
        "germanName": ""
    },
    "Aratinga nenday": {
        "latinName": "Aratinga nenday",
        "germanName": ""
    },
    "Archilochus alexandri": {
        "latinName": "Archilochus alexandri",
        "germanName": ""
    },
    "Archilochus colubris": {
        "latinName": "Archilochus colubris",
        "germanName": ""
    },
    "Ardea alba": {
        "latinName": "Ardea alba",
        "germanName": "Silberreiher"
    },
    "Ardea alba modesta": {
        "latinName": "Ardea alba modesta",
        "germanName": ""
    },
    "Ardea cinerea": {
        "latinName": "Ardea cinerea",
        "germanName": "Graureiher"
    },
    "Ardea cocoi": {
        "latinName": "Ardea cocoi",
        "germanName": ""
    },
    "Ardea herodias": {
        "latinName": "Ardea herodias",
        "germanName": ""
    },
    "Ardea herodias occidentalis": {
        "latinName": "Ardea herodias occidentalis",
        "germanName": ""
    },
    "Ardea melanocephala": {
        "latinName": "Ardea melanocephala",
        "germanName": "Schwarzhalsreiher"
    },
    "Ardea purpurea": {
        "latinName": "Ardea purpurea",
        "germanName": "Purpurreiher"
    },
    "Ardenna creatopus": {
        "latinName": "Ardenna creatopus",
        "germanName": ""
    },
    "Ardenna gravis": {
        "latinName": "Ardenna gravis",
        "germanName": "Kappensturmtaucher"
    },
    "Ardenna grisea": {
        "latinName": "Ardenna grisea",
        "germanName": "Dunkelsturmtaucher"
    },
    "Ardeola ralloides": {
        "latinName": "Ardeola ralloides",
        "germanName": "Rallenreiher"
    },
    "Ardeotis kori": {
        "latinName": "Ardeotis kori",
        "germanName": ""
    },
    "Arenaria interpres": {
        "latinName": "Arenaria interpres",
        "germanName": "Steinwaelzer"
    },
    "Arenaria melanocephala": {
        "latinName": "Arenaria melanocephala",
        "germanName": ""
    },
    "Arremonops rufivirgatus": {
        "latinName": "Arremonops rufivirgatus",
        "germanName": ""
    },
    "Artemisiospiza belli": {
        "latinName": "Artemisiospiza belli",
        "germanName": ""
    },
    "Asio flammeus": {
        "latinName": "Asio flammeus",
        "germanName": "Sumpfohreule"
    },
    "Asio otus": {
        "latinName": "Asio otus",
        "germanName": "Waldohreule"
    },
    "Athene cunicularia": {
        "latinName": "Athene cunicularia",
        "germanName": ""
    },
    "Athene noctua": {
        "latinName": "Athene noctua",
        "germanName": "Steinkauz"
    },
    "Aulacorhynchus prasinus": {
        "latinName": "Aulacorhynchus prasinus",
        "germanName": ""
    },
    "Auriparus flaviceps": {
        "latinName": "Auriparus flaviceps",
        "germanName": ""
    },
    "Aythya affinis": {
        "latinName": "Aythya affinis",
        "germanName": "Kanadabergente"
    },
    "Aythya americana": {
        "latinName": "Aythya americana",
        "germanName": "Rotkopfente"
    },
    "Aythya collaris": {
        "latinName": "Aythya collaris",
        "germanName": "Ringschnabelente"
    },
    "Aythya ferina": {
        "latinName": "Aythya ferina",
        "germanName": "Tafelente"
    },
    "Aythya fuligula": {
        "latinName": "Aythya fuligula",
        "germanName": "Reiherente"
    },
    "Aythya marila": {
        "latinName": "Aythya marila",
        "germanName": "Bergente"
    },
    "Aythya novaeseelandiae": {
        "latinName": "Aythya novaeseelandiae",
        "germanName": ""
    },
    "Aythya nyroca": {
        "latinName": "Aythya nyroca",
        "germanName": "Moorente"
    },
    "Aythya valisineria": {
        "latinName": "Aythya valisineria",
        "germanName": "Riesentafelente"
    },
    "Baeolophus atricristatus": {
        "latinName": "Baeolophus atricristatus",
        "germanName": ""
    },
    "Baeolophus bicolor": {
        "latinName": "Baeolophus bicolor",
        "germanName": ""
    },
    "Baeolophus inornatus": {
        "latinName": "Baeolophus inornatus",
        "germanName": ""
    },
    "Balearica regulorum": {
        "latinName": "Balearica regulorum",
        "germanName": ""
    },
    "Bartramia longicauda": {
        "latinName": "Bartramia longicauda",
        "germanName": "Praerielaeufer"
    },
    "Basileuterus rufifrons": {
        "latinName": "Basileuterus rufifrons",
        "germanName": ""
    },
    "Bombycilla cedrorum": {
        "latinName": "Bombycilla cedrorum",
        "germanName": ""
    },
    "Bombycilla garrulus": {
        "latinName": "Bombycilla garrulus",
        "germanName": "Seidenschwanz"
    },
    "Bonasa umbellus": {
        "latinName": "Bonasa umbellus",
        "germanName": ""
    },
    "Bostrychia hagedash": {
        "latinName": "Bostrychia hagedash",
        "germanName": ""
    },
    "Botaurus lentiginosus": {
        "latinName": "Botaurus lentiginosus",
        "germanName": ""
    },
    "Botaurus stellaris": {
        "latinName": "Botaurus stellaris",
        "germanName": "Rohrdommel"
    },
    "Branta bernicla": {
        "latinName": "Branta bernicla",
        "germanName": "Ringelgans"
    },
    "Branta canadensis": {
        "latinName": "Branta canadensis",
        "germanName": "Kanadagans"
    },
    "Branta hutchinsii": {
        "latinName": "Branta hutchinsii",
        "germanName": "Zwergkanadagans"
    },
    "Branta leucopsis": {
        "latinName": "Branta leucopsis",
        "germanName": "Weisswangengans"
    },
    "Branta ruficollis": {
        "latinName": "Branta ruficollis",
        "germanName": "Rothalsgans"
    },
    "Branta sandvicensis": {
        "latinName": "Branta sandvicensis",
        "germanName": ""
    },
    "Bubo bubo": {
        "latinName": "Bubo bubo",
        "germanName": "Uhu"
    },
    "Bubo scandiacus": {
        "latinName": "Bubo scandiacus",
        "germanName": "Schneeeule"
    },
    "Bubo virginianus": {
        "latinName": "Bubo virginianus",
        "germanName": "Virginiauhu"
    },
    "Bubulcus ibis": {
        "latinName": "Bubulcus ibis",
        "germanName": "Kuhreiher"
    },
    "Bucanetes githagineus": {
        "latinName": "Bucanetes githagineus",
        "germanName": "Wuestengimpel"
    },
    "Bucephala albeola": {
        "latinName": "Bucephala albeola",
        "germanName": "Bueffelkopfente"
    },
    "Bucephala clangula": {
        "latinName": "Bucephala clangula",
        "germanName": "Schellente"
    },
    "Bucephala islandica": {
        "latinName": "Bucephala islandica",
        "germanName": "Spatelente"
    },
    "Bucorvus leadbeateri": {
        "latinName": "Bucorvus leadbeateri",
        "germanName": ""
    },
    "Bulweria bulwerii": {
        "latinName": "Bulweria bulwerii",
        "germanName": "Bulwersturmvogel"
    },
    "Burhinus oedicnemus": {
        "latinName": "Burhinus oedicnemus",
        "germanName": "Triel"
    },
    "Busarellus nigricollis": {
        "latinName": "Busarellus nigricollis",
        "germanName": ""
    },
    "Buteo albonotatus": {
        "latinName": "Buteo albonotatus",
        "germanName": ""
    },
    "Buteo brachyurus": {
        "latinName": "Buteo brachyurus",
        "germanName": ""
    },
    "Buteo buteo": {
        "latinName": "Buteo buteo",
        "germanName": "Maeusebussard"
    },
    "Buteo jamaicensis": {
        "latinName": "Buteo jamaicensis",
        "germanName": ""
    },
    "Buteo lagopus": {
        "latinName": "Buteo lagopus",
        "germanName": "Raufussbussard"
    },
    "Buteo lineatus": {
        "latinName": "Buteo lineatus",
        "germanName": ""
    },
    "Buteo lineatus elegans": {
        "latinName": "Buteo lineatus elegans",
        "germanName": ""
    },
    "Buteo plagiatus": {
        "latinName": "Buteo plagiatus",
        "germanName": ""
    },
    "Buteo platypterus": {
        "latinName": "Buteo platypterus",
        "germanName": ""
    },
    "Buteo regalis": {
        "latinName": "Buteo regalis",
        "germanName": ""
    },
    "Buteo rufinus": {
        "latinName": "Buteo rufinus",
        "germanName": "Adlerbussard"
    },
    "Buteo swainsoni": {
        "latinName": "Buteo swainsoni",
        "germanName": ""
    },
    "Buteogallus anthracinus": {
        "latinName": "Buteogallus anthracinus",
        "germanName": ""
    },
    "Butorides striata": {
        "latinName": "Butorides striata",
        "germanName": ""
    },
    "Butorides virescens": {
        "latinName": "Butorides virescens",
        "germanName": ""
    },
    "Cacatua galerita": {
        "latinName": "Cacatua galerita",
        "germanName": ""
    },
    "Cairina moschata": {
        "latinName": "Cairina moschata",
        "germanName": "Moschusente"
    },
    "Cairina moschata domestica": {
        "latinName": "Cairina moschata domestica",
        "germanName": ""
    },
    "Calamospiza melanocorys": {
        "latinName": "Calamospiza melanocorys",
        "germanName": ""
    },
    "Calandrella brachydactyla": {
        "latinName": "Calandrella brachydactyla",
        "germanName": "Kurzzehenlerche"
    },
    "Calcarius lapponicus": {
        "latinName": "Calcarius lapponicus",
        "germanName": "Spornammer"
    },
    "Calidris acuminata": {
        "latinName": "Calidris acuminata",
        "germanName": "Spitzschwanz-Strandlaeufer"
    },
    "Calidris alba": {
        "latinName": "Calidris alba",
        "germanName": "Sanderling"
    },
    "Calidris alpina": {
        "latinName": "Calidris alpina",
        "germanName": "Alpenstrandlaeufer"
    },
    "Calidris bairdii": {
        "latinName": "Calidris bairdii",
        "germanName": "Bairdstrandlaeufer"
    },
    "Calidris canutus": {
        "latinName": "Calidris canutus",
        "germanName": "Knutt"
    },
    "Calidris falcinellus": {
        "latinName": "Calidris falcinellus",
        "germanName": "Sumpflaeufer"
    },
    "Calidris ferruginea": {
        "latinName": "Calidris ferruginea",
        "germanName": "Sichelstrandlaeufer"
    },
    "Calidris fuscicollis": {
        "latinName": "Calidris fuscicollis",
        "germanName": "Weissbuerzel-Strandlaeufer"
    },
    "Calidris himantopus": {
        "latinName": "Calidris himantopus",
        "germanName": "Bindenstrandlaeufer"
    },
    "Calidris maritima": {
        "latinName": "Calidris maritima",
        "germanName": "Meerstrandlaeufer"
    },
    "Calidris mauri": {
        "latinName": "Calidris mauri",
        "germanName": ""
    },
    "Calidris melanotos": {
        "latinName": "Calidris melanotos",
        "germanName": "Graubrust-Strandlaeufer"
    },
    "Calidris minuta": {
        "latinName": "Calidris minuta",
        "germanName": "Zwergstrandlaeufer"
    },
    "Calidris minutilla": {
        "latinName": "Calidris minutilla",
        "germanName": "Wiesenstrandlaeufer"
    },
    "Calidris pugnax": {
        "latinName": "Calidris pugnax",
        "germanName": "Kampflaeufer"
    },
    "Calidris pusilla": {
        "latinName": "Calidris pusilla",
        "germanName": "Sandstrandlaeufer"
    },
    "Calidris ruficollis": {
        "latinName": "Calidris ruficollis",
        "germanName": "Rotkehl-Strandlaeufer"
    },
    "Calidris subminuta": {
        "latinName": "Calidris subminuta",
        "germanName": "Langzehen-Strandlaeufer"
    },
    "Calidris subruficollis": {
        "latinName": "Calidris subruficollis",
        "germanName": "Graslaeufer"
    },
    "Calidris temminckii": {
        "latinName": "Calidris temminckii",
        "germanName": "Temminckstrandlaeufer"
    },
    "Calidris tenuirostris": {
        "latinName": "Calidris tenuirostris",
        "germanName": "Anadyrknutt"
    },
    "Calidris virgata": {
        "latinName": "Calidris virgata",
        "germanName": ""
    },
    "Calliope calliope": {
        "latinName": "Calliope calliope",
        "germanName": "Rubinkehlchen"
    },
    "Callipepla californica": {
        "latinName": "Callipepla californica",
        "germanName": ""
    },
    "Callipepla gambelii": {
        "latinName": "Callipepla gambelii",
        "germanName": ""
    },
    "Callipepla squamata": {
        "latinName": "Callipepla squamata",
        "germanName": ""
    },
    "Callonetta leucophrys": {
        "latinName": "Callonetta leucophrys",
        "germanName": "Rotschulterente"
    },
    "Calocitta colliei": {
        "latinName": "Calocitta colliei",
        "germanName": ""
    },
    "Calocitta formosa": {
        "latinName": "Calocitta formosa",
        "germanName": ""
    },
    "Calonectris borealis": {
        "latinName": "Calonectris borealis",
        "germanName": "Corysturmtaucher"
    },
    "Calonectris diomedea": {
        "latinName": "Calonectris diomedea",
        "germanName": "Sepiasturmtaucher"
    },
    "Calothorax lucifer": {
        "latinName": "Calothorax lucifer",
        "germanName": ""
    },
    "Calypte anna": {
        "latinName": "Calypte anna",
        "germanName": ""
    },
    "Calypte costae": {
        "latinName": "Calypte costae",
        "germanName": ""
    },
    "Campephilus guatemalensis": {
        "latinName": "Campephilus guatemalensis",
        "germanName": ""
    },
    "Camptostoma imberbe": {
        "latinName": "Camptostoma imberbe",
        "germanName": ""
    },
    "Campylopterus hemileucurus": {
        "latinName": "Campylopterus hemileucurus",
        "germanName": ""
    },
    "Campylorhynchus brunneicapillus": {
        "latinName": "Campylorhynchus brunneicapillus",
        "germanName": ""
    },
    "Campylorhynchus rufinucha": {
        "latinName": "Campylorhynchus rufinucha",
        "germanName": ""
    },
    "Caprimulgus aegyptius": {
        "latinName": "Caprimulgus aegyptius",
        "germanName": "Pharaonennachtschwalbe"
    },
    "Caprimulgus europaeus": {
        "latinName": "Caprimulgus europaeus",
        "germanName": "Nachtschwalbe"
    },
    "Caracara cheriway": {
        "latinName": "Caracara cheriway",
        "germanName": ""
    },
    "Caracara plancus": {
        "latinName": "Caracara plancus",
        "germanName": ""
    },
    "Cardellina canadensis": {
        "latinName": "Cardellina canadensis",
        "germanName": ""
    },
    "Cardellina pusilla": {
        "latinName": "Cardellina pusilla",
        "germanName": ""
    },
    "Cardellina rubra": {
        "latinName": "Cardellina rubra",
        "germanName": ""
    },
    "Cardinalis cardinalis": {
        "latinName": "Cardinalis cardinalis",
        "germanName": ""
    },
    "Cardinalis sinuatus": {
        "latinName": "Cardinalis sinuatus",
        "germanName": ""
    },
    "Carduelis cannabina": {
        "latinName": "Carduelis cannabina",
        "germanName": ""
    },
    "Carduelis carduelis": {
        "latinName": "Carduelis carduelis",
        "germanName": "Stieglitz"
    },
    "Carduelis citrinella": {
        "latinName": "Carduelis citrinella",
        "germanName": "Zitronenzeisig"
    },
    "Carpodacus erythrinus": {
        "latinName": "Carpodacus erythrinus",
        "germanName": "Karmingimpel"
    },
    "Carpodacus sibiricus": {
        "latinName": "Carpodacus sibiricus",
        "germanName": "Meisengimpel"
    },
    "Cassiculus melanicterus": {
        "latinName": "Cassiculus melanicterus",
        "germanName": ""
    },
    "Cathartes aura": {
        "latinName": "Cathartes aura",
        "germanName": ""
    },
    "Cathartes burrovianus": {
        "latinName": "Cathartes burrovianus",
        "germanName": ""
    },
    "Catharus fuscescens": {
        "latinName": "Catharus fuscescens",
        "germanName": ""
    },
    "Catharus guttatus": {
        "latinName": "Catharus guttatus",
        "germanName": "Einsiedler-Musendrossel"
    },
    "Catharus minimus": {
        "latinName": "Catharus minimus",
        "germanName": "Grauwangen-Musendrossel"
    },
    "Catharus ustulatus": {
        "latinName": "Catharus ustulatus",
        "germanName": "Zwergmusendrossel"
    },
    "Catherpes mexicanus": {
        "latinName": "Catherpes mexicanus",
        "germanName": ""
    },
    "Cecropis daurica": {
        "latinName": "Cecropis daurica",
        "germanName": "Roetelschwalbe"
    },
    "Cepphus columba": {
        "latinName": "Cepphus columba",
        "germanName": ""
    },
    "Cepphus grylle": {
        "latinName": "Cepphus grylle",
        "germanName": "Gryllteiste"
    },
    "Cercotrichas galactotes": {
        "latinName": "Cercotrichas galactotes",
        "germanName": "Heckensaenger"
    },
    "Cerorhinca monocerata": {
        "latinName": "Cerorhinca monocerata",
        "germanName": ""
    },
    "Certhia americana": {
        "latinName": "Certhia americana",
        "germanName": ""
    },
    "Certhia brachydactyla": {
        "latinName": "Certhia brachydactyla",
        "germanName": "Gartenbaumlaeufer"
    },
    "Certhia familiaris": {
        "latinName": "Certhia familiaris",
        "germanName": "Waldbaumlaeufer"
    },
    "Ceryle rudis": {
        "latinName": "Ceryle rudis",
        "germanName": ""
    },
    "Cettia cetti": {
        "latinName": "Cettia cetti",
        "germanName": "Seidensaenger"
    },
    "Chaetura pelagica": {
        "latinName": "Chaetura pelagica",
        "germanName": ""
    },
    "Chaetura vauxi": {
        "latinName": "Chaetura vauxi",
        "germanName": ""
    },
    "Chamaea fasciata": {
        "latinName": "Chamaea fasciata",
        "germanName": ""
    },
    "Charadrius alexandrinus": {
        "latinName": "Charadrius alexandrinus",
        "germanName": "Seeregenpfeifer"
    },
    "Charadrius asiaticus": {
        "latinName": "Charadrius asiaticus",
        "germanName": "Wermutregenpfeifer"
    },
    "Charadrius dubius": {
        "latinName": "Charadrius dubius",
        "germanName": "Flussregenpfeifer"
    },
    "Charadrius hiaticula": {
        "latinName": "Charadrius hiaticula",
        "germanName": "Sandregenpfeifer"
    },
    "Charadrius leschenaultii": {
        "latinName": "Charadrius leschenaultii",
        "germanName": "Wuestenregenpfeifer"
    },
    "Charadrius melodus": {
        "latinName": "Charadrius melodus",
        "germanName": ""
    },
    "Charadrius montanus": {
        "latinName": "Charadrius montanus",
        "germanName": ""
    },
    "Charadrius morinellus": {
        "latinName": "Charadrius morinellus",
        "germanName": "Mornellregenpfeifer"
    },
    "Charadrius nivosus": {
        "latinName": "Charadrius nivosus",
        "germanName": ""
    },
    "Charadrius semipalmatus": {
        "latinName": "Charadrius semipalmatus",
        "germanName": ""
    },
    "Charadrius vociferus": {
        "latinName": "Charadrius vociferus",
        "germanName": ""
    },
    "Charadrius wilsonia": {
        "latinName": "Charadrius wilsonia",
        "germanName": ""
    },
    "Chen caerulescens": {
        "latinName": "Chen caerulescens",
        "germanName": ""
    },
    "Chen rossii": {
        "latinName": "Chen rossii",
        "germanName": ""
    },
    "Chenonetta jubata": {
        "latinName": "Chenonetta jubata",
        "germanName": ""
    },
    "Chlamydotis macqueenii": {
        "latinName": "Chlamydotis macqueenii",
        "germanName": "Steppenkragentrappe"
    },
    "Chlidonias hybrida": {
        "latinName": "Chlidonias hybrida",
        "germanName": "Weissbart-Seeschwalbe"
    },
    "Chlidonias leucopterus": {
        "latinName": "Chlidonias leucopterus",
        "germanName": "Weissfluegel-Seeschwalbe"
    },
    "Chlidonias niger": {
        "latinName": "Chlidonias niger",
        "germanName": "Trauerseeschwalbe"
    },
    "Chloris chloris": {
        "latinName": "Chloris chloris",
        "germanName": "Gruenfink"
    },
    "Chloroceryle aenea": {
        "latinName": "Chloroceryle aenea",
        "germanName": ""
    },
    "Chloroceryle amazona": {
        "latinName": "Chloroceryle amazona",
        "germanName": ""
    },
    "Chloroceryle americana": {
        "latinName": "Chloroceryle americana",
        "germanName": ""
    },
    "Chlorophanes spiza": {
        "latinName": "Chlorophanes spiza",
        "germanName": ""
    },
    "Chondestes grammacus": {
        "latinName": "Chondestes grammacus",
        "germanName": ""
    },
    "Chordeiles acutipennis": {
        "latinName": "Chordeiles acutipennis",
        "germanName": ""
    },
    "Chordeiles minor": {
        "latinName": "Chordeiles minor",
        "germanName": ""
    },
    "Chroicocephalus genei": {
        "latinName": "Chroicocephalus genei",
        "germanName": "Duennschnabelmoewe"
    },
    "Chroicocephalus novaehollandiae": {
        "latinName": "Chroicocephalus novaehollandiae",
        "germanName": ""
    },
    "Chroicocephalus philadelphia": {
        "latinName": "Chroicocephalus philadelphia",
        "germanName": "Bonapartemoewe"
    },
    "Chroicocephalus ridibundus": {
        "latinName": "Chroicocephalus ridibundus",
        "germanName": "Lachmoewe"
    },
    "Chroicocephalus scopulinus": {
        "latinName": "Chroicocephalus scopulinus",
        "germanName": ""
    },
    "Ciccaba virgata": {
        "latinName": "Ciccaba virgata",
        "germanName": ""
    },
    "Ciconia ciconia": {
        "latinName": "Ciconia ciconia",
        "germanName": "Weissstorch"
    },
    "Ciconia nigra": {
        "latinName": "Ciconia nigra",
        "germanName": "Schwarzstorch"
    },
    "Cinclus cinclus": {
        "latinName": "Cinclus cinclus",
        "germanName": "Wasseramsel"
    },
    "Cinclus mexicanus": {
        "latinName": "Cinclus mexicanus",
        "germanName": ""
    },
    "Cinnyris jugularis": {
        "latinName": "Cinnyris jugularis",
        "germanName": ""
    },
    "Circaetus gallicus": {
        "latinName": "Circaetus gallicus",
        "germanName": "Schlangenadler"
    },
    "Circus aeruginosus": {
        "latinName": "Circus aeruginosus",
        "germanName": "Rohrweihe"
    },
    "Circus approximans": {
        "latinName": "Circus approximans",
        "germanName": ""
    },
    "Circus cyaneus": {
        "latinName": "Circus cyaneus",
        "germanName": "Kornweihe"
    },
    "Circus cyaneus hudsonius": {
        "latinName": "Circus cyaneus hudsonius",
        "germanName": ""
    },
    "Circus macrourus": {
        "latinName": "Circus macrourus",
        "germanName": "Steppenweihe"
    },
    "Circus pygargus": {
        "latinName": "Circus pygargus",
        "germanName": "Wiesenweihe"
    },
    "Cisticola juncidis": {
        "latinName": "Cisticola juncidis",
        "germanName": "Zistensaenger"
    },
    "Cistothorus palustris": {
        "latinName": "Cistothorus palustris",
        "germanName": ""
    },
    "Cistothorus platensis": {
        "latinName": "Cistothorus platensis",
        "germanName": ""
    },
    "Clamator glandarius": {
        "latinName": "Clamator glandarius",
        "germanName": "Haeherkuckuck"
    },
    "Clanga clanga": {
        "latinName": "Clanga clanga",
        "germanName": "Schelladler"
    },
    "Clanga pomarina": {
        "latinName": "Clanga pomarina",
        "germanName": "Schreiadler"
    },
    "Clangula hyemalis": {
        "latinName": "Clangula hyemalis",
        "germanName": "Eisente"
    },
    "Coccothraustes coccothraustes": {
        "latinName": "Coccothraustes coccothraustes",
        "germanName": "Kernbeisser"
    },
    "Coccothraustes vespertinus": {
        "latinName": "Coccothraustes vespertinus",
        "germanName": ""
    },
    "Coccyzus americanus": {
        "latinName": "Coccyzus americanus",
        "germanName": ""
    },
    "Coccyzus erythropthalmus": {
        "latinName": "Coccyzus erythropthalmus",
        "germanName": "Schwarzschnabelkuckuck"
    },
    "Coccyzus minor": {
        "latinName": "Coccyzus minor",
        "germanName": ""
    },
    "Cochlearius cochlearius": {
        "latinName": "Cochlearius cochlearius",
        "germanName": ""
    },
    "Coereba flaveola": {
        "latinName": "Coereba flaveola",
        "germanName": ""
    },
    "Colaptes auratus": {
        "latinName": "Colaptes auratus",
        "germanName": ""
    },
    "Colaptes auratus auratus": {
        "latinName": "Colaptes auratus auratus",
        "germanName": ""
    },
    "Colaptes auratus cafer": {
        "latinName": "Colaptes auratus cafer",
        "germanName": ""
    },
    "Colaptes rubiginosus": {
        "latinName": "Colaptes rubiginosus",
        "germanName": ""
    },
    "Colinus virginianus": {
        "latinName": "Colinus virginianus",
        "germanName": ""
    },
    "Coloeus dauuricus": {
        "latinName": "Coloeus dauuricus",
        "germanName": "Elsterdohle"
    },
    "Coloeus monedula": {
        "latinName": "Coloeus monedula",
        "germanName": "Dohle"
    },
    "Columba livia": {
        "latinName": "Columba livia",
        "germanName": ""
    },
    "Columba livia domestica": {
        "latinName": "Columba livia domestica",
        "germanName": ""
    },
    "Columba livia f. domestica": {
        "latinName": "Columba livia f. domestica",
        "germanName": "Strassentaube"
    },
    "Columba oenas": {
        "latinName": "Columba oenas",
        "germanName": "Hohltaube"
    },
    "Columba palumbus": {
        "latinName": "Columba palumbus",
        "germanName": "Ringeltaube"
    },
    "Columbina inca": {
        "latinName": "Columbina inca",
        "germanName": ""
    },
    "Columbina passerina": {
        "latinName": "Columbina passerina",
        "germanName": ""
    },
    "Columbina talpacoti": {
        "latinName": "Columbina talpacoti",
        "germanName": ""
    },
    "Contopus cooperi": {
        "latinName": "Contopus cooperi",
        "germanName": ""
    },
    "Contopus pertinax": {
        "latinName": "Contopus pertinax",
        "germanName": ""
    },
    "Contopus sordidulus": {
        "latinName": "Contopus sordidulus",
        "germanName": ""
    },
    "Contopus virens": {
        "latinName": "Contopus virens",
        "germanName": ""
    },
    "Copsychus malabaricus": {
        "latinName": "Copsychus malabaricus",
        "germanName": ""
    },
    "Copsychus saularis": {
        "latinName": "Copsychus saularis",
        "germanName": ""
    },
    "Coracias benghalensis": {
        "latinName": "Coracias benghalensis",
        "germanName": ""
    },
    "Coracias caudatus": {
        "latinName": "Coracias caudatus",
        "germanName": ""
    },
    "Coracias garrulus": {
        "latinName": "Coracias garrulus",
        "germanName": "Blauracke"
    },
    "Coragyps atratus": {
        "latinName": "Coragyps atratus",
        "germanName": ""
    },
    "Corvus albus": {
        "latinName": "Corvus albus",
        "germanName": ""
    },
    "Corvus brachyrhynchos": {
        "latinName": "Corvus brachyrhynchos",
        "germanName": ""
    },
    "Corvus caurinus": {
        "latinName": "Corvus caurinus",
        "germanName": ""
    },
    "Corvus corax": {
        "latinName": "Corvus corax",
        "germanName": "Kolkrabe"
    },
    "Corvus cornix": {
        "latinName": "Corvus cornix",
        "germanName": "Nebelkraehe"
    },
    "Corvus corone": {
        "latinName": "Corvus corone",
        "germanName": "Rabenkraehe"
    },
    "Corvus frugilegus": {
        "latinName": "Corvus frugilegus",
        "germanName": "Saatkraehe"
    },
    "Corvus monedula": {
        "latinName": "Corvus monedula",
        "germanName": ""
    },
    "Corvus ossifragus": {
        "latinName": "Corvus ossifragus",
        "germanName": ""
    },
    "Corvus splendens": {
        "latinName": "Corvus splendens",
        "germanName": ""
    },
    "Coturnix coturnix": {
        "latinName": "Coturnix coturnix",
        "germanName": "Wachtel"
    },
    "Crax rubra": {
        "latinName": "Crax rubra",
        "germanName": ""
    },
    "Crex crex": {
        "latinName": "Crex crex",
        "germanName": "Wachtelkoenig"
    },
    "Crotophaga ani": {
        "latinName": "Crotophaga ani",
        "germanName": ""
    },
    "Crotophaga sulcirostris": {
        "latinName": "Crotophaga sulcirostris",
        "germanName": ""
    },
    "Cuculus canorus": {
        "latinName": "Cuculus canorus",
        "germanName": "Kuckuck"
    },
    "Cursorius cursor": {
        "latinName": "Cursorius cursor",
        "germanName": "Rennvogel"
    },
    "Cyanerpes cyaneus": {
        "latinName": "Cyanerpes cyaneus",
        "germanName": ""
    },
    "Cyanistes caeruleus": {
        "latinName": "Cyanistes caeruleus",
        "germanName": "Blaumeise"
    },
    "Cyanistes cyanus": {
        "latinName": "Cyanistes cyanus",
        "germanName": "Lasurmeise"
    },
    "Cyanocitta cristata": {
        "latinName": "Cyanocitta cristata",
        "germanName": ""
    },
    "Cyanocitta stelleri": {
        "latinName": "Cyanocitta stelleri",
        "germanName": ""
    },
    "Cyanocompsa parellina": {
        "latinName": "Cyanocompsa parellina",
        "germanName": ""
    },
    "Cyanocorax yncas": {
        "latinName": "Cyanocorax yncas",
        "germanName": ""
    },
    "Cyanocorax yucatanicus": {
        "latinName": "Cyanocorax yucatanicus",
        "germanName": ""
    },
    "Cyanopica cyanus": {
        "latinName": "Cyanopica cyanus",
        "germanName": "Azurelster"
    },
    "Cyanoramphus novaezelandiae": {
        "latinName": "Cyanoramphus novaezelandiae",
        "germanName": ""
    },
    "Cygnus atratus": {
        "latinName": "Cygnus atratus",
        "germanName": "Schwarzschwan"
    },
    "Cygnus buccinator": {
        "latinName": "Cygnus buccinator",
        "germanName": ""
    },
    "Cygnus columbianus": {
        "latinName": "Cygnus columbianus",
        "germanName": "Zwergschwan"
    },
    "Cygnus cygnus": {
        "latinName": "Cygnus cygnus",
        "germanName": "Singschwan"
    },
    "Cygnus olor": {
        "latinName": "Cygnus olor",
        "germanName": "Hoeckerschwan"
    },
    "Cynanthus latirostris": {
        "latinName": "Cynanthus latirostris",
        "germanName": ""
    },
    "Cyrtonyx montezumae": {
        "latinName": "Cyrtonyx montezumae",
        "germanName": ""
    },
    "Dacelo novaeguineae": {
        "latinName": "Dacelo novaeguineae",
        "germanName": ""
    },
    "Delichon urbicum": {
        "latinName": "Delichon urbicum",
        "germanName": "Mehlschwalbe"
    },
    "Dendragapus fuliginosus": {
        "latinName": "Dendragapus fuliginosus",
        "germanName": ""
    },
    "Dendragapus obscurus": {
        "latinName": "Dendragapus obscurus",
        "germanName": ""
    },
    "Dendrocopos leucotos": {
        "latinName": "Dendrocopos leucotos",
        "germanName": "Weissrueckenspecht"
    },
    "Dendrocopos major": {
        "latinName": "Dendrocopos major",
        "germanName": "Buntspecht"
    },
    "Dendrocopos syriacus": {
        "latinName": "Dendrocopos syriacus",
        "germanName": "Blutspecht"
    },
    "Dendrocoptes medius": {
        "latinName": "Dendrocoptes medius",
        "germanName": "Mittelspecht"
    },
    "Dendrocygna autumnalis": {
        "latinName": "Dendrocygna autumnalis",
        "germanName": ""
    },
    "Dendrocygna bicolor": {
        "latinName": "Dendrocygna bicolor",
        "germanName": ""
    },
    "Dendrocygna viduata": {
        "latinName": "Dendrocygna viduata",
        "germanName": ""
    },
    "Dicrurus adsimilis": {
        "latinName": "Dicrurus adsimilis",
        "germanName": ""
    },
    "Diglossa baritula": {
        "latinName": "Diglossa baritula",
        "germanName": ""
    },
    "Dives dives": {
        "latinName": "Dives dives",
        "germanName": ""
    },
    "Dolichonyx oryzivorus": {
        "latinName": "Dolichonyx oryzivorus",
        "germanName": ""
    },
    "Dryobates minor": {
        "latinName": "Dryobates minor",
        "germanName": "Kleinspecht"
    },
    "Dryocopus lineatus": {
        "latinName": "Dryocopus lineatus",
        "germanName": ""
    },
    "Dryocopus martius": {
        "latinName": "Dryocopus martius",
        "germanName": "Schwarzspecht"
    },
    "Dryocopus pileatus": {
        "latinName": "Dryocopus pileatus",
        "germanName": ""
    },
    "Dumetella carolinensis": {
        "latinName": "Dumetella carolinensis",
        "germanName": "Katzenspottdrossel"
    },
    "Egretta caerulea": {
        "latinName": "Egretta caerulea",
        "germanName": ""
    },
    "Egretta garzetta": {
        "latinName": "Egretta garzetta",
        "germanName": "Seidenreiher"
    },
    "Egretta gularis": {
        "latinName": "Egretta gularis",
        "germanName": "Kuestenreiher"
    },
    "Egretta novaehollandiae": {
        "latinName": "Egretta novaehollandiae",
        "germanName": ""
    },
    "Egretta rufescens": {
        "latinName": "Egretta rufescens",
        "germanName": ""
    },
    "Egretta sacra": {
        "latinName": "Egretta sacra",
        "germanName": ""
    },
    "Egretta thula": {
        "latinName": "Egretta thula",
        "germanName": "Schmuckreiher"
    },
    "Egretta tricolor": {
        "latinName": "Egretta tricolor",
        "germanName": "Dreifarbenreiher"
    },
    "Elanoides forficatus": {
        "latinName": "Elanoides forficatus",
        "germanName": ""
    },
    "Elanus caeruleus": {
        "latinName": "Elanus caeruleus",
        "germanName": "Gleitaar"
    },
    "Elanus leucurus": {
        "latinName": "Elanus leucurus",
        "germanName": ""
    },
    "Emberiza aureola": {
        "latinName": "Emberiza aureola",
        "germanName": "Weidenammer"
    },
    "Emberiza bruniceps": {
        "latinName": "Emberiza bruniceps",
        "germanName": "Braunkopfammer"
    },
    "Emberiza buchanani": {
        "latinName": "Emberiza buchanani",
        "germanName": "Steinortolan"
    },
    "Emberiza caesia": {
        "latinName": "Emberiza caesia",
        "germanName": "Grauortolan"
    },
    "Emberiza calandra": {
        "latinName": "Emberiza calandra",
        "germanName": "Grauammer"
    },
    "Emberiza cia": {
        "latinName": "Emberiza cia",
        "germanName": "Zippammer"
    },
    "Emberiza cineracea": {
        "latinName": "Emberiza cineracea",
        "germanName": "Tuerkenammer"
    },
    "Emberiza cioides": {
        "latinName": "Emberiza cioides",
        "germanName": "Wiesenammer"
    },
    "Emberiza cirlus": {
        "latinName": "Emberiza cirlus",
        "germanName": "Zaunammer"
    },
    "Emberiza citrinella": {
        "latinName": "Emberiza citrinella",
        "germanName": "Goldammer"
    },
    "Emberiza elegans": {
        "latinName": "Emberiza elegans",
        "germanName": "Gelbkehlammer"
    },
    "Emberiza hortulana": {
        "latinName": "Emberiza hortulana",
        "germanName": "Ortolan"
    },
    "Emberiza leucocephalos": {
        "latinName": "Emberiza leucocephalos",
        "germanName": "Fichtenammer"
    },
    "Emberiza melanocephala": {
        "latinName": "Emberiza melanocephala",
        "germanName": "Kappenammer"
    },
    "Emberiza pusilla": {
        "latinName": "Emberiza pusilla",
        "germanName": "Zwergammer"
    },
    "Emberiza rustica": {
        "latinName": "Emberiza rustica",
        "germanName": "Waldammer"
    },
    "Emberiza schoeniclus": {
        "latinName": "Emberiza schoeniclus",
        "germanName": "Rohrammer"
    },
    "Emberiza spodocephala": {
        "latinName": "Emberiza spodocephala",
        "germanName": "Maskenammer"
    },
    "Empidonax difficilis": {
        "latinName": "Empidonax difficilis",
        "germanName": ""
    },
    "Empidonax fulvifrons": {
        "latinName": "Empidonax fulvifrons",
        "germanName": ""
    },
    "Empidonax hammondii": {
        "latinName": "Empidonax hammondii",
        "germanName": ""
    },
    "Empidonax minimus": {
        "latinName": "Empidonax minimus",
        "germanName": ""
    },
    "Empidonax occidentalis": {
        "latinName": "Empidonax occidentalis",
        "germanName": ""
    },
    "Empidonax traillii": {
        "latinName": "Empidonax traillii",
        "germanName": ""
    },
    "Eolophus roseicapilla": {
        "latinName": "Eolophus roseicapilla",
        "germanName": ""
    },
    "Ephippiorhynchus senegalensis": {
        "latinName": "Ephippiorhynchus senegalensis",
        "germanName": ""
    },
    "Eremophila alpestris": {
        "latinName": "Eremophila alpestris",
        "germanName": "Ohrenlerche"
    },
    "Erithacus rubecula": {
        "latinName": "Erithacus rubecula",
        "germanName": "Rotkehlchen"
    },
    "Estrilda astrild": {
        "latinName": "Estrilda astrild",
        "germanName": ""
    },
    "Eudocimus albus": {
        "latinName": "Eudocimus albus",
        "germanName": ""
    },
    "Eudyptula minor": {
        "latinName": "Eudyptula minor",
        "germanName": ""
    },
    "Eugenes fulgens": {
        "latinName": "Eugenes fulgens",
        "germanName": ""
    },
    "Eumomota superciliosa": {
        "latinName": "Eumomota superciliosa",
        "germanName": ""
    },
    "Euphagus carolinus": {
        "latinName": "Euphagus carolinus",
        "germanName": ""
    },
    "Euphagus cyanocephalus": {
        "latinName": "Euphagus cyanocephalus",
        "germanName": ""
    },
    "Euphonia affinis": {
        "latinName": "Euphonia affinis",
        "germanName": ""
    },
    "Euphonia elegantissima": {
        "latinName": "Euphonia elegantissima",
        "germanName": ""
    },
    "Euphonia hirundinacea": {
        "latinName": "Euphonia hirundinacea",
        "germanName": ""
    },
    "Eupsittula canicularis": {
        "latinName": "Eupsittula canicularis",
        "germanName": ""
    },
    "Eupsittula nana": {
        "latinName": "Eupsittula nana",
        "germanName": ""
    },
    "Falcipennis canadensis": {
        "latinName": "Falcipennis canadensis",
        "germanName": ""
    },
    "Falco biarmicus": {
        "latinName": "Falco biarmicus",
        "germanName": "Lannerfalke"
    },
    "Falco cherrug": {
        "latinName": "Falco cherrug",
        "germanName": "Wuergfalke"
    },
    "Falco columbarius": {
        "latinName": "Falco columbarius",
        "germanName": "Merlin"
    },
    "Falco eleonorae": {
        "latinName": "Falco eleonorae",
        "germanName": "Eleonorenfalke"
    },
    "Falco femoralis": {
        "latinName": "Falco femoralis",
        "germanName": ""
    },
    "Falco mexicanus": {
        "latinName": "Falco mexicanus",
        "germanName": ""
    },
    "Falco naumanni": {
        "latinName": "Falco naumanni",
        "germanName": "Roetelfalke"
    },
    "Falco novaeseelandiae": {
        "latinName": "Falco novaeseelandiae",
        "germanName": ""
    },
    "Falco peregrinus": {
        "latinName": "Falco peregrinus",
        "germanName": "Wanderfalke"
    },
    "Falco rufigularis": {
        "latinName": "Falco rufigularis",
        "germanName": ""
    },
    "Falco rusticolus": {
        "latinName": "Falco rusticolus",
        "germanName": "Gerfalke"
    },
    "Falco sparverius": {
        "latinName": "Falco sparverius",
        "germanName": "Buntfalke"
    },
    "Falco subbuteo": {
        "latinName": "Falco subbuteo",
        "germanName": "Baumfalke"
    },
    "Falco tinnunculus": {
        "latinName": "Falco tinnunculus",
        "germanName": "Turmfalke"
    },
    "Falco vespertinus": {
        "latinName": "Falco vespertinus",
        "germanName": "Rotfussfalke"
    },
    "Familie Accipitridae": {
        "latinName": "Familie Accipitridae",
        "germanName": "Habichtverwandte"
    },
    "Familie Acrocephalidae": {
        "latinName": "Familie Acrocephalidae",
        "germanName": "Rohrsaengerverwandte"
    },
    "Familie Aegithalidae": {
        "latinName": "Familie Aegithalidae",
        "germanName": "Schwanzmeisen"
    },
    "Familie Alaudidae": {
        "latinName": "Familie Alaudidae",
        "germanName": "Lerchen"
    },
    "Familie Alcedinidae": {
        "latinName": "Familie Alcedinidae",
        "germanName": "Eisvoegel"
    },
    "Familie Alcidae": {
        "latinName": "Familie Alcidae",
        "germanName": "Alke"
    },
    "Familie Ardeidae": {
        "latinName": "Familie Ardeidae",
        "germanName": "Reiher"
    },
    "Familie Bombycillidae": {
        "latinName": "Familie Bombycillidae",
        "germanName": "Seidenschwaenze"
    },
    "Familie Calcariidae": {
        "latinName": "Familie Calcariidae",
        "germanName": "Tundraammern"
    },
    "Familie Certhiidae": {
        "latinName": "Familie Certhiidae",
        "germanName": "Baumlaeufer"
    },
    "Familie Cettiidae": {
        "latinName": "Familie Cettiidae",
        "germanName": "Buschsaenger"
    },
    "Familie Charadriidae": {
        "latinName": "Familie Charadriidae",
        "germanName": "Regenpfeiferverwandte"
    },
    "Familie Ciconiidae": {
        "latinName": "Familie Ciconiidae",
        "germanName": "Stoerche"
    },
    "Familie Cinclidae": {
        "latinName": "Familie Cinclidae",
        "germanName": "Wasseramseln"
    },
    "Familie Cisticolidae": {
        "latinName": "Familie Cisticolidae",
        "germanName": "Halmsaenger"
    },
    "Familie Coraciidae": {
        "latinName": "Familie Coraciidae",
        "germanName": "Racken"
    },
    "Familie Corvidae": {
        "latinName": "Familie Corvidae",
        "germanName": "Kraehenverwandte"
    },
    "Familie Diomedeidae": {
        "latinName": "Familie Diomedeidae",
        "germanName": "Albatrosse"
    },
    "Familie Emberizidae": {
        "latinName": "Familie Emberizidae",
        "germanName": "Ammern"
    },
    "Familie Falconidae": {
        "latinName": "Familie Falconidae",
        "germanName": "Falken"
    },
    "Familie Fringillidae": {
        "latinName": "Familie Fringillidae",
        "germanName": "Finkenverwandte"
    },
    "Familie Glareolidae": {
        "latinName": "Familie Glareolidae",
        "germanName": "Brachschwalbenverwandte"
    },
    "Familie Gruidae": {
        "latinName": "Familie Gruidae",
        "germanName": "Kraniche"
    },
    "Familie Haematopodidae": {
        "latinName": "Familie Haematopodidae",
        "germanName": "Austernfischer"
    },
    "Familie Hirundinidae": {
        "latinName": "Familie Hirundinidae",
        "germanName": "Schwalben"
    },
    "Familie Hydrobatidae": {
        "latinName": "Familie Hydrobatidae",
        "germanName": "Wellenlaeufer"
    },
    "Familie Laniidae": {
        "latinName": "Familie Laniidae",
        "germanName": "Wuerger"
    },
    "Familie Laridae": {
        "latinName": "Familie Laridae",
        "germanName": "Moewenverwandte"
    },
    "Familie Locustellidae": {
        "latinName": "Familie Locustellidae",
        "germanName": "Schwirlverwandte"
    },
    "Familie Meropidae": {
        "latinName": "Familie Meropidae",
        "germanName": "Spinte"
    },
    "Familie Mimidae": {
        "latinName": "Familie Mimidae",
        "germanName": "Spottdrosseln"
    },
    "Familie Motacillidae": {
        "latinName": "Familie Motacillidae",
        "germanName": "Stelzenverwandte"
    },
    "Familie Muscicapidae": {
        "latinName": "Familie Muscicapidae",
        "germanName": "Schnaepperverwandte"
    },
    "Familie Oceanitidae": {
        "latinName": "Familie Oceanitidae",
        "germanName": "Sturmschwalben"
    },
    "Familie Oriolidae": {
        "latinName": "Familie Oriolidae",
        "germanName": "Pirole"
    },
    "Familie Pandionidae": {
        "latinName": "Familie Pandionidae",
        "germanName": "Fischadler"
    },
    "Familie Panuridae": {
        "latinName": "Familie Panuridae",
        "germanName": "Bartmeisen"
    },
    "Familie Paridae": {
        "latinName": "Familie Paridae",
        "germanName": "Meisen"
    },
    "Familie Parulidae": {
        "latinName": "Familie Parulidae",
        "germanName": "Waldsaenger"
    },
    "Familie Passeridae": {
        "latinName": "Familie Passeridae",
        "germanName": "Sperlinge"
    },
    "Familie Pelecanidae": {
        "latinName": "Familie Pelecanidae",
        "germanName": "Pelikane"
    },
    "Familie Phalacrocoracidae": {
        "latinName": "Familie Phalacrocoracidae",
        "germanName": "Scharben"
    },
    "Familie Phylloscopidae": {
        "latinName": "Familie Phylloscopidae",
        "germanName": "Laubsaenger"
    },
    "Familie Picidae": {
        "latinName": "Familie Picidae",
        "germanName": "Spechte"
    },
    "Familie Procellariidae": {
        "latinName": "Familie Procellariidae",
        "germanName": "Sturmvoegel"
    },
    "Familie Prunellidae": {
        "latinName": "Familie Prunellidae",
        "germanName": "Braunellen"
    },
    "Familie Psittaculidae": {
        "latinName": "Familie Psittaculidae",
        "germanName": "Altweltpapageien"
    },
    "Familie Recurvirostridae": {
        "latinName": "Familie Recurvirostridae",
        "germanName": "Saebelschnaeblerverwandte"
    },
    "Familie Regulidae": {
        "latinName": "Familie Regulidae",
        "germanName": "Goldhaehnchen"
    },
    "Familie Remizidae": {
        "latinName": "Familie Remizidae",
        "germanName": "Beutelmeisen"
    },
    "Familie Scolopacidae": {
        "latinName": "Familie Scolopacidae",
        "germanName": "Schnepfenverwandte"
    },
    "Familie Sittidae": {
        "latinName": "Familie Sittidae",
        "germanName": "Kleiber"
    },
    "Familie Stercorariidae": {
        "latinName": "Familie Stercorariidae",
        "germanName": "Raubmoewen"
    },
    "Familie Strigidae": {
        "latinName": "Familie Strigidae",
        "germanName": "Eulen"
    },
    "Familie Sturnidae": {
        "latinName": "Familie Sturnidae",
        "germanName": "Starenverwandte"
    },
    "Familie Sulidae": {
        "latinName": "Familie Sulidae",
        "germanName": "Toelpel"
    },
    "Familie Sylviidae": {
        "latinName": "Familie Sylviidae",
        "germanName": "Grasmueckenverwandte"
    },
    "Familie Threskiornithidae": {
        "latinName": "Familie Threskiornithidae",
        "germanName": "Ibisse"
    },
    "Familie Tichodromidae": {
        "latinName": "Familie Tichodromidae",
        "germanName": "Mauerlaeufer"
    },
    "Familie Troglodytidae": {
        "latinName": "Familie Troglodytidae",
        "germanName": "Zaunkoenige"
    },
    "Familie Turdidae": {
        "latinName": "Familie Turdidae",
        "germanName": "Drosseln"
    },
    "Familie Tytonidae": {
        "latinName": "Familie Tytonidae",
        "germanName": "Schleiereulen"
    },
    "Familie Upupidae": {
        "latinName": "Familie Upupidae",
        "germanName": "Wiedehopfe"
    },
    "Familie Vireonidae": {
        "latinName": "Familie Vireonidae",
        "germanName": "Vireos"
    },
    "Ficedula albicollis": {
        "latinName": "Ficedula albicollis",
        "germanName": "Halsbandschnaepper"
    },
    "Ficedula hypoleuca": {
        "latinName": "Ficedula hypoleuca",
        "germanName": "Trauerschnaepper"
    },
    "Ficedula parva": {
        "latinName": "Ficedula parva",
        "germanName": "Zwergschnaepper"
    },
    "Florisuga mellivora": {
        "latinName": "Florisuga mellivora",
        "germanName": ""
    },
    "Francolinus pondicerianus": {
        "latinName": "Francolinus pondicerianus",
        "germanName": ""
    },
    "Fratercula arctica": {
        "latinName": "Fratercula arctica",
        "germanName": "Papageitaucher"
    },
    "Fratercula cirrhata": {
        "latinName": "Fratercula cirrhata",
        "germanName": ""
    },
    "Fregata magnificens": {
        "latinName": "Fregata magnificens",
        "germanName": ""
    },
    "Fregata minor": {
        "latinName": "Fregata minor",
        "germanName": ""
    },
    "Fringilla coelebs": {
        "latinName": "Fringilla coelebs",
        "germanName": "Buchfink"
    },
    "Fringilla montifringilla": {
        "latinName": "Fringilla montifringilla",
        "germanName": "Bergfink"
    },
    "Fulica americana": {
        "latinName": "Fulica americana",
        "germanName": ""
    },
    "Fulica atra": {
        "latinName": "Fulica atra",
        "germanName": "Blaesshuhn"
    },
    "Fulmarus glacialis": {
        "latinName": "Fulmarus glacialis",
        "germanName": "Eissturmvogel"
    },
    "Galbula ruficauda": {
        "latinName": "Galbula ruficauda",
        "germanName": ""
    },
    "Galerida cristata": {
        "latinName": "Galerida cristata",
        "germanName": "Haubenlerche"
    },
    "Gallinago delicata": {
        "latinName": "Gallinago delicata",
        "germanName": ""
    },
    "Gallinago gallinago": {
        "latinName": "Gallinago gallinago",
        "germanName": "Bekassine"
    },
    "Gallinago media": {
        "latinName": "Gallinago media",
        "germanName": "Doppelschnepfe"
    },
    "Gallinula chloropus": {
        "latinName": "Gallinula chloropus",
        "germanName": "Teichhuhn"
    },
    "Gallinula galeata": {
        "latinName": "Gallinula galeata",
        "germanName": ""
    },
    "Gallinula tenebrosa": {
        "latinName": "Gallinula tenebrosa",
        "germanName": ""
    },
    "Gallirallus australis": {
        "latinName": "Gallirallus australis",
        "germanName": ""
    },
    "Gallus gallus": {
        "latinName": "Gallus gallus",
        "germanName": ""
    },
    "Gallus gallus domesticus": {
        "latinName": "Gallus gallus domesticus",
        "germanName": ""
    },
    "Garrulus glandarius": {
        "latinName": "Garrulus glandarius",
        "germanName": "Eichelhaeher"
    },
    "Gavia adamsii": {
        "latinName": "Gavia adamsii",
        "germanName": "Gelbschnabeltaucher"
    },
    "Gavia arctica": {
        "latinName": "Gavia arctica",
        "germanName": "Prachttaucher"
    },
    "Gavia immer": {
        "latinName": "Gavia immer",
        "germanName": "Eistaucher"
    },
    "Gavia pacifica": {
        "latinName": "Gavia pacifica",
        "germanName": ""
    },
    "Gavia stellata": {
        "latinName": "Gavia stellata",
        "germanName": "Sterntaucher"
    },
    "Gelochelidon nilotica": {
        "latinName": "Gelochelidon nilotica",
        "germanName": "Lachseeschwalbe"
    },
    "Geococcyx californianus": {
        "latinName": "Geococcyx californianus",
        "germanName": ""
    },
    "Geococcyx velox": {
        "latinName": "Geococcyx velox",
        "germanName": ""
    },
    "Geokichla sibirica": {
        "latinName": "Geokichla sibirica",
        "germanName": "Schieferdrossel"
    },
    "Geopelia striata": {
        "latinName": "Geopelia striata",
        "germanName": ""
    },
    "Geothlypis formosa": {
        "latinName": "Geothlypis formosa",
        "germanName": ""
    },
    "Geothlypis philadelphia": {
        "latinName": "Geothlypis philadelphia",
        "germanName": ""
    },
    "Geothlypis tolmiei": {
        "latinName": "Geothlypis tolmiei",
        "germanName": ""
    },
    "Geothlypis trichas": {
        "latinName": "Geothlypis trichas",
        "germanName": ""
    },
    "Geranoaetus albicaudatus": {
        "latinName": "Geranoaetus albicaudatus",
        "germanName": ""
    },
    "Geronticus eremita": {
        "latinName": "Geronticus eremita",
        "germanName": "Waldrapp"
    },
    "Gerygone igata": {
        "latinName": "Gerygone igata",
        "germanName": ""
    },
    "Glareola nordmanni": {
        "latinName": "Glareola nordmanni",
        "germanName": "Schwarzfluegel-Brachschwalbe"
    },
    "Glareola pratincola": {
        "latinName": "Glareola pratincola",
        "germanName": "Rotfluegel-Brachschwalbe"
    },
    "Glaucidium brasilianum": {
        "latinName": "Glaucidium brasilianum",
        "germanName": ""
    },
    "Glaucidium gnoma": {
        "latinName": "Glaucidium gnoma",
        "germanName": ""
    },
    "Glaucidium passerinum": {
        "latinName": "Glaucidium passerinum",
        "germanName": "Sperlingskauz"
    },
    "Grallina cyanoleuca": {
        "latinName": "Grallina cyanoleuca",
        "germanName": ""
    },
    "Grus americana": {
        "latinName": "Grus americana",
        "germanName": ""
    },
    "Grus grus": {
        "latinName": "Grus grus",
        "germanName": "Kranich"
    },
    "Grus virgo": {
        "latinName": "Grus virgo",
        "germanName": "Jungfernkranich"
    },
    "Gygis alba": {
        "latinName": "Gygis alba",
        "germanName": ""
    },
    "Gymnogyps californianus": {
        "latinName": "Gymnogyps californianus",
        "germanName": ""
    },
    "Gymnorhina tibicen": {
        "latinName": "Gymnorhina tibicen",
        "germanName": ""
    },
    "Gypaetus barbatus": {
        "latinName": "Gypaetus barbatus",
        "germanName": "Bartgeier"
    },
    "Gyps africanus": {
        "latinName": "Gyps africanus",
        "germanName": ""
    },
    "Gyps fulvus": {
        "latinName": "Gyps fulvus",
        "germanName": "Gaensegeier"
    },
    "Gyps rueppelli": {
        "latinName": "Gyps rueppelli",
        "germanName": "Sperbergeier"
    },
    "Haematopus bachmani": {
        "latinName": "Haematopus bachmani",
        "germanName": ""
    },
    "Haematopus finschi": {
        "latinName": "Haematopus finschi",
        "germanName": ""
    },
    "Haematopus ostralegus": {
        "latinName": "Haematopus ostralegus",
        "germanName": "Austernfischer"
    },
    "Haematopus palliatus": {
        "latinName": "Haematopus palliatus",
        "germanName": ""
    },
    "Haematopus unicolor": {
        "latinName": "Haematopus unicolor",
        "germanName": ""
    },
    "Haemorhous cassinii": {
        "latinName": "Haemorhous cassinii",
        "germanName": ""
    },
    "Haemorhous mexicanus": {
        "latinName": "Haemorhous mexicanus",
        "germanName": ""
    },
    "Haemorhous purpureus": {
        "latinName": "Haemorhous purpureus",
        "germanName": ""
    },
    "Halcyon smyrnensis": {
        "latinName": "Halcyon smyrnensis",
        "germanName": ""
    },
    "Haliaeetus albicilla": {
        "latinName": "Haliaeetus albicilla",
        "germanName": "Seeadler"
    },
    "Haliaeetus leucocephalus": {
        "latinName": "Haliaeetus leucocephalus",
        "germanName": "Weisskopf-Seeadler"
    },
    "Haliaeetus leucogaster": {
        "latinName": "Haliaeetus leucogaster",
        "germanName": ""
    },
    "Haliaeetus leucoryphus": {
        "latinName": "Haliaeetus leucoryphus",
        "germanName": "Bindenseeadler"
    },
    "Haliaeetus pelagicus": {
        "latinName": "Haliaeetus pelagicus",
        "germanName": "Riesenseeadler"
    },
    "Haliaeetus vocifer": {
        "latinName": "Haliaeetus vocifer",
        "germanName": ""
    },
    "Haliastur indus": {
        "latinName": "Haliastur indus",
        "germanName": ""
    },
    "Helmitheros vermivorum": {
        "latinName": "Helmitheros vermivorum",
        "germanName": ""
    },
    "Helopsaltes certhiola": {
        "latinName": "Helopsaltes certhiola",
        "germanName": "Streifenschwirl"
    },
    "Hemiphaga novaeseelandiae": {
        "latinName": "Hemiphaga novaeseelandiae",
        "germanName": ""
    },
    "Herpetotheres cachinnans": {
        "latinName": "Herpetotheres cachinnans",
        "germanName": ""
    },
    "Hieraaetus pennatus": {
        "latinName": "Hieraaetus pennatus",
        "germanName": "Zwergadler"
    },
    "Himantopus himantopus": {
        "latinName": "Himantopus himantopus",
        "germanName": "Stelzenlaeufer"
    },
    "Himantopus leucocephalus": {
        "latinName": "Himantopus leucocephalus",
        "germanName": ""
    },
    "Himantopus mexicanus": {
        "latinName": "Himantopus mexicanus",
        "germanName": ""
    },
    "Hippolais icterina": {
        "latinName": "Hippolais icterina",
        "germanName": "Gelbspoetter"
    },
    "Hippolais polyglotta": {
        "latinName": "Hippolais polyglotta",
        "germanName": "Orpheusspoetter"
    },
    "Hirundo neoxena": {
        "latinName": "Hirundo neoxena",
        "germanName": ""
    },
    "Hirundo rustica": {
        "latinName": "Hirundo rustica",
        "germanName": "Rauchschwalbe"
    },
    "Hirundo rustica erythrogaster": {
        "latinName": "Hirundo rustica erythrogaster",
        "germanName": ""
    },
    "Histrionicus histrionicus": {
        "latinName": "Histrionicus histrionicus",
        "germanName": "Kragenente"
    },
    "Hydrobates pelagicus": {
        "latinName": "Hydrobates pelagicus",
        "germanName": "Sturmwellenlaeufer"
    },
    "Hydrocoloeus minutus": {
        "latinName": "Hydrocoloeus minutus",
        "germanName": "Zwergmoewe"
    },
    "Hydroprogne caspia": {
        "latinName": "Hydroprogne caspia",
        "germanName": "Raubseeschwalbe"
    },
    "Hylocharis leucotis": {
        "latinName": "Hylocharis leucotis",
        "germanName": ""
    },
    "Hylocichla mustelina": {
        "latinName": "Hylocichla mustelina",
        "germanName": ""
    },
    "Hymenolaimus malacorhynchos": {
        "latinName": "Hymenolaimus malacorhynchos",
        "germanName": ""
    },
    "Ichthyaetus audouinii": {
        "latinName": "Ichthyaetus audouinii",
        "germanName": "Korallenmoewe"
    },
    "Ichthyaetus ichthyaetus": {
        "latinName": "Ichthyaetus ichthyaetus",
        "germanName": "Fischmoewe"
    },
    "Ichthyaetus melanocephalus": {
        "latinName": "Ichthyaetus melanocephalus",
        "germanName": "Schwarzkopfmoewe"
    },
    "Icteria virens": {
        "latinName": "Icteria virens",
        "germanName": ""
    },
    "Icterus abeillei": {
        "latinName": "Icterus abeillei",
        "germanName": ""
    },
    "Icterus bullockii": {
        "latinName": "Icterus bullockii",
        "germanName": ""
    },
    "Icterus cucullatus": {
        "latinName": "Icterus cucullatus",
        "germanName": ""
    },
    "Icterus galbula": {
        "latinName": "Icterus galbula",
        "germanName": ""
    },
    "Icterus graduacauda": {
        "latinName": "Icterus graduacauda",
        "germanName": ""
    },
    "Icterus gularis": {
        "latinName": "Icterus gularis",
        "germanName": ""
    },
    "Icterus parisorum": {
        "latinName": "Icterus parisorum",
        "germanName": ""
    },
    "Icterus pustulatus": {
        "latinName": "Icterus pustulatus",
        "germanName": ""
    },
    "Icterus spurius": {
        "latinName": "Icterus spurius",
        "germanName": ""
    },
    "Icterus wagleri": {
        "latinName": "Icterus wagleri",
        "germanName": ""
    },
    "Ictinia mississippiensis": {
        "latinName": "Ictinia mississippiensis",
        "germanName": ""
    },
    "Iduna caligata": {
        "latinName": "Iduna caligata",
        "germanName": "Buschspoetter"
    },
    "Iduna pallida": {
        "latinName": "Iduna pallida",
        "germanName": "Blassspoetter"
    },
    "Iduna rama": {
        "latinName": "Iduna rama",
        "germanName": "Steppenspoetter"
    },
    "Ixobrychus exilis": {
        "latinName": "Ixobrychus exilis",
        "germanName": ""
    },
    "Ixobrychus minutus": {
        "latinName": "Ixobrychus minutus",
        "germanName": "Zwergdommel"
    },
    "Ixoreus naevius": {
        "latinName": "Ixoreus naevius",
        "germanName": ""
    },
    "Jabiru mycteria": {
        "latinName": "Jabiru mycteria",
        "germanName": ""
    },
    "Jacana jacana": {
        "latinName": "Jacana jacana",
        "germanName": ""
    },
    "Jacana spinosa": {
        "latinName": "Jacana spinosa",
        "germanName": ""
    },
    "Junco hyemalis": {
        "latinName": "Junco hyemalis",
        "germanName": ""
    },
    "Junco hyemalis caniceps": {
        "latinName": "Junco hyemalis caniceps",
        "germanName": ""
    },
    "Junco hyemalis hyemalis": {
        "latinName": "Junco hyemalis hyemalis",
        "germanName": ""
    },
    "Junco hyemalis oreganus": {
        "latinName": "Junco hyemalis oreganus",
        "germanName": ""
    },
    "Junco phaeonotus": {
        "latinName": "Junco phaeonotus",
        "germanName": ""
    },
    "Jynx torquilla": {
        "latinName": "Jynx torquilla",
        "germanName": "Wendehals"
    },
    "Lagopus lagopus": {
        "latinName": "Lagopus lagopus",
        "germanName": ""
    },
    "Lagopus muta": {
        "latinName": "Lagopus muta",
        "germanName": "Alpenschneehuhn"
    },
    "Lampornis clemenciae": {
        "latinName": "Lampornis clemenciae",
        "germanName": ""
    },
    "Lanius collurio": {
        "latinName": "Lanius collurio",
        "germanName": "Neuntoeter"
    },
    "Lanius cristatus": {
        "latinName": "Lanius cristatus",
        "germanName": "Braunwuerger"
    },
    "Lanius excubitor": {
        "latinName": "Lanius excubitor",
        "germanName": "Raubwuerger"
    },
    "Lanius isabellinus": {
        "latinName": "Lanius isabellinus",
        "germanName": "Isabellwuerger"
    },
    "Lanius ludovicianus": {
        "latinName": "Lanius ludovicianus",
        "germanName": ""
    },
    "Lanius minor": {
        "latinName": "Lanius minor",
        "germanName": "Schwarzstirnwuerger"
    },
    "Lanius nubicus": {
        "latinName": "Lanius nubicus",
        "germanName": "Maskenwuerger"
    },
    "Lanius phoenicuroides": {
        "latinName": "Lanius phoenicuroides",
        "germanName": "Rotschwanzwuerger"
    },
    "Lanius senator": {
        "latinName": "Lanius senator",
        "germanName": "Rotkopfwuerger"
    },
    "Larus argentatus": {
        "latinName": "Larus argentatus",
        "germanName": "Silbermoewe"
    },
    "Larus argentatus smithsonianus": {
        "latinName": "Larus argentatus smithsonianus",
        "germanName": ""
    },
    "Larus cachinnans": {
        "latinName": "Larus cachinnans",
        "germanName": "Steppenmoewe"
    },
    "Larus californicus": {
        "latinName": "Larus californicus",
        "germanName": ""
    },
    "Larus canus": {
        "latinName": "Larus canus",
        "germanName": "Sturmmoewe"
    },
    "Larus delawarensis": {
        "latinName": "Larus delawarensis",
        "germanName": "Ringschnabelmoewe"
    },
    "Larus dominicanus": {
        "latinName": "Larus dominicanus",
        "germanName": ""
    },
    "Larus dominicanus dominicanus": {
        "latinName": "Larus dominicanus dominicanus",
        "germanName": ""
    },
    "Larus fuscus": {
        "latinName": "Larus fuscus",
        "germanName": "Heringsmoewe"
    },
    "Larus glaucescens": {
        "latinName": "Larus glaucescens",
        "germanName": ""
    },
    "Larus glaucescens \u00c3\u2014 occidentalis": {
        "latinName": "Larus glaucescens \u00c3\u2014 occidentalis",
        "germanName": ""
    },
    "Larus glaucoides": {
        "latinName": "Larus glaucoides",
        "germanName": "Polarmoewe"
    },
    "Larus heermanni": {
        "latinName": "Larus heermanni",
        "germanName": ""
    },
    "Larus hyperboreus": {
        "latinName": "Larus hyperboreus",
        "germanName": "Eismoewe"
    },
    "Larus livens": {
        "latinName": "Larus livens",
        "germanName": ""
    },
    "Larus marinus": {
        "latinName": "Larus marinus",
        "germanName": "Mantelmoewe"
    },
    "Larus michahellis": {
        "latinName": "Larus michahellis",
        "germanName": "Mittelmeermoewe"
    },
    "Larus occidentalis": {
        "latinName": "Larus occidentalis",
        "germanName": ""
    },
    "Larus smithsonianus": {
        "latinName": "Larus smithsonianus",
        "germanName": "Kanadamoewe"
    },
    "Larus thayeri": {
        "latinName": "Larus thayeri",
        "germanName": ""
    },
    "Leptoptilos crumenifer": {
        "latinName": "Leptoptilos crumenifer",
        "germanName": ""
    },
    "Leptotila verreauxi": {
        "latinName": "Leptotila verreauxi",
        "germanName": ""
    },
    "Leucophaeus atricilla": {
        "latinName": "Leucophaeus atricilla",
        "germanName": "Aztekenmoewe"
    },
    "Leucophaeus pipixcan": {
        "latinName": "Leucophaeus pipixcan",
        "germanName": "Praeriemoewe"
    },
    "Limnodromus griseus": {
        "latinName": "Limnodromus griseus",
        "germanName": "Moorschlammlaeufer"
    },
    "Limnodromus scolopaceus": {
        "latinName": "Limnodromus scolopaceus",
        "germanName": "Tundraschlammlaeufer"
    },
    "Limosa fedoa": {
        "latinName": "Limosa fedoa",
        "germanName": ""
    },
    "Limosa haemastica": {
        "latinName": "Limosa haemastica",
        "germanName": ""
    },
    "Limosa lapponica": {
        "latinName": "Limosa lapponica",
        "germanName": "Pfuhlschnepfe"
    },
    "Limosa limosa": {
        "latinName": "Limosa limosa",
        "germanName": "Uferschnepfe"
    },
    "Linaria cannabina": {
        "latinName": "Linaria cannabina",
        "germanName": "Bluthaenfling"
    },
    "Linaria flavirostris": {
        "latinName": "Linaria flavirostris",
        "germanName": "Berghaenfling"
    },
    "Locustella fluviatilis": {
        "latinName": "Locustella fluviatilis",
        "germanName": "Schlagschwirl"
    },
    "Locustella lanceolata": {
        "latinName": "Locustella lanceolata",
        "germanName": "Strichelschwirl"
    },
    "Locustella luscinioides": {
        "latinName": "Locustella luscinioides",
        "germanName": "Rohrschwirl"
    },
    "Locustella naevia": {
        "latinName": "Locustella naevia",
        "germanName": "Feldschwirl"
    },
    "Lonchura oryzivora": {
        "latinName": "Lonchura oryzivora",
        "germanName": ""
    },
    "Lonchura punctulata": {
        "latinName": "Lonchura punctulata",
        "germanName": ""
    },
    "Lophodytes cucullatus": {
        "latinName": "Lophodytes cucullatus",
        "germanName": "Kappensaeger"
    },
    "Lophophanes cristatus": {
        "latinName": "Lophophanes cristatus",
        "germanName": "Haubenmeise"
    },
    "Lophura leucomelanos": {
        "latinName": "Lophura leucomelanos",
        "germanName": ""
    },
    "Loxia curvirostra": {
        "latinName": "Loxia curvirostra",
        "germanName": "Fichtenkreuzschnabel"
    },
    "Loxia leucoptera": {
        "latinName": "Loxia leucoptera",
        "germanName": "Bindenkreuzschnabel"
    },
    "Loxia pytyopsittacus": {
        "latinName": "Loxia pytyopsittacus",
        "germanName": "Kiefernkreuzschnabel"
    },
    "Lullula arborea": {
        "latinName": "Lullula arborea",
        "germanName": "Heidelerche"
    },
    "Luscinia luscinia": {
        "latinName": "Luscinia luscinia",
        "germanName": "Sprosser"
    },
    "Luscinia megarhynchos": {
        "latinName": "Luscinia megarhynchos",
        "germanName": "Nachtigall"
    },
    "Luscinia svecica": {
        "latinName": "Luscinia svecica",
        "germanName": "Blaukehlchen"
    },
    "Lymnocryptes minimus": {
        "latinName": "Lymnocryptes minimus",
        "germanName": "Zwergschnepfe"
    },
    "Lyrurus tetrix": {
        "latinName": "Lyrurus tetrix",
        "germanName": "Birkhuhn"
    },
    "Malurus cyaneus": {
        "latinName": "Malurus cyaneus",
        "germanName": ""
    },
    "Manorina melanocephala": {
        "latinName": "Manorina melanocephala",
        "germanName": ""
    },
    "Mareca americana": {
        "latinName": "Mareca americana",
        "germanName": "Kanadapfeifente"
    },
    "Mareca falcata": {
        "latinName": "Mareca falcata",
        "germanName": "Sichelente"
    },
    "Mareca penelope": {
        "latinName": "Mareca penelope",
        "germanName": "Pfeifente"
    },
    "Mareca strepera": {
        "latinName": "Mareca strepera",
        "germanName": "Schnatterente"
    },
    "Marmaronetta angustirostris": {
        "latinName": "Marmaronetta angustirostris",
        "germanName": "Marmelente"
    },
    "Megaceryle alcyon": {
        "latinName": "Megaceryle alcyon",
        "germanName": ""
    },
    "Megaceryle torquata": {
        "latinName": "Megaceryle torquata",
        "germanName": ""
    },
    "Megadyptes antipodes": {
        "latinName": "Megadyptes antipodes",
        "germanName": ""
    },
    "Megarynchus pitangua": {
        "latinName": "Megarynchus pitangua",
        "germanName": ""
    },
    "Megascops asio": {
        "latinName": "Megascops asio",
        "germanName": ""
    },
    "Megascops kennicottii": {
        "latinName": "Megascops kennicottii",
        "germanName": ""
    },
    "Melanerpes aurifrons": {
        "latinName": "Melanerpes aurifrons",
        "germanName": ""
    },
    "Melanerpes carolinus": {
        "latinName": "Melanerpes carolinus",
        "germanName": ""
    },
    "Melanerpes chrysogenys": {
        "latinName": "Melanerpes chrysogenys",
        "germanName": ""
    },
    "Melanerpes erythrocephalus": {
        "latinName": "Melanerpes erythrocephalus",
        "germanName": ""
    },
    "Melanerpes formicivorus": {
        "latinName": "Melanerpes formicivorus",
        "germanName": ""
    },
    "Melanerpes lewis": {
        "latinName": "Melanerpes lewis",
        "germanName": ""
    },
    "Melanerpes pucherani": {
        "latinName": "Melanerpes pucherani",
        "germanName": ""
    },
    "Melanerpes uropygialis": {
        "latinName": "Melanerpes uropygialis",
        "germanName": ""
    },
    "Melanitta americana": {
        "latinName": "Melanitta americana",
        "germanName": "Pazifiktrauerente"
    },
    "Melanitta fusca": {
        "latinName": "Melanitta fusca",
        "germanName": "Samtente"
    },
    "Melanitta nigra": {
        "latinName": "Melanitta nigra",
        "germanName": "Trauerente"
    },
    "Melanitta perspicillata": {
        "latinName": "Melanitta perspicillata",
        "germanName": "Brillenente"
    },
    "Melanitta stejnegeri": {
        "latinName": "Melanitta stejnegeri",
        "germanName": "Kamtschatkasamtente"
    },
    "Melanocorypha bimaculata": {
        "latinName": "Melanocorypha bimaculata",
        "germanName": "Bergkalanderlerche"
    },
    "Melanocorypha calandra": {
        "latinName": "Melanocorypha calandra",
        "germanName": "Kalanderlerche"
    },
    "Melanocorypha yeltoniensis": {
        "latinName": "Melanocorypha yeltoniensis",
        "germanName": "Schwarzsteppenlerche"
    },
    "Melanotis caerulescens": {
        "latinName": "Melanotis caerulescens",
        "germanName": ""
    },
    "Meleagris gallopavo": {
        "latinName": "Meleagris gallopavo",
        "germanName": "Truthuhn"
    },
    "Meleagris gallopavo intermedia": {
        "latinName": "Meleagris gallopavo intermedia",
        "germanName": ""
    },
    "Meleagris gallopavo silvestris": {
        "latinName": "Meleagris gallopavo silvestris",
        "germanName": ""
    },
    "Meleagris ocellata": {
        "latinName": "Meleagris ocellata",
        "germanName": ""
    },
    "Melopsittacus undulatus": {
        "latinName": "Melopsittacus undulatus",
        "germanName": ""
    },
    "Melospiza georgiana": {
        "latinName": "Melospiza georgiana",
        "germanName": ""
    },
    "Melospiza lincolnii": {
        "latinName": "Melospiza lincolnii",
        "germanName": ""
    },
    "Melospiza melodia": {
        "latinName": "Melospiza melodia",
        "germanName": "Singammer"
    },
    "Melozone aberti": {
        "latinName": "Melozone aberti",
        "germanName": ""
    },
    "Melozone crissalis": {
        "latinName": "Melozone crissalis",
        "germanName": ""
    },
    "Melozone fusca": {
        "latinName": "Melozone fusca",
        "germanName": ""
    },
    "Mergellus albellus": {
        "latinName": "Mergellus albellus",
        "germanName": "Zwergsaeger"
    },
    "Mergus merganser": {
        "latinName": "Mergus merganser",
        "germanName": "Gaensesaeger"
    },
    "Mergus serrator": {
        "latinName": "Mergus serrator",
        "germanName": "Mittelsaeger"
    },
    "Merops apiaster": {
        "latinName": "Merops apiaster",
        "germanName": "Bienenfresser"
    },
    "Merops orientalis": {
        "latinName": "Merops orientalis",
        "germanName": ""
    },
    "Merops persicus": {
        "latinName": "Merops persicus",
        "germanName": "Blauwangenspint"
    },
    "Merops pusillus": {
        "latinName": "Merops pusillus",
        "germanName": ""
    },
    "Microcarbo melanoleucos": {
        "latinName": "Microcarbo melanoleucos",
        "germanName": ""
    },
    "Microcarbo melanoleucos brevirostris": {
        "latinName": "Microcarbo melanoleucos brevirostris",
        "germanName": ""
    },
    "Microcarbo pygmaeus": {
        "latinName": "Microcarbo pygmaeus",
        "germanName": "Zwergscharbe"
    },
    "Milvago chimachima": {
        "latinName": "Milvago chimachima",
        "germanName": ""
    },
    "Milvus migrans": {
        "latinName": "Milvus migrans",
        "germanName": "Schwarzmilan"
    },
    "Milvus milvus": {
        "latinName": "Milvus milvus",
        "germanName": "Rotmilan"
    },
    "Mimus gilvus": {
        "latinName": "Mimus gilvus",
        "germanName": ""
    },
    "Mimus polyglottos": {
        "latinName": "Mimus polyglottos",
        "germanName": ""
    },
    "Mitrephanes phaeocercus": {
        "latinName": "Mitrephanes phaeocercus",
        "germanName": ""
    },
    "Mniotilta varia": {
        "latinName": "Mniotilta varia",
        "germanName": ""
    },
    "Molothrus aeneus": {
        "latinName": "Molothrus aeneus",
        "germanName": ""
    },
    "Molothrus ater": {
        "latinName": "Molothrus ater",
        "germanName": "Braunkopf-Kuhstaerling"
    },
    "Momotus coeruliceps": {
        "latinName": "Momotus coeruliceps",
        "germanName": ""
    },
    "Momotus lessonii": {
        "latinName": "Momotus lessonii",
        "germanName": ""
    },
    "Momotus mexicanus": {
        "latinName": "Momotus mexicanus",
        "germanName": ""
    },
    "Monticola saxatilis": {
        "latinName": "Monticola saxatilis",
        "germanName": "Steinroetel"
    },
    "Monticola solitarius": {
        "latinName": "Monticola solitarius",
        "germanName": "Blaumerle"
    },
    "Montifringilla nivalis": {
        "latinName": "Montifringilla nivalis",
        "germanName": "Schneesperling"
    },
    "Morus bassanus": {
        "latinName": "Morus bassanus",
        "germanName": "Basstoelpel"
    },
    "Morus serrator": {
        "latinName": "Morus serrator",
        "germanName": ""
    },
    "Motacilla aguimp": {
        "latinName": "Motacilla aguimp",
        "germanName": ""
    },
    "Motacilla alba": {
        "latinName": "Motacilla alba",
        "germanName": "Bachstelze"
    },
    "Motacilla cinerea": {
        "latinName": "Motacilla cinerea",
        "germanName": "Gebirgsstelze"
    },
    "Motacilla citreola": {
        "latinName": "Motacilla citreola",
        "germanName": "Zitronenstelze"
    },
    "Motacilla flava": {
        "latinName": "Motacilla flava",
        "germanName": "Schafstelze"
    },
    "Muscicapa sibirica": {
        "latinName": "Muscicapa sibirica",
        "germanName": "Russschnaepper"
    },
    "Muscicapa striata": {
        "latinName": "Muscicapa striata",
        "germanName": "Grauschnaepper"
    },
    "Myadestes townsendi": {
        "latinName": "Myadestes townsendi",
        "germanName": ""
    },
    "Mycteria americana": {
        "latinName": "Mycteria americana",
        "germanName": ""
    },
    "Mycteria ibis": {
        "latinName": "Mycteria ibis",
        "germanName": ""
    },
    "Myiarchus cinerascens": {
        "latinName": "Myiarchus cinerascens",
        "germanName": ""
    },
    "Myiarchus crinitus": {
        "latinName": "Myiarchus crinitus",
        "germanName": ""
    },
    "Myiarchus tuberculifer": {
        "latinName": "Myiarchus tuberculifer",
        "germanName": ""
    },
    "Myiarchus tyrannulus": {
        "latinName": "Myiarchus tyrannulus",
        "germanName": ""
    },
    "Myioborus miniatus": {
        "latinName": "Myioborus miniatus",
        "germanName": ""
    },
    "Myioborus pictus": {
        "latinName": "Myioborus pictus",
        "germanName": ""
    },
    "Myiodynastes luteiventris": {
        "latinName": "Myiodynastes luteiventris",
        "germanName": ""
    },
    "Myiopsitta monachus": {
        "latinName": "Myiopsitta monachus",
        "germanName": ""
    },
    "Myiozetetes similis": {
        "latinName": "Myiozetetes similis",
        "germanName": ""
    },
    "Neophron percnopterus": {
        "latinName": "Neophron percnopterus",
        "germanName": "Schmutzgeier"
    },
    "Nestor meridionalis": {
        "latinName": "Nestor meridionalis",
        "germanName": ""
    },
    "Nestor meridionalis septentrionalis": {
        "latinName": "Nestor meridionalis septentrionalis",
        "germanName": ""
    },
    "Nestor notabilis": {
        "latinName": "Nestor notabilis",
        "germanName": ""
    },
    "Netta rufina": {
        "latinName": "Netta rufina",
        "germanName": "Kolbenente"
    },
    "Ninox novaeseelandiae novaeseelandiae": {
        "latinName": "Ninox novaeseelandiae novaeseelandiae",
        "germanName": ""
    },
    "None": {
        "latinName": "None",
        "germanName": ""
    },
    "Notiomystis cincta": {
        "latinName": "Notiomystis cincta",
        "germanName": ""
    },
    "Nucifraga caryocatactes": {
        "latinName": "Nucifraga caryocatactes",
        "germanName": "Tannenhaeher"
    },
    "Nucifraga columbiana": {
        "latinName": "Nucifraga columbiana",
        "germanName": ""
    },
    "Numenius americanus": {
        "latinName": "Numenius americanus",
        "germanName": ""
    },
    "Numenius arquata": {
        "latinName": "Numenius arquata",
        "germanName": "Brachvogel"
    },
    "Numenius phaeopus": {
        "latinName": "Numenius phaeopus",
        "germanName": "Regenbrachvogel"
    },
    "Numenius tenuirostris": {
        "latinName": "Numenius tenuirostris",
        "germanName": "Duennschnabel-Brachvogel"
    },
    "Numida meleagris": {
        "latinName": "Numida meleagris",
        "germanName": ""
    },
    "Nyctanassa violacea": {
        "latinName": "Nyctanassa violacea",
        "germanName": ""
    },
    "Nyctibius jamaicensis": {
        "latinName": "Nyctibius jamaicensis",
        "germanName": ""
    },
    "Nycticorax nycticorax": {
        "latinName": "Nycticorax nycticorax",
        "germanName": "Nachtreiher"
    },
    "Nyctidromus albicollis": {
        "latinName": "Nyctidromus albicollis",
        "germanName": ""
    },
    "ORDNUNG PASSERIFORMES": {
        "latinName": "ORDNUNG PASSERIFORMES",
        "germanName": "SPERLINGSVoeGEL"
    },
    "Oceanites oceanicus": {
        "latinName": "Oceanites oceanicus",
        "germanName": "Buntfuss-Sturmschwalbe"
    },
    "Oceanodroma leucorhoa": {
        "latinName": "Oceanodroma leucorhoa",
        "germanName": "Wellenlaeufer"
    },
    "Ocyphaps lophotes": {
        "latinName": "Ocyphaps lophotes",
        "germanName": ""
    },
    "Oenanthe cypriaca": {
        "latinName": "Oenanthe cypriaca",
        "germanName": "Zypernsteinschmaetzer"
    },
    "Oenanthe deserti": {
        "latinName": "Oenanthe deserti",
        "germanName": "Wuestensteinschmaetzer"
    },
    "Oenanthe hispanica": {
        "latinName": "Oenanthe hispanica",
        "germanName": "Mittelmeer-Steinschmaetzer*"
    },
    "Oenanthe isabellina": {
        "latinName": "Oenanthe isabellina",
        "germanName": "Isabellsteinschmaetzer"
    },
    "Oenanthe leucopyga": {
        "latinName": "Oenanthe leucopyga",
        "germanName": "Saharasteinschmaetzer"
    },
    "Oenanthe oenanthe": {
        "latinName": "Oenanthe oenanthe",
        "germanName": "Steinschmaetzer"
    },
    "Oenanthe pleschanka": {
        "latinName": "Oenanthe pleschanka",
        "germanName": "Nonnensteinschmaetzer"
    },
    "Onychognathus morio": {
        "latinName": "Onychognathus morio",
        "germanName": ""
    },
    "Onychoprion anaethetus": {
        "latinName": "Onychoprion anaethetus",
        "germanName": "Zuegelseeschwalbe"
    },
    "Onychoprion fuscatus": {
        "latinName": "Onychoprion fuscatus",
        "germanName": "Russseeschwalbe"
    },
    "Opisthocomus hoazin": {
        "latinName": "Opisthocomus hoazin",
        "germanName": ""
    },
    "Oreoscoptes montanus": {
        "latinName": "Oreoscoptes montanus",
        "germanName": ""
    },
    "Oreothlypis celata": {
        "latinName": "Oreothlypis celata",
        "germanName": ""
    },
    "Oreothlypis peregrina": {
        "latinName": "Oreothlypis peregrina",
        "germanName": ""
    },
    "Oreothlypis ruficapilla": {
        "latinName": "Oreothlypis ruficapilla",
        "germanName": ""
    },
    "Oriolus oriolus": {
        "latinName": "Oriolus oriolus",
        "germanName": "Pirol"
    },
    "Oriturus superciliosus": {
        "latinName": "Oriturus superciliosus",
        "germanName": ""
    },
    "Ortalis poliocephala": {
        "latinName": "Ortalis poliocephala",
        "germanName": ""
    },
    "Ortalis vetula": {
        "latinName": "Ortalis vetula",
        "germanName": ""
    },
    "Otis tarda": {
        "latinName": "Otis tarda",
        "germanName": "Grosstrappe"
    },
    "Otus scops": {
        "latinName": "Otus scops",
        "germanName": "Zwergohreule"
    },
    "Oxyura jamaicensis": {
        "latinName": "Oxyura jamaicensis",
        "germanName": "Schwarzkopf-Ruderente"
    },
    "Oxyura leucocephala": {
        "latinName": "Oxyura leucocephala",
        "germanName": "Weisskopf-Ruderente"
    },
    "Pachyramphus aglaiae": {
        "latinName": "Pachyramphus aglaiae",
        "germanName": ""
    },
    "Pagophila eburnea": {
        "latinName": "Pagophila eburnea",
        "germanName": "Elfenbeinmoewe"
    },
    "Pandion haliaetus": {
        "latinName": "Pandion haliaetus",
        "germanName": "Fischadler"
    },
    "Panurus biarmicus": {
        "latinName": "Panurus biarmicus",
        "germanName": "Bartmeise"
    },
    "Parabuteo unicinctus": {
        "latinName": "Parabuteo unicinctus",
        "germanName": ""
    },
    "Parkesia motacilla": {
        "latinName": "Parkesia motacilla",
        "germanName": ""
    },
    "Parkesia noveboracensis": {
        "latinName": "Parkesia noveboracensis",
        "germanName": ""
    },
    "Paroaria capitata": {
        "latinName": "Paroaria capitata",
        "germanName": ""
    },
    "Paroaria coronata": {
        "latinName": "Paroaria coronata",
        "germanName": ""
    },
    "Parus major": {
        "latinName": "Parus major",
        "germanName": "Kohlmeise"
    },
    "Passer domesticus": {
        "latinName": "Passer domesticus",
        "germanName": "Haussperling"
    },
    "Passer italiae": {
        "latinName": "Passer italiae",
        "germanName": ""
    },
    "Passer montanus": {
        "latinName": "Passer montanus",
        "germanName": "Feldsperling"
    },
    "Passerculus sandwichensis": {
        "latinName": "Passerculus sandwichensis",
        "germanName": ""
    },
    "Passerella iliaca": {
        "latinName": "Passerella iliaca",
        "germanName": "Fuchsammer"
    },
    "Passerina amoena": {
        "latinName": "Passerina amoena",
        "germanName": "Lazulifink"
    },
    "Passerina caerulea": {
        "latinName": "Passerina caerulea",
        "germanName": ""
    },
    "Passerina ciris": {
        "latinName": "Passerina ciris",
        "germanName": ""
    },
    "Passerina cyanea": {
        "latinName": "Passerina cyanea",
        "germanName": "Indigofink"
    },
    "Passerina leclancherii": {
        "latinName": "Passerina leclancherii",
        "germanName": ""
    },
    "Passerina versicolor": {
        "latinName": "Passerina versicolor",
        "germanName": ""
    },
    "Pastor roseus": {
        "latinName": "Pastor roseus",
        "germanName": "Rosenstar"
    },
    "Patagioenas fasciata": {
        "latinName": "Patagioenas fasciata",
        "germanName": ""
    },
    "Patagioenas flavirostris": {
        "latinName": "Patagioenas flavirostris",
        "germanName": ""
    },
    "Patagioenas leucocephala": {
        "latinName": "Patagioenas leucocephala",
        "germanName": ""
    },
    "Pavo cristatus": {
        "latinName": "Pavo cristatus",
        "germanName": ""
    },
    "Pelecanus conspicillatus": {
        "latinName": "Pelecanus conspicillatus",
        "germanName": ""
    },
    "Pelecanus crispus": {
        "latinName": "Pelecanus crispus",
        "germanName": "Krauskopfpelikan"
    },
    "Pelecanus erythrorhynchos": {
        "latinName": "Pelecanus erythrorhynchos",
        "germanName": ""
    },
    "Pelecanus occidentalis": {
        "latinName": "Pelecanus occidentalis",
        "germanName": ""
    },
    "Pelecanus occidentalis californicus": {
        "latinName": "Pelecanus occidentalis californicus",
        "germanName": ""
    },
    "Pelecanus occidentalis carolinensis": {
        "latinName": "Pelecanus occidentalis carolinensis",
        "germanName": ""
    },
    "Pelecanus onocrotalus": {
        "latinName": "Pelecanus onocrotalus",
        "germanName": "Rosapelikan"
    },
    "Pelecanus rufescens": {
        "latinName": "Pelecanus rufescens",
        "germanName": "Roetelpelikan"
    },
    "Penelope purpurascens": {
        "latinName": "Penelope purpurascens",
        "germanName": ""
    },
    "Perdix perdix": {
        "latinName": "Perdix perdix",
        "germanName": "Rebhuhn"
    },
    "Periparus ater": {
        "latinName": "Periparus ater",
        "germanName": "Tannenmeise"
    },
    "Perisoreus canadensis": {
        "latinName": "Perisoreus canadensis",
        "germanName": ""
    },
    "Pernis apivorus": {
        "latinName": "Pernis apivorus",
        "germanName": "Wespenbussard"
    },
    "Petrochelidon fulva": {
        "latinName": "Petrochelidon fulva",
        "germanName": ""
    },
    "Petrochelidon pyrrhonota": {
        "latinName": "Petrochelidon pyrrhonota",
        "germanName": ""
    },
    "Petroica australis australis": {
        "latinName": "Petroica australis australis",
        "germanName": ""
    },
    "Petroica australis longipes": {
        "latinName": "Petroica australis longipes",
        "germanName": ""
    },
    "Petroica macrocephala macrocephala": {
        "latinName": "Petroica macrocephala macrocephala",
        "germanName": ""
    },
    "Petronia petronia": {
        "latinName": "Petronia petronia",
        "germanName": "Steinsperling"
    },
    "Peucaea ruficauda": {
        "latinName": "Peucaea ruficauda",
        "germanName": ""
    },
    "Phaethon aethereus": {
        "latinName": "Phaethon aethereus",
        "germanName": ""
    },
    "Phainopepla nitens": {
        "latinName": "Phainopepla nitens",
        "germanName": ""
    },
    "Phalacrocorax aristotelis": {
        "latinName": "Phalacrocorax aristotelis",
        "germanName": "Kraehenscharbe"
    },
    "Phalacrocorax auritus": {
        "latinName": "Phalacrocorax auritus",
        "germanName": "Ohrenscharbe"
    },
    "Phalacrocorax brasilianus": {
        "latinName": "Phalacrocorax brasilianus",
        "germanName": ""
    },
    "Phalacrocorax carbo": {
        "latinName": "Phalacrocorax carbo",
        "germanName": "Kormoran"
    },
    "Phalacrocorax carbo novaehollandiae": {
        "latinName": "Phalacrocorax carbo novaehollandiae",
        "germanName": ""
    },
    "Phalacrocorax pelagicus": {
        "latinName": "Phalacrocorax pelagicus",
        "germanName": ""
    },
    "Phalacrocorax penicillatus": {
        "latinName": "Phalacrocorax penicillatus",
        "germanName": ""
    },
    "Phalacrocorax sulcirostris": {
        "latinName": "Phalacrocorax sulcirostris",
        "germanName": ""
    },
    "Phalacrocorax varius": {
        "latinName": "Phalacrocorax varius",
        "germanName": ""
    },
    "Phalacrocorax varius varius": {
        "latinName": "Phalacrocorax varius varius",
        "germanName": ""
    },
    "Phalaenoptilus nuttallii": {
        "latinName": "Phalaenoptilus nuttallii",
        "germanName": ""
    },
    "Phalaropus fulicarius": {
        "latinName": "Phalaropus fulicarius",
        "germanName": "Thorshuehnchen"
    },
    "Phalaropus lobatus": {
        "latinName": "Phalaropus lobatus",
        "germanName": "Odinshuehnchen"
    },
    "Phalaropus tricolor": {
        "latinName": "Phalaropus tricolor",
        "germanName": "Wilsonwassertreter"
    },
    "Pharomachrus mocinno": {
        "latinName": "Pharomachrus mocinno",
        "germanName": ""
    },
    "Phasianus colchicus": {
        "latinName": "Phasianus colchicus",
        "germanName": "Jagdfasan"
    },
    "Pheucticus ludovicianus": {
        "latinName": "Pheucticus ludovicianus",
        "germanName": "Rosenbrust-Kernknacker"
    },
    "Pheucticus melanocephalus": {
        "latinName": "Pheucticus melanocephalus",
        "germanName": ""
    },
    "Philesturnus rufusater": {
        "latinName": "Philesturnus rufusater",
        "germanName": ""
    },
    "Phoebastria immutabilis": {
        "latinName": "Phoebastria immutabilis",
        "germanName": ""
    },
    "Phoebastria nigripes": {
        "latinName": "Phoebastria nigripes",
        "germanName": ""
    },
    "Phoeniconaias minor": {
        "latinName": "Phoeniconaias minor",
        "germanName": "Zwergflamingo"
    },
    "Phoenicopterus chilensis": {
        "latinName": "Phoenicopterus chilensis",
        "germanName": "Chileflamingo"
    },
    "Phoenicopterus roseus": {
        "latinName": "Phoenicopterus roseus",
        "germanName": "Rosaflamingo"
    },
    "Phoenicopterus ruber": {
        "latinName": "Phoenicopterus ruber",
        "germanName": "Kubaflamingo"
    },
    "Phoenicurus ochruros": {
        "latinName": "Phoenicurus ochruros",
        "germanName": "Hausrotschwanz"
    },
    "Phoenicurus phoenicurus": {
        "latinName": "Phoenicurus phoenicurus",
        "germanName": "Gartenrotschwanz"
    },
    "Phylloscopus bonelli": {
        "latinName": "Phylloscopus bonelli",
        "germanName": "Berglaubsaenger"
    },
    "Phylloscopus borealis": {
        "latinName": "Phylloscopus borealis",
        "germanName": "Wanderlaubsaenger"
    },
    "Phylloscopus collybita": {
        "latinName": "Phylloscopus collybita",
        "germanName": "Zilpzalp"
    },
    "Phylloscopus coronatus": {
        "latinName": "Phylloscopus coronatus",
        "germanName": "Kronenlaubsaenger"
    },
    "Phylloscopus fuscatus": {
        "latinName": "Phylloscopus fuscatus",
        "germanName": "Dunkellaubsaenger"
    },
    "Phylloscopus humei": {
        "latinName": "Phylloscopus humei",
        "germanName": "Tienschan-Laubsaenger"
    },
    "Phylloscopus ibericus": {
        "latinName": "Phylloscopus ibericus",
        "germanName": "Iberienzilpzalp"
    },
    "Phylloscopus inornatus": {
        "latinName": "Phylloscopus inornatus",
        "germanName": "Gelbbrauen-Laubsaenger"
    },
    "Phylloscopus nitidus": {
        "latinName": "Phylloscopus nitidus",
        "germanName": "Wacholderlaubsaenger"
    },
    "Phylloscopus plumbeitarsus": {
        "latinName": "Phylloscopus plumbeitarsus",
        "germanName": "Middendorff-Laubsaenger"
    },
    "Phylloscopus proregulus": {
        "latinName": "Phylloscopus proregulus",
        "germanName": "Goldhaehnchen-Laubsaenger"
    },
    "Phylloscopus schwarzi": {
        "latinName": "Phylloscopus schwarzi",
        "germanName": "Bartlaubsaenger"
    },
    "Phylloscopus sibilatrix": {
        "latinName": "Phylloscopus sibilatrix",
        "germanName": "Waldlaubsaenger"
    },
    "Phylloscopus trochiloides": {
        "latinName": "Phylloscopus trochiloides",
        "germanName": "Gruenlaubsaenger"
    },
    "Phylloscopus trochilus": {
        "latinName": "Phylloscopus trochilus",
        "germanName": "Fitis"
    },
    "Piaya cayana": {
        "latinName": "Piaya cayana",
        "germanName": ""
    },
    "Pica hudsonia": {
        "latinName": "Pica hudsonia",
        "germanName": ""
    },
    "Pica nuttalli": {
        "latinName": "Pica nuttalli",
        "germanName": ""
    },
    "Pica pica": {
        "latinName": "Pica pica",
        "germanName": "Elster"
    },
    "Picoides albolarvatus": {
        "latinName": "Picoides albolarvatus",
        "germanName": ""
    },
    "Picoides arcticus": {
        "latinName": "Picoides arcticus",
        "germanName": ""
    },
    "Picoides dorsalis": {
        "latinName": "Picoides dorsalis",
        "germanName": ""
    },
    "Picoides nuttallii": {
        "latinName": "Picoides nuttallii",
        "germanName": ""
    },
    "Picoides pubescens": {
        "latinName": "Picoides pubescens",
        "germanName": ""
    },
    "Picoides scalaris": {
        "latinName": "Picoides scalaris",
        "germanName": ""
    },
    "Picoides tridactylus": {
        "latinName": "Picoides tridactylus",
        "germanName": "Dreizehenspecht"
    },
    "Picoides villosus": {
        "latinName": "Picoides villosus",
        "germanName": ""
    },
    "Picus canus": {
        "latinName": "Picus canus",
        "germanName": "Grauspecht"
    },
    "Picus viridis": {
        "latinName": "Picus viridis",
        "germanName": "Gruenspecht"
    },
    "Pinicola enucleator": {
        "latinName": "Pinicola enucleator",
        "germanName": "Hakengimpel"
    },
    "Pipilo chlorurus": {
        "latinName": "Pipilo chlorurus",
        "germanName": ""
    },
    "Pipilo erythrophthalmus": {
        "latinName": "Pipilo erythrophthalmus",
        "germanName": ""
    },
    "Pipilo maculatus": {
        "latinName": "Pipilo maculatus",
        "germanName": ""
    },
    "Piranga bidentata": {
        "latinName": "Piranga bidentata",
        "germanName": ""
    },
    "Piranga flava": {
        "latinName": "Piranga flava",
        "germanName": ""
    },
    "Piranga ludoviciana": {
        "latinName": "Piranga ludoviciana",
        "germanName": ""
    },
    "Piranga olivacea": {
        "latinName": "Piranga olivacea",
        "germanName": ""
    },
    "Piranga rubra": {
        "latinName": "Piranga rubra",
        "germanName": ""
    },
    "Pitangus sulphuratus": {
        "latinName": "Pitangus sulphuratus",
        "germanName": ""
    },
    "Platalea ajaja": {
        "latinName": "Platalea ajaja",
        "germanName": ""
    },
    "Platalea alba": {
        "latinName": "Platalea alba",
        "germanName": "Rotgesichtloeffler"
    },
    "Platalea leucorodia": {
        "latinName": "Platalea leucorodia",
        "germanName": "Loeffler"
    },
    "Platalea regia": {
        "latinName": "Platalea regia",
        "germanName": ""
    },
    "Platycercus elegans": {
        "latinName": "Platycercus elegans",
        "germanName": ""
    },
    "Platycercus eximius": {
        "latinName": "Platycercus eximius",
        "germanName": ""
    },
    "Plectrophenax nivalis": {
        "latinName": "Plectrophenax nivalis",
        "germanName": "Schneeammer"
    },
    "Plegadis chihi": {
        "latinName": "Plegadis chihi",
        "germanName": ""
    },
    "Plegadis falcinellus": {
        "latinName": "Plegadis falcinellus",
        "germanName": "Sichler"
    },
    "Pluvialis apricaria": {
        "latinName": "Pluvialis apricaria",
        "germanName": "Goldregenpfeifer"
    },
    "Pluvialis dominica": {
        "latinName": "Pluvialis dominica",
        "germanName": "Praerie-Goldregenpfeifer"
    },
    "Pluvialis fulva": {
        "latinName": "Pluvialis fulva",
        "germanName": "Tundra-Goldregenpfeifer"
    },
    "Pluvialis squatarola": {
        "latinName": "Pluvialis squatarola",
        "germanName": "Kiebitzregenpfeifer"
    },
    "Podiceps auritus": {
        "latinName": "Podiceps auritus",
        "germanName": "Ohrentaucher"
    },
    "Podiceps cristatus": {
        "latinName": "Podiceps cristatus",
        "germanName": "Haubentaucher"
    },
    "Podiceps grisegena": {
        "latinName": "Podiceps grisegena",
        "germanName": "Rothalstaucher"
    },
    "Podiceps nigricollis": {
        "latinName": "Podiceps nigricollis",
        "germanName": "Schwarzhalstaucher"
    },
    "Podilymbus podiceps": {
        "latinName": "Podilymbus podiceps",
        "germanName": "Bindentaucher"
    },
    "Poecile atricapillus": {
        "latinName": "Poecile atricapillus",
        "germanName": ""
    },
    "Poecile carolinensis": {
        "latinName": "Poecile carolinensis",
        "germanName": ""
    },
    "Poecile gambeli": {
        "latinName": "Poecile gambeli",
        "germanName": ""
    },
    "Poecile montanus": {
        "latinName": "Poecile montanus",
        "germanName": "Weidenmeise"
    },
    "Poecile palustris": {
        "latinName": "Poecile palustris",
        "germanName": "Sumpfmeise"
    },
    "Poecile rufescens": {
        "latinName": "Poecile rufescens",
        "germanName": ""
    },
    "Polioptila caerulea": {
        "latinName": "Polioptila caerulea",
        "germanName": ""
    },
    "Polioptila melanura": {
        "latinName": "Polioptila melanura",
        "germanName": ""
    },
    "Polysticta stelleri": {
        "latinName": "Polysticta stelleri",
        "germanName": "Scheckente"
    },
    "Pooecetes gramineus": {
        "latinName": "Pooecetes gramineus",
        "germanName": ""
    },
    "Porphyrio alleni": {
        "latinName": "Porphyrio alleni",
        "germanName": "Bronzesultanshuhn"
    },
    "Porphyrio hochstetteri": {
        "latinName": "Porphyrio hochstetteri",
        "germanName": ""
    },
    "Porphyrio martinicus": {
        "latinName": "Porphyrio martinicus",
        "germanName": ""
    },
    "Porphyrio melanotus": {
        "latinName": "Porphyrio melanotus",
        "germanName": ""
    },
    "Porphyrio melanotus melanotus": {
        "latinName": "Porphyrio melanotus melanotus",
        "germanName": ""
    },
    "Porphyrio poliocephalus": {
        "latinName": "Porphyrio poliocephalus",
        "germanName": "Graukopf-Purpurhuhn"
    },
    "Porphyrio porphyrio": {
        "latinName": "Porphyrio porphyrio",
        "germanName": "Purpurhuhn"
    },
    "Porzana carolina": {
        "latinName": "Porzana carolina",
        "germanName": ""
    },
    "Porzana porzana": {
        "latinName": "Porzana porzana",
        "germanName": "Tuepfelsumpfhuhn"
    },
    "Progne subis": {
        "latinName": "Progne subis",
        "germanName": ""
    },
    "Prosthemadera novaeseelandiae": {
        "latinName": "Prosthemadera novaeseelandiae",
        "germanName": ""
    },
    "Prosthemadera novaeseelandiae novaeseelandiae": {
        "latinName": "Prosthemadera novaeseelandiae novaeseelandiae",
        "germanName": ""
    },
    "Protonotaria citrea": {
        "latinName": "Protonotaria citrea",
        "germanName": ""
    },
    "Prunella atrogularis": {
        "latinName": "Prunella atrogularis",
        "germanName": "Schwarzkehlbraunelle"
    },
    "Prunella collaris": {
        "latinName": "Prunella collaris",
        "germanName": "Alpenbraunelle"
    },
    "Prunella modularis": {
        "latinName": "Prunella modularis",
        "germanName": "Heckenbraunelle"
    },
    "Prunella montanella": {
        "latinName": "Prunella montanella",
        "germanName": "Bergbraunelle"
    },
    "Psaltriparus minimus": {
        "latinName": "Psaltriparus minimus",
        "germanName": ""
    },
    "Psarocolius montezuma": {
        "latinName": "Psarocolius montezuma",
        "germanName": ""
    },
    "Psilorhinus morio": {
        "latinName": "Psilorhinus morio",
        "germanName": ""
    },
    "Psittacara erythrogenys": {
        "latinName": "Psittacara erythrogenys",
        "germanName": ""
    },
    "Psittacara holochlorus": {
        "latinName": "Psittacara holochlorus",
        "germanName": ""
    },
    "Psittacula eupatria": {
        "latinName": "Psittacula eupatria",
        "germanName": "Alexandersittich"
    },
    "Psittacula krameri": {
        "latinName": "Psittacula krameri",
        "germanName": "Halsbandsittich"
    },
    "Pterocles alchata": {
        "latinName": "Pterocles alchata",
        "germanName": "Spiessflughuhn"
    },
    "Pterocles orientalis": {
        "latinName": "Pterocles orientalis",
        "germanName": "Sandflughuhn"
    },
    "Pteroglossus torquatus": {
        "latinName": "Pteroglossus torquatus",
        "germanName": ""
    },
    "Ptiliogonys cinereus": {
        "latinName": "Ptiliogonys cinereus",
        "germanName": ""
    },
    "Ptyonoprogne rupestris": {
        "latinName": "Ptyonoprogne rupestris",
        "germanName": "Felsenschwalbe"
    },
    "Puffinus baroli": {
        "latinName": "Puffinus baroli",
        "germanName": "Barolosturmtaucher"
    },
    "Puffinus mauretanicus": {
        "latinName": "Puffinus mauretanicus",
        "germanName": "Balearensturmtaucher"
    },
    "Puffinus puffinus": {
        "latinName": "Puffinus puffinus",
        "germanName": "Atlantiksturmtaucher"
    },
    "Pycnonotus barbatus": {
        "latinName": "Pycnonotus barbatus",
        "germanName": ""
    },
    "Pycnonotus cafer": {
        "latinName": "Pycnonotus cafer",
        "germanName": ""
    },
    "Pycnonotus jocosus": {
        "latinName": "Pycnonotus jocosus",
        "germanName": ""
    },
    "Pyrocephalus rubinus": {
        "latinName": "Pyrocephalus rubinus",
        "germanName": ""
    },
    "Pyrrhocorax graculus": {
        "latinName": "Pyrrhocorax graculus",
        "germanName": "Alpendohle"
    },
    "Pyrrhocorax pyrrhocorax": {
        "latinName": "Pyrrhocorax pyrrhocorax",
        "germanName": "Alpenkraehe"
    },
    "Pyrrhula pyrrhula": {
        "latinName": "Pyrrhula pyrrhula",
        "germanName": "Gimpel"
    },
    "Quiscalus major": {
        "latinName": "Quiscalus major",
        "germanName": ""
    },
    "Quiscalus mexicanus": {
        "latinName": "Quiscalus mexicanus",
        "germanName": ""
    },
    "Quiscalus niger": {
        "latinName": "Quiscalus niger",
        "germanName": ""
    },
    "Quiscalus quiscula": {
        "latinName": "Quiscalus quiscula",
        "germanName": ""
    },
    "Rallus aquaticus": {
        "latinName": "Rallus aquaticus",
        "germanName": "Wasserralle"
    },
    "Rallus crepitans": {
        "latinName": "Rallus crepitans",
        "germanName": ""
    },
    "Rallus limicola": {
        "latinName": "Rallus limicola",
        "germanName": ""
    },
    "Rallus obsoletus": {
        "latinName": "Rallus obsoletus",
        "germanName": ""
    },
    "Ramphastos ambiguus": {
        "latinName": "Ramphastos ambiguus",
        "germanName": ""
    },
    "Ramphastos sulfuratus": {
        "latinName": "Ramphastos sulfuratus",
        "germanName": ""
    },
    "Ramphocelus passerinii": {
        "latinName": "Ramphocelus passerinii",
        "germanName": ""
    },
    "Recurvirostra americana": {
        "latinName": "Recurvirostra americana",
        "germanName": ""
    },
    "Recurvirostra avosetta": {
        "latinName": "Recurvirostra avosetta",
        "germanName": "Saebelschnaebler"
    },
    "Regulus calendula": {
        "latinName": "Regulus calendula",
        "germanName": ""
    },
    "Regulus ignicapilla": {
        "latinName": "Regulus ignicapilla",
        "germanName": "Sommergoldhaehnchen"
    },
    "Regulus regulus": {
        "latinName": "Regulus regulus",
        "germanName": "Wintergoldhaehnchen"
    },
    "Regulus satrapa": {
        "latinName": "Regulus satrapa",
        "germanName": ""
    },
    "Remiz pendulinus": {
        "latinName": "Remiz pendulinus",
        "germanName": "Beutelmeise"
    },
    "Rhea americana": {
        "latinName": "Rhea americana",
        "germanName": "Nandu"
    },
    "Rhipidura fuliginosa": {
        "latinName": "Rhipidura fuliginosa",
        "germanName": ""
    },
    "Rhipidura fuliginosa fuliginosa": {
        "latinName": "Rhipidura fuliginosa fuliginosa",
        "germanName": ""
    },
    "Rhipidura fuliginosa placabilis": {
        "latinName": "Rhipidura fuliginosa placabilis",
        "germanName": ""
    },
    "Rhipidura leucophrys": {
        "latinName": "Rhipidura leucophrys",
        "germanName": ""
    },
    "Rhodostethia rosea": {
        "latinName": "Rhodostethia rosea",
        "germanName": "Rosenmoewe"
    },
    "Riparia riparia": {
        "latinName": "Riparia riparia",
        "germanName": "Uferschwalbe"
    },
    "Rissa tridactyla": {
        "latinName": "Rissa tridactyla",
        "germanName": "Dreizehenmoewe"
    },
    "Rostrhamus sociabilis": {
        "latinName": "Rostrhamus sociabilis",
        "germanName": ""
    },
    "Rupornis magnirostris": {
        "latinName": "Rupornis magnirostris",
        "germanName": ""
    },
    "Rynchops niger": {
        "latinName": "Rynchops niger",
        "germanName": ""
    },
    "Sagittarius serpentarius": {
        "latinName": "Sagittarius serpentarius",
        "germanName": ""
    },
    "Salpinctes obsoletus": {
        "latinName": "Salpinctes obsoletus",
        "germanName": ""
    },
    "Saltator atriceps": {
        "latinName": "Saltator atriceps",
        "germanName": ""
    },
    "Saltator coerulescens": {
        "latinName": "Saltator coerulescens",
        "germanName": ""
    },
    "Sarcoramphus papa": {
        "latinName": "Sarcoramphus papa",
        "germanName": ""
    },
    "Saxicola maurus": {
        "latinName": "Saxicola maurus",
        "germanName": "Pallasschwarzkehlchen"
    },
    "Saxicola rubetra": {
        "latinName": "Saxicola rubetra",
        "germanName": "Braunkehlchen"
    },
    "Saxicola rubicola": {
        "latinName": "Saxicola rubicola",
        "germanName": "Schwarzkehlchen"
    },
    "Sayornis nigricans": {
        "latinName": "Sayornis nigricans",
        "germanName": ""
    },
    "Sayornis phoebe": {
        "latinName": "Sayornis phoebe",
        "germanName": ""
    },
    "Sayornis saya": {
        "latinName": "Sayornis saya",
        "germanName": ""
    },
    "Sciurus vulgaris": {
        "latinName": "Sciurus vulgaris",
        "germanName": "Eurasisches Eichhoernchen"
    },
    "Scolopax minor": {
        "latinName": "Scolopax minor",
        "germanName": ""
    },
    "Scolopax rusticola": {
        "latinName": "Scolopax rusticola",
        "germanName": "Waldschnepfe"
    },
    "Scopus umbretta": {
        "latinName": "Scopus umbretta",
        "germanName": ""
    },
    "Seiurus aurocapilla": {
        "latinName": "Seiurus aurocapilla",
        "germanName": ""
    },
    "Selasphorus calliope": {
        "latinName": "Selasphorus calliope",
        "germanName": ""
    },
    "Selasphorus platycercus": {
        "latinName": "Selasphorus platycercus",
        "germanName": ""
    },
    "Selasphorus rufus": {
        "latinName": "Selasphorus rufus",
        "germanName": ""
    },
    "Selasphorus sasin": {
        "latinName": "Selasphorus sasin",
        "germanName": ""
    },
    "Serinus mozambicus": {
        "latinName": "Serinus mozambicus",
        "germanName": ""
    },
    "Serinus serinus": {
        "latinName": "Serinus serinus",
        "germanName": "Girlitz"
    },
    "Setophaga americana": {
        "latinName": "Setophaga americana",
        "germanName": "Meisenwaldsaenger"
    },
    "Setophaga caerulescens": {
        "latinName": "Setophaga caerulescens",
        "germanName": ""
    },
    "Setophaga castanea": {
        "latinName": "Setophaga castanea",
        "germanName": ""
    },
    "Setophaga cerulea": {
        "latinName": "Setophaga cerulea",
        "germanName": ""
    },
    "Setophaga chrysoparia": {
        "latinName": "Setophaga chrysoparia",
        "germanName": ""
    },
    "Setophaga citrina": {
        "latinName": "Setophaga citrina",
        "germanName": ""
    },
    "Setophaga coronata": {
        "latinName": "Setophaga coronata",
        "germanName": ""
    },
    "Setophaga coronata auduboni": {
        "latinName": "Setophaga coronata auduboni",
        "germanName": ""
    },
    "Setophaga coronata coronata": {
        "latinName": "Setophaga coronata coronata",
        "germanName": ""
    },
    "Setophaga discolor": {
        "latinName": "Setophaga discolor",
        "germanName": ""
    },
    "Setophaga dominica": {
        "latinName": "Setophaga dominica",
        "germanName": ""
    },
    "Setophaga fusca": {
        "latinName": "Setophaga fusca",
        "germanName": ""
    },
    "Setophaga magnolia": {
        "latinName": "Setophaga magnolia",
        "germanName": ""
    },
    "Setophaga nigrescens": {
        "latinName": "Setophaga nigrescens",
        "germanName": ""
    },
    "Setophaga occidentalis": {
        "latinName": "Setophaga occidentalis",
        "germanName": ""
    },
    "Setophaga palmarum": {
        "latinName": "Setophaga palmarum",
        "germanName": ""
    },
    "Setophaga pensylvanica": {
        "latinName": "Setophaga pensylvanica",
        "germanName": ""
    },
    "Setophaga petechia": {
        "latinName": "Setophaga petechia",
        "germanName": ""
    },
    "Setophaga pinus": {
        "latinName": "Setophaga pinus",
        "germanName": ""
    },
    "Setophaga ruticilla": {
        "latinName": "Setophaga ruticilla",
        "germanName": ""
    },
    "Setophaga striata": {
        "latinName": "Setophaga striata",
        "germanName": ""
    },
    "Setophaga tigrina": {
        "latinName": "Setophaga tigrina",
        "germanName": ""
    },
    "Setophaga townsendi": {
        "latinName": "Setophaga townsendi",
        "germanName": ""
    },
    "Setophaga virens": {
        "latinName": "Setophaga virens",
        "germanName": "Gruenmantel-Waldsaenger"
    },
    "Sialia currucoides": {
        "latinName": "Sialia currucoides",
        "germanName": ""
    },
    "Sialia mexicana": {
        "latinName": "Sialia mexicana",
        "germanName": ""
    },
    "Sialia sialis": {
        "latinName": "Sialia sialis",
        "germanName": ""
    },
    "Sibirionetta formosa": {
        "latinName": "Sibirionetta formosa",
        "germanName": "Gluckente"
    },
    "Sicalis flaveola": {
        "latinName": "Sicalis flaveola",
        "germanName": ""
    },
    "Sitta canadensis": {
        "latinName": "Sitta canadensis",
        "germanName": ""
    },
    "Sitta carolinensis": {
        "latinName": "Sitta carolinensis",
        "germanName": ""
    },
    "Sitta europaea": {
        "latinName": "Sitta europaea",
        "germanName": "Kleiber"
    },
    "Sitta pusilla": {
        "latinName": "Sitta pusilla",
        "germanName": ""
    },
    "Sitta pygmaea": {
        "latinName": "Sitta pygmaea",
        "germanName": ""
    },
    "Somateria mollissima": {
        "latinName": "Somateria mollissima",
        "germanName": "Eiderente"
    },
    "Somateria spectabilis": {
        "latinName": "Somateria spectabilis",
        "germanName": "Prachteiderente"
    },
    "Spatula clypeata": {
        "latinName": "Spatula clypeata",
        "germanName": "Loeffelente"
    },
    "Spatula discors": {
        "latinName": "Spatula discors",
        "germanName": "Blaufluegelente"
    },
    "Spatula querquedula": {
        "latinName": "Spatula querquedula",
        "germanName": "Knaekente"
    },
    "Spheniscus demersus": {
        "latinName": "Spheniscus demersus",
        "germanName": ""
    },
    "Sphyrapicus nuchalis": {
        "latinName": "Sphyrapicus nuchalis",
        "germanName": ""
    },
    "Sphyrapicus ruber": {
        "latinName": "Sphyrapicus ruber",
        "germanName": ""
    },
    "Sphyrapicus thyroideus": {
        "latinName": "Sphyrapicus thyroideus",
        "germanName": ""
    },
    "Sphyrapicus varius": {
        "latinName": "Sphyrapicus varius",
        "germanName": ""
    },
    "Spilopelia senegalensis": {
        "latinName": "Spilopelia senegalensis",
        "germanName": "Palmtaube"
    },
    "Spinus lawrencei": {
        "latinName": "Spinus lawrencei",
        "germanName": ""
    },
    "Spinus pinus": {
        "latinName": "Spinus pinus",
        "germanName": ""
    },
    "Spinus psaltria": {
        "latinName": "Spinus psaltria",
        "germanName": ""
    },
    "Spinus spinus": {
        "latinName": "Spinus spinus",
        "germanName": "Erlenzeisig"
    },
    "Spinus tristis": {
        "latinName": "Spinus tristis",
        "germanName": ""
    },
    "Spiza americana": {
        "latinName": "Spiza americana",
        "germanName": ""
    },
    "Spizella atrogularis": {
        "latinName": "Spizella atrogularis",
        "germanName": ""
    },
    "Spizella breweri": {
        "latinName": "Spizella breweri",
        "germanName": ""
    },
    "Spizella pallida": {
        "latinName": "Spizella pallida",
        "germanName": ""
    },
    "Spizella passerina": {
        "latinName": "Spizella passerina",
        "germanName": ""
    },
    "Spizella pusilla": {
        "latinName": "Spizella pusilla",
        "germanName": ""
    },
    "Spizelloides arborea": {
        "latinName": "Spizelloides arborea",
        "germanName": ""
    },
    "Sporophila torqueola": {
        "latinName": "Sporophila torqueola",
        "germanName": ""
    },
    "Stelgidopteryx serripennis": {
        "latinName": "Stelgidopteryx serripennis",
        "germanName": ""
    },
    "Stercorarius longicaudus": {
        "latinName": "Stercorarius longicaudus",
        "germanName": "Falkenraubmoewe"
    },
    "Stercorarius parasiticus": {
        "latinName": "Stercorarius parasiticus",
        "germanName": "Schmarotzerraubmoewe"
    },
    "Stercorarius pomarinus": {
        "latinName": "Stercorarius pomarinus",
        "germanName": "Spatelraubmoewe"
    },
    "Stercorarius skua": {
        "latinName": "Stercorarius skua",
        "germanName": "Skua"
    },
    "Sterna dougallii": {
        "latinName": "Sterna dougallii",
        "germanName": "Rosenseeschwalbe"
    },
    "Sterna forsteri": {
        "latinName": "Sterna forsteri",
        "germanName": ""
    },
    "Sterna hirundo": {
        "latinName": "Sterna hirundo",
        "germanName": "Flussseeschwalbe"
    },
    "Sterna paradisaea": {
        "latinName": "Sterna paradisaea",
        "germanName": "Kuestenseeschwalbe"
    },
    "Sterna striata": {
        "latinName": "Sterna striata",
        "germanName": ""
    },
    "Sternula albifrons": {
        "latinName": "Sternula albifrons",
        "germanName": "Zwergseeschwalbe"
    },
    "Sternula antillarum": {
        "latinName": "Sternula antillarum",
        "germanName": ""
    },
    "Streptopelia chinensis": {
        "latinName": "Streptopelia chinensis",
        "germanName": ""
    },
    "Streptopelia decaocto": {
        "latinName": "Streptopelia decaocto",
        "germanName": "Tuerkentaube"
    },
    "Streptopelia orientalis": {
        "latinName": "Streptopelia orientalis",
        "germanName": "Orientturteltaube"
    },
    "Streptopelia senegalensis": {
        "latinName": "Streptopelia senegalensis",
        "germanName": ""
    },
    "Streptopelia turtur": {
        "latinName": "Streptopelia turtur",
        "germanName": "Turteltaube"
    },
    "Strix aluco": {
        "latinName": "Strix aluco",
        "germanName": "Waldkauz"
    },
    "Strix nebulosa": {
        "latinName": "Strix nebulosa",
        "germanName": ""
    },
    "Strix uralensis": {
        "latinName": "Strix uralensis",
        "germanName": "Habichtskauz"
    },
    "Strix varia": {
        "latinName": "Strix varia",
        "germanName": ""
    },
    "Struthio camelus": {
        "latinName": "Struthio camelus",
        "germanName": ""
    },
    "Sturnella magna": {
        "latinName": "Sturnella magna",
        "germanName": ""
    },
    "Sturnella neglecta": {
        "latinName": "Sturnella neglecta",
        "germanName": ""
    },
    "Sturnus vulgaris": {
        "latinName": "Sturnus vulgaris",
        "germanName": "Star"
    },
    "Sula dactylatra": {
        "latinName": "Sula dactylatra",
        "germanName": ""
    },
    "Sula granti": {
        "latinName": "Sula granti",
        "germanName": ""
    },
    "Sula leucogaster": {
        "latinName": "Sula leucogaster",
        "germanName": "Weissbauchtoelpel"
    },
    "Sula nebouxii": {
        "latinName": "Sula nebouxii",
        "germanName": ""
    },
    "Sula sula": {
        "latinName": "Sula sula",
        "germanName": ""
    },
    "Surnia ulula": {
        "latinName": "Surnia ulula",
        "germanName": "Sperbereule"
    },
    "Sylvia atricapilla": {
        "latinName": "Sylvia atricapilla",
        "germanName": "Moenchsgrasmuecke"
    },
    "Sylvia borin": {
        "latinName": "Sylvia borin",
        "germanName": "Gartengrasmuecke"
    },
    "Sylvia cantillans": {
        "latinName": "Sylvia cantillans",
        "germanName": "Weissbart-Grasmuecke"
    },
    "Sylvia communis": {
        "latinName": "Sylvia communis",
        "germanName": "Dorngrasmuecke"
    },
    "Sylvia conspicillata": {
        "latinName": "Sylvia conspicillata",
        "germanName": "Brillengrasmuecke"
    },
    "Sylvia curruca": {
        "latinName": "Sylvia curruca",
        "germanName": "Klappergrasmuecke"
    },
    "Sylvia hortensis": {
        "latinName": "Sylvia hortensis",
        "germanName": "Orpheusgrasmuecke"
    },
    "Sylvia melanocephala": {
        "latinName": "Sylvia melanocephala",
        "germanName": "Samtkopf-Grasmuecke"
    },
    "Sylvia nana": {
        "latinName": "Sylvia nana",
        "germanName": "Wuestengrasmuecke"
    },
    "Sylvia nisoria": {
        "latinName": "Sylvia nisoria",
        "germanName": "Sperbergrasmuecke"
    },
    "Sylvia subalpina": {
        "latinName": "Sylvia subalpina",
        "germanName": "Ligurien-Bartgrasmuecke"
    },
    "Sylvia undata": {
        "latinName": "Sylvia undata",
        "germanName": "Provencegrasmuecke"
    },
    "Syrrhaptes paradoxus": {
        "latinName": "Syrrhaptes paradoxus",
        "germanName": "Steppenflughuhn"
    },
    "Tachybaptus dominicus": {
        "latinName": "Tachybaptus dominicus",
        "germanName": ""
    },
    "Tachybaptus ruficollis": {
        "latinName": "Tachybaptus ruficollis",
        "germanName": "Zwergtaucher"
    },
    "Tachycineta albilinea": {
        "latinName": "Tachycineta albilinea",
        "germanName": ""
    },
    "Tachycineta bicolor": {
        "latinName": "Tachycineta bicolor",
        "germanName": ""
    },
    "Tachycineta thalassina": {
        "latinName": "Tachycineta thalassina",
        "germanName": ""
    },
    "Tachymarptis melba": {
        "latinName": "Tachymarptis melba",
        "germanName": "Alpensegler"
    },
    "Tadorna ferruginea": {
        "latinName": "Tadorna ferruginea",
        "germanName": "Rostgans"
    },
    "Tadorna tadorna": {
        "latinName": "Tadorna tadorna",
        "germanName": "Brandgans"
    },
    "Tadorna variegata": {
        "latinName": "Tadorna variegata",
        "germanName": ""
    },
    "Tarsiger cyanurus": {
        "latinName": "Tarsiger cyanurus",
        "germanName": "Blauschwanz"
    },
    "Terathopius ecaudatus": {
        "latinName": "Terathopius ecaudatus",
        "germanName": ""
    },
    "Tetrao urogallus": {
        "latinName": "Tetrao urogallus",
        "germanName": "Auerhuhn"
    },
    "Tetrastes bonasia": {
        "latinName": "Tetrastes bonasia",
        "germanName": "Haselhuhn"
    },
    "Tetrax tetrax": {
        "latinName": "Tetrax tetrax",
        "germanName": "Zwergtrappe"
    },
    "Thalassarche melanophris": {
        "latinName": "Thalassarche melanophris",
        "germanName": "Schwarzbrauenalbatros"
    },
    "Thalasseus bengalensis": {
        "latinName": "Thalasseus bengalensis",
        "germanName": "Rueppellseeschwalbe"
    },
    "Thalasseus bergii": {
        "latinName": "Thalasseus bergii",
        "germanName": ""
    },
    "Thalasseus elegans": {
        "latinName": "Thalasseus elegans",
        "germanName": "Schmuckseeschwalbe"
    },
    "Thalasseus maximus": {
        "latinName": "Thalasseus maximus",
        "germanName": ""
    },
    "Thalasseus sandvicensis": {
        "latinName": "Thalasseus sandvicensis",
        "germanName": "Brandseeschwalbe"
    },
    "Thamnophilus doliatus": {
        "latinName": "Thamnophilus doliatus",
        "germanName": ""
    },
    "Thraupis abbas": {
        "latinName": "Thraupis abbas",
        "germanName": ""
    },
    "Thraupis episcopus": {
        "latinName": "Thraupis episcopus",
        "germanName": ""
    },
    "Thraupis palmarum": {
        "latinName": "Thraupis palmarum",
        "germanName": ""
    },
    "Threskiornis aethiopicus": {
        "latinName": "Threskiornis aethiopicus",
        "germanName": "Pharaonenibis"
    },
    "Threskiornis moluccus": {
        "latinName": "Threskiornis moluccus",
        "germanName": ""
    },
    "Thryomanes bewickii": {
        "latinName": "Thryomanes bewickii",
        "germanName": ""
    },
    "Thryothorus ludovicianus": {
        "latinName": "Thryothorus ludovicianus",
        "germanName": ""
    },
    "Tiaris olivaceus": {
        "latinName": "Tiaris olivaceus",
        "germanName": ""
    },
    "Tichodroma muraria": {
        "latinName": "Tichodroma muraria",
        "germanName": "Mauerlaeufer"
    },
    "Tigrisoma mexicanum": {
        "latinName": "Tigrisoma mexicanum",
        "germanName": ""
    },
    "Tityra semifasciata": {
        "latinName": "Tityra semifasciata",
        "germanName": ""
    },
    "Todiramphus chloris": {
        "latinName": "Todiramphus chloris",
        "germanName": ""
    },
    "Todiramphus sanctus": {
        "latinName": "Todiramphus sanctus",
        "germanName": ""
    },
    "Todiramphus sanctus vagans": {
        "latinName": "Todiramphus sanctus vagans",
        "germanName": ""
    },
    "Toxostoma curvirostre": {
        "latinName": "Toxostoma curvirostre",
        "germanName": ""
    },
    "Toxostoma longirostre": {
        "latinName": "Toxostoma longirostre",
        "germanName": ""
    },
    "Toxostoma redivivum": {
        "latinName": "Toxostoma redivivum",
        "germanName": ""
    },
    "Toxostoma rufum": {
        "latinName": "Toxostoma rufum",
        "germanName": ""
    },
    "Trichoglossus haematodus": {
        "latinName": "Trichoglossus haematodus",
        "germanName": ""
    },
    "Tringa erythropus": {
        "latinName": "Tringa erythropus",
        "germanName": "Dunkelwasserlaeufer"
    },
    "Tringa flavipes": {
        "latinName": "Tringa flavipes",
        "germanName": "Gelbschenkel"
    },
    "Tringa glareola": {
        "latinName": "Tringa glareola",
        "germanName": "Bruchwasserlaeufer"
    },
    "Tringa incana": {
        "latinName": "Tringa incana",
        "germanName": ""
    },
    "Tringa melanoleuca": {
        "latinName": "Tringa melanoleuca",
        "germanName": ""
    },
    "Tringa nebularia": {
        "latinName": "Tringa nebularia",
        "germanName": "Gruenschenkel"
    },
    "Tringa ochropus": {
        "latinName": "Tringa ochropus",
        "germanName": "Waldwasserlaeufer"
    },
    "Tringa semipalmata": {
        "latinName": "Tringa semipalmata",
        "germanName": ""
    },
    "Tringa semipalmata inornatus": {
        "latinName": "Tringa semipalmata inornatus",
        "germanName": ""
    },
    "Tringa solitaria": {
        "latinName": "Tringa solitaria",
        "germanName": ""
    },
    "Tringa stagnatilis": {
        "latinName": "Tringa stagnatilis",
        "germanName": "Teichwasserlaeufer"
    },
    "Tringa totanus": {
        "latinName": "Tringa totanus",
        "germanName": "Rotschenkel"
    },
    "Troglodytes aedon": {
        "latinName": "Troglodytes aedon",
        "germanName": ""
    },
    "Troglodytes hiemalis": {
        "latinName": "Troglodytes hiemalis",
        "germanName": ""
    },
    "Troglodytes pacificus": {
        "latinName": "Troglodytes pacificus",
        "germanName": ""
    },
    "Troglodytes troglodytes": {
        "latinName": "Troglodytes troglodytes",
        "germanName": "Zaunkoenig"
    },
    "Trogon caligatus": {
        "latinName": "Trogon caligatus",
        "germanName": ""
    },
    "Trogon citreolus": {
        "latinName": "Trogon citreolus",
        "germanName": ""
    },
    "Trogon collaris": {
        "latinName": "Trogon collaris",
        "germanName": ""
    },
    "Trogon elegans": {
        "latinName": "Trogon elegans",
        "germanName": ""
    },
    "Trogon massena": {
        "latinName": "Trogon massena",
        "germanName": ""
    },
    "Trogon melanocephalus": {
        "latinName": "Trogon melanocephalus",
        "germanName": ""
    },
    "Turdus atrogularis": {
        "latinName": "Turdus atrogularis",
        "germanName": "Schwarzkehldrossel"
    },
    "Turdus eunomus": {
        "latinName": "Turdus eunomus",
        "germanName": "Rostfluegeldrossel"
    },
    "Turdus grayi": {
        "latinName": "Turdus grayi",
        "germanName": ""
    },
    "Turdus hortulorum": {
        "latinName": "Turdus hortulorum",
        "germanName": "Amurdrossel"
    },
    "Turdus iliacus": {
        "latinName": "Turdus iliacus",
        "germanName": "Rotdrossel"
    },
    "Turdus merula": {
        "latinName": "Turdus merula",
        "germanName": "Amsel"
    },
    "Turdus migratorius": {
        "latinName": "Turdus migratorius",
        "germanName": "Wanderdrossel"
    },
    "Turdus naumanni": {
        "latinName": "Turdus naumanni",
        "germanName": "Rostschwanzdrossel"
    },
    "Turdus obscurus": {
        "latinName": "Turdus obscurus",
        "germanName": "Weissbrauendrossel"
    },
    "Turdus pallidus": {
        "latinName": "Turdus pallidus",
        "germanName": "Fahldrossel"
    },
    "Turdus philomelos": {
        "latinName": "Turdus philomelos",
        "germanName": "Singdrossel"
    },
    "Turdus pilaris": {
        "latinName": "Turdus pilaris",
        "germanName": "Wacholderdrossel"
    },
    "Turdus plumbeus": {
        "latinName": "Turdus plumbeus",
        "germanName": ""
    },
    "Turdus ruficollis": {
        "latinName": "Turdus ruficollis",
        "germanName": "Rotkehldrossel"
    },
    "Turdus rufopalliatus": {
        "latinName": "Turdus rufopalliatus",
        "germanName": ""
    },
    "Turdus torquatus": {
        "latinName": "Turdus torquatus",
        "germanName": "Ringdrossel"
    },
    "Turdus unicolor": {
        "latinName": "Turdus unicolor",
        "germanName": "Einfarbdrossel"
    },
    "Turdus viscivorus": {
        "latinName": "Turdus viscivorus",
        "germanName": "Misteldrossel"
    },
    "Tyrannus couchii": {
        "latinName": "Tyrannus couchii",
        "germanName": ""
    },
    "Tyrannus crassirostris": {
        "latinName": "Tyrannus crassirostris",
        "germanName": ""
    },
    "Tyrannus dominicensis": {
        "latinName": "Tyrannus dominicensis",
        "germanName": ""
    },
    "Tyrannus forficatus": {
        "latinName": "Tyrannus forficatus",
        "germanName": ""
    },
    "Tyrannus melancholicus": {
        "latinName": "Tyrannus melancholicus",
        "germanName": ""
    },
    "Tyrannus savana": {
        "latinName": "Tyrannus savana",
        "germanName": ""
    },
    "Tyrannus tyrannus": {
        "latinName": "Tyrannus tyrannus",
        "germanName": ""
    },
    "Tyrannus verticalis": {
        "latinName": "Tyrannus verticalis",
        "germanName": ""
    },
    "Tyrannus vociferans": {
        "latinName": "Tyrannus vociferans",
        "germanName": ""
    },
    "Tyto alba": {
        "latinName": "Tyto alba",
        "germanName": "Schleiereule"
    },
    "Upupa epops": {
        "latinName": "Upupa epops",
        "germanName": "Wiedehopf"
    },
    "Uria aalge": {
        "latinName": "Uria aalge",
        "germanName": "Trottellumme"
    },
    "Uria lomvia": {
        "latinName": "Uria lomvia",
        "germanName": "Dickschnabellumme"
    },
    "Vanellus armatus": {
        "latinName": "Vanellus armatus",
        "germanName": ""
    },
    "Vanellus chilensis": {
        "latinName": "Vanellus chilensis",
        "germanName": ""
    },
    "Vanellus gregarius": {
        "latinName": "Vanellus gregarius",
        "germanName": "Steppenkiebitz"
    },
    "Vanellus leucurus": {
        "latinName": "Vanellus leucurus",
        "germanName": "Weissschwanzkiebitz"
    },
    "Vanellus miles": {
        "latinName": "Vanellus miles",
        "germanName": ""
    },
    "Vanellus spinosus": {
        "latinName": "Vanellus spinosus",
        "germanName": "Spornkiebitz"
    },
    "Vanellus vanellus": {
        "latinName": "Vanellus vanellus",
        "germanName": "Kiebitz"
    },
    "Vermivora chrysoptera": {
        "latinName": "Vermivora chrysoptera",
        "germanName": ""
    },
    "Vermivora cyanoptera": {
        "latinName": "Vermivora cyanoptera",
        "germanName": ""
    },
    "Vireo bellii": {
        "latinName": "Vireo bellii",
        "germanName": ""
    },
    "Vireo cassinii": {
        "latinName": "Vireo cassinii",
        "germanName": ""
    },
    "Vireo flavifrons": {
        "latinName": "Vireo flavifrons",
        "germanName": "Gelbkehlvireo"
    },
    "Vireo gilvus": {
        "latinName": "Vireo gilvus",
        "germanName": ""
    },
    "Vireo griseus": {
        "latinName": "Vireo griseus",
        "germanName": ""
    },
    "Vireo huttoni": {
        "latinName": "Vireo huttoni",
        "germanName": ""
    },
    "Vireo olivaceus": {
        "latinName": "Vireo olivaceus",
        "germanName": "Rotaugenvireo"
    },
    "Vireo philadelphicus": {
        "latinName": "Vireo philadelphicus",
        "germanName": ""
    },
    "Vireo plumbeus": {
        "latinName": "Vireo plumbeus",
        "germanName": ""
    },
    "Vireo solitarius": {
        "latinName": "Vireo solitarius",
        "germanName": ""
    },
    "Volatinia jacarina": {
        "latinName": "Volatinia jacarina",
        "germanName": ""
    },
    "Xanthocephalus xanthocephalus": {
        "latinName": "Xanthocephalus xanthocephalus",
        "germanName": ""
    },
    "Xema sabini": {
        "latinName": "Xema sabini",
        "germanName": "Schwalbenmoewe"
    },
    "Xenus cinereus": {
        "latinName": "Xenus cinereus",
        "germanName": "Terekwasserlaeufer"
    },
    "Xiphorhynchus flavigaster": {
        "latinName": "Xiphorhynchus flavigaster",
        "germanName": ""
    },
    "Zapornia parva": {
        "latinName": "Zapornia parva",
        "germanName": "Kleinsumpfhuhn"
    },
    "Zapornia pusilla": {
        "latinName": "Zapornia pusilla",
        "germanName": "Zwergsumpfhuhn"
    },
    "Zenaida asiatica": {
        "latinName": "Zenaida asiatica",
        "germanName": ""
    },
    "Zenaida auriculata": {
        "latinName": "Zenaida auriculata",
        "germanName": ""
    },
    "Zenaida aurita": {
        "latinName": "Zenaida aurita",
        "germanName": ""
    },
    "Zenaida macroura": {
        "latinName": "Zenaida macroura",
        "germanName": "Carolinataube"
    },
    "Zonotrichia albicollis": {
        "latinName": "Zonotrichia albicollis",
        "germanName": "Weisskehlammer"
    },
    "Zonotrichia atricapilla": {
        "latinName": "Zonotrichia atricapilla",
        "germanName": ""
    },
    "Zonotrichia capensis": {
        "latinName": "Zonotrichia capensis",
        "germanName": ""
    },
    "Zonotrichia leucophrys": {
        "latinName": "Zonotrichia leucophrys",
        "germanName": "Dachsammer"
    },
    "Zonotrichia querula": {
        "latinName": "Zonotrichia querula",
        "germanName": ""
    },
    "Zoothera aurea": {
        "latinName": "Zoothera aurea",
        "germanName": "Erddrossel"
    },
    "Zosterops japonicus": {
        "latinName": "Zosterops japonicus",
        "germanName": ""
    },
    "Zosterops lateralis": {
        "latinName": "Zosterops lateralis",
        "germanName": ""
    },
    "Zosterops lateralis lateralis": {
        "latinName": "Zosterops lateralis lateralis",
        "germanName": ""
    }

}

module.exports = {
    saerchOptions : saerchOptions,
    validationOptions : validationOptions,
    
};